export default {
  hkMarket: {
    deskSubtitle: '直販決済カタログ＋オンボード＋模擬入金 · stub≠本番PSP/PayPal/Meta',
    sellableCatalogTitle: '直販決済カタログ（§1-11）',
    sellableCatalogHint: 'Apple/Googleは現地PSP経由；PayPal予備；暗号はカタログ（本番はコンプライアンス後）。BYO/Referral可。',
    colTitle: '名称',
    colTrack: '商用軌',
    colEnabled: '有効',
    colMerchant: '加盟店参照',
    colNote: '備考'
  },
  produceOutputCatalog: {
    pageTitle: '出品ひも付け',
    pageDesc: '機種が主：一台が出せる出品を紐付け。分類とシーンキットも Leo 自動生産用。',
    tabCategories: '出品分類',
    tabBinds: '機種→出品',
    tabKits: 'シーンキット',
    categoryKey: '分類キー',
    name: '名称',
    bucket: '大分類',
    status: '状態',
    sortNo: '並び',
    modelKey: '機種コード',
    deviceFamily: 'デバイス族',
    bindRole: '役割',
    boundOutputs: '紐付け出品',
    secondaryOutputs: 'うち副役割',
    secondaryHint: '副にしたものは当該機種の副次能力。',
    kitKey: 'キットキー',
    members: '構成機器',
    coverCategories: '対象出品',
    optional: '任意',
    startPipeline: '標準流水線を開始',
    guideStarted: '出品ひも付けガイドを開始しました',
    guideStartFail: 'ガイド開始に失敗'
  },
  trainingWorkBoard: {
    title: '訓作業表',
    desc: 'ドイツ日次訓練の総表。機種／内容で絞り、健全・停滞・訓練ROIをすぐ見る。',
    toDesk: '意思決定台',
    refresh: '更新',
    searchPh: 'タイトル／内容／型番',
    deviceFamily: '機種族',
    contentCategory: '内容類',
    status: '報告状態',
    workState: '作業態',
    stuckOnly: '停滞のみ',
    total: '全部',
    stuck: '停滞',
    healthy: '健全',
    recent: '直近',
    roiTitle: '訓練ROI',
    roiAvg: '平均',
    roiImprove: '要改善',
    roiWaste: '浪費候補',
    roiPlateau: '頭打ち／低ROI',
    roiNext: '次の一手',
    colTitle: '訓練項',
    colContent: '内容',
    colFamily: '機種族',
    colCategory: '内容類',
    colFreq: '頻度',
    colWorkState: '作業態',
    colRoi: 'ROI帯',
    colRoiScore: '点',
    colRoiReason: 'ROI助言',
    colStatus: '報告',
    colAge: '経過(h)',
    colReportAt: '報告時刻',
    colModels: '型番キー',
    colActions: '操作',
    nodeOpen: '総表を開く',
    nodeFilter: '停滞を絞る',
    nodeDesk: '意思決定へ',
    nodeDone: '完了',
    nodeTodo: '未着手',
    ws: { HEALTHY: '健全', STUCK: '停滞', RECENT: '直近' },
    family: {
      tea_machine: '茶機',
      coffee_machine: 'コーヒー',
      cross_cutting: '横断',
      factory: '工場'
    },
    category: {
      device_gate: '機器 Gate',
      routing_nl: 'ルーティング NL',
      portal_nl: 'ポータル NL',
      hm_engine: 'HM',
      commerce_nl: 'モール NL',
      store_ops: '店舗',
      intelligence: '知力',
      healer: 'Healer',
      factory: '工場',
      other: 'その他'
    }
  },
  aiSpendAudit: {
    title: '費用監査',
    desc: 'AI Token／USD 支出の集中監査：ドイツ訓練・クラウド修繕・エッジ商家・拡張科目。',
    reconcileOr: 'OpenRouter 突合',
    importOr: 'OR 活動取込',
    refresh: '更新',
    kpiMeasured: '実測 USD',
    kpiEstimate: '概算 USD',
    kpiCombined: '合計表示',
    kpiTokens: '実測 Token',
    kpiTrainStatus: '訓練コスト状態',
    kpiHealer: 'Healer',
    group: '費用グループ',
    deviceFamily: 'デバイス族',
    applyFilter: '絞り込み',
    colCategory: '科目',
    colGroup: 'グループ',
    colMetering: '計量',
    colUsd: '今月 USD',
    colTokens: 'Token',
    colBudget: '予算',
    colStatus: '状態',
    colHint: '説明',
    detail: '明細',
    budgetPanel: '予算ゲート',
    healerMode: 'Healer モード',
    rounds: '月次ラウンド',
    trainBudget: '訓練月予算 USD',
    saveHealer: 'Healer 保存',
    saveTrainBudget: '訓練予算保存',
    nodeOpen: '費用監査を開く',
    nodeCap: '月上限確認',
    nodeDone: '完了',
    nodeTodo: '未着手',
    loadFail: '費用監査の読込失敗',
    reconcileOk: '突合完了',
    importOk: '取込完了',
    saveOk: '保存済み',
    stepOverview: '概要',
    stepCategories: '科目',
    stepDetail: '明細',
    stepBudget: '上限',
    stepOps: '突合',
    stepOverviewTitle: '今月の AI 費用概要',
    stepOverviewLead: '合計を見てから、科目と月次上限を一歩ずつ確認します。',
    stepCategoriesTitle: '科目を分類表示',
    stepCategoriesLead: 'カードを選んで明細へ。グループで絞り込み可能。',
    stepDetailTitle: '科目明細',
    stepDetailLead: '金額・計量・説明のみ表示。生 JSON は出しません。',
    stepBudgetTitle: '月次上限を設定',
    stepBudgetLead: 'クラウド修繕の USD／ラウンドと訓練予算。',
    stepOpsTitle: '突合と取込',
    stepOpsLead: '必要なら OpenRouter 突合／取込を実行して完了。',
    groupAll: '全グループ',
    emptyCategories: '科目がありません。更新するかドイツ台帳を確認してください。',
    pickCategoryFirst: '前のステップで科目を選んでください',
    moreFields: 'その他フィールド',
    healerBlock: 'Cursor クラウド修繕',
    trainBlock: 'ドイツ訓練予算',
    usdCap: '月次 USD 上限',
    reconcileHint: 'OpenRouter 請求と訓練台帳を揃えます。',
    importHint: 'OpenRouter 活動から今月の利用を取り込みます。',
    doneBanner: '監査フロー完了。概要にいつでも戻れます。',
    prev: '戻る',
    next: '次へ',
    finish: '完了',
    finishOk: '費用監査ウィザード完了',
    chartsTitle: 'チャート分析',
    chartsLead: '日／月／年／曜日／時間帯の推移。科目比較・グループ構成・予算消化を表示。',
    granDay: '日',
    granMonth: '月',
    granYear: '年',
    granWeekday: '曜日',
    granHour: '時間帯',
    chartTrend: '費用推移比較',
    chartCategory: '科目金額比較',
    chartGroup: 'グループ構成',
    chartBudget: '予算 vs 使用',
    chartTrainSplit: '訓練内訳（T9 / OpenRouter）',
    chartModels: 'OpenRouter モデル順位',
    chartEmpty: 'チャートデータなし（台帳が空のときは科目カードのみ）',
    seriesTraining: 'ドイツ訓練',
    seriesHealer: 'クラウド修繕',
    seriesEcs: 'ドイツ ECS（概算）',
    seriesCombined: '合計',
    seriesBudget: '予算',
    seriesSpent: '使用',
  },
  leoChat: {
    chat_1475da: "エンタープライズログイン",
    chat_16f606: "整数。単位はデバイス/契約に依存",
    chat_17dfdc: "マイ設定",
    chat_22f4eb: "使用量と課金",
    chat_27e8b6: "タグ（記憶設定から）",
    chat_29f404: "ブレンダーレシピ",
    chat_30_can_4ab820: "過去30日間の CAN デコードフレーム",
    chat_30_can_8fe750: "過去30日間の CAN 計量合計",
    chat_30_e47539: "過去30日間の入金済み引き落とし",
    chat_30_token_16fa23: "過去30日間の AI ポイント",
    chat_33613d: "チャット",
    chat_40d6e4: "ゲストとして続行（製品と公開問い合わせ）",
    chat_43631f: "リスニング停止",
    chat_4845c6: "処理中…",
    chat_553891: "記入してデバイスに合わせる",
    chat_5cd727: "チャットに戻る",
    chat_62e9d1: "モード選択",
    chat_6888c5: "保存",
    chat_6adada: "コンソール",
    chat_6d1197: "プライバシーポリシー・利用規約・免責事項",
    chat_7106a7: "機台商品",
    chat_71c576: "パスワードを入力してください",
    chat_755be2: "出品登録",
    chat_7847b8: "送信",
    chat_7e76c4: "課金アカウントがまだ作成されていません。保存後、選択したモードで計量が開始されます。",
    chat_805f8b: "このコンテンツを使用",
    chat_85406a: "読み上げをスキップ",
    chat_965a50: "店舗管理者",
    chat_9b2c38: "メッセージを入力",
    chat_9cbbd1: "最後の認識",
    chat_a84cf9: "空欄＝グローバル設定。指定するとそのデバイス専用",
    chat_ab185d: "入力欄に記入",
    chat_abd535: "メンバー登録",
    chat_api_a76f41: "（サブスクリプションプランは運用または API で作成してください）",
    chat_app_c884f6: "他のアプリがリンクまたはキーをコピーしている場合は、直接貼り付けてください。",
    chat_b347b6: "現在の課金設定",
    chat_b6d41c: "コマンドをコピー",
    chat_cta_title_7535dd: "cta.title",
    chat_curve_soft_7e9ea0: "例：curve_soft",
    chat_d2de5e: "登録完了。メンバーとして再ログインして続行してください。",
    chat_d5e285: "を読み、同意しました",
    chat_d5edfc: "全文をコピー",
    chat_da4d71: "メンバーログイン",
    chat_docs_leo_brain_ident_64cb16: "docs/leo_brain/IDENTITY_PROTOCOL.md",
    chat_docs_leo_brain_leo_p_6f7d10: "docs/leo_brain/LEO_PERSONALIZATION_SCENARIO.md",
    chat_e31e3a: "バックエンド完全ログインページ",
    chat_e6a549: "閉じる",
    chat_ea544c: "アカウントを入力してください",
    chat_ef5cb: "リロード",
    chat_email_leo_fda298: "メール + パスワード。ログイン後、Leo チャットに戻り、手順に従ってアクティベーションを完了してください。",
    chat_eur_394b9b: "EUR",
    chat_f98d0d: "設定を保存",
    chat_fe497b: "メンバーアカウントでログインしてください。店舗管理者は「エンタープライズバックエンド」タブを使用してください。ログイン後、プロンプトに従って家庭用または商用設定を完了してください。",
    chat_hintauth_a22705: "hintAuth",
    chat_https_localhost_qr_e4c72c: "カメラ権限が必要。HTTPS または localhost を推奨。デバイスまたは製品の QR/バーコードに合わせてください。",
    chat_leo_323396: "Leo 使用量と課金",
    chat_leo_99743: "Leo ガイド",
    chat_leo_ac1503: "メンバーログインして Leo に入る",
    chat_leo_e3ca11: "Leo アクティベーション手順",
    chat_leo_e7dd0: "Leo",
    chat_leo_e9f6cd: "エンタープライズログインして Leo に入る",
    chat_loaderror_108d9d: "ロードエラー",
    chat_name_example_com_cb4900: "name@example.com",
    chat_night_owl_b82e53: "例：night_owl",
    chat_png_d92bec: "PNG をダウンロード",
    chat_qr_25f92d: "スキャンと製品 QR",
    chat_qr_40dfbd: "QR を生成",
    chat_qr_a9ae66: "アルバムのスクリーンショットまたは写真を選択し、オフラインで QR/バーコードを認識します。",
    chat_session_inputplaceho_bbe0d1: "session.inputPlaceholderZh ||",
    chat_sku_qr_png_c9b88c: "店舗のレシピキーワード、URL、または SKU を QR に変換し、PNG をダウンロードしてラベルを印刷できます。",
    chat_token_7959d6: "累計 AI ポイント（全期間）",
    chat_token_can_dbc_28957f: "Token と車載 CAN/DBC 使用量、ウォレット/台帳の引き落とし記録を表示（メンバーとしてログインするか、バックエンドアカウントが商用バインディング済みであること）。",
    chat_user_ace2e8: "バックエンド User アカウント。メニュー権限を持つユーザーはデバイスとデータセンターを操作できます。",
    chat_voicemictitle_650ed3: "voiceMicTitle",
    chat_voicesiriarialabel_76d873: "voiceSiriAriaLabel",
    chat_wsstatustitle_f6c66f: "wsStatusTitle",
  },
  leoNl: {
      busy: "…",
      close: "Close",
      enable: "この言語で Leo NL を有効にしますか？",
      later: "稍后",
      no: "いいえ",
      subProgress: "生成中…",
      subPrompt: "%1$s の音声コマンドを AI で理解",
      titleProgress: "Leo NL 言語理解を準備中…",
      titlePrompt: "この言語で Leo NL を有効にしますか？",
      titleReady: "Leo NL 言語パックの準備完了",
      yes: "はい",
  },

  dineTable: {
    title: '卓注文',
    desc: '卓ごとに1つのコード。Leo がなくてもウェブで1件注文でき、ダウンロードも案内します。同じページを Facebook などに埋め込めます。',
    brand: 'ブランド',
    retailer: '小売',
    store: '店舗',
    payMode: '支払い',
    payFirst: '先に支払う',
    payLater: '後で支払う',
    saveMode: '保存',
    tableNo: '卓番号',
    create: '卓を追加',
    refresh: '更新',
    colNo: '卓',
    colUrl: '卓シール',
    qr: '卓コード',
    stickerPreview: 'シールプレビュー',
    downloadJpg: 'JPGをダウンロード',
    downloadAllJpg: '全卓シールをZIP',
    downloadOk: '卓シールJPGを保存しました',
    downloadAllOk: '全卓シールZIPを保存しました',
    downloadFail: 'ダウンロードに失敗しました',
    scanHint: 'スキャンして注文',
    poweredBy: 'Leo · 卓注文',
    empty: '卓はまだありません',
    webLink: 'SNS注文リンク',
    webHint: 'Facebook などに埋め込んで、ウェブで注文できます',
    close: '片付け',
    ordersTitle: 'テーブル注文／会計',
    orderCount: '件数',
    paidCount: '入金済',
    unpaidCount: '未入金',
    amount: '金額',
    paid: '支払',
    paidYes: '済',
    paidNo: '未',
    pickup: '呼出番号',
    createdAt: '時刻',
    ordersEmpty: 'まだテーブル注文がありません',
    ordersLoadFail: 'テーブル注文の読み込みに失敗しました。更新するか再ログインしてください',
  },

  brandStorePayment: {
    title: 'ブランド決済',
    desc: '地域 → 決済1社 → 加盟店番号 → 試験通過 → LIVE。売上は店舗加盟店口座へ。',
    hintOneVendor: '店舗ごとに決済は1社のみ。変更時は再試験が必要。',
    store: '店舗',
    storePh: '店舗を選択',
    region: '地域',
    vendor: '決済',
    track: '開設方式',
    trackByo: '既存加盟店（自己入力）',
    trackReferral: '紹介経由で開設',
    merchantRef: '加盟店番号',
    merchantRefPh: '公開 MID／Account（Secret 禁止）',
    currency: '通貨',
    secretWarn: 'API Secret／秘密鍵は入力禁止。公開加盟店番号のみ。',
    save: '保存',
    trial: '試験通過を記録',
    live: 'LIVE にする',
    status: '状態',
    needStore: '先に店舗を選択',
    needMid: '加盟店番号を入力',
    saveOk: '紐付け完了',
    trialOk: '試験通過を記録しました',
    liveOk: 'LIVE にしました'
  },

  hkPspOpenAccount: {
    title: '口座開設',
    desc: '香港 Referral 案件：AI審査・ベンダー送付・受信フォロー。運用は閲覧と例外のみ。',
    hint: 'Referral のみ。BYO 紐付けはこのキューに入りません。',
    refresh: '更新',
    status: '状態',
    vendor: 'ベンダー',
    caseId: '案件ID',
    store: '店舗',
    mid: '加盟店番号',
    sla: 'SLA',
    updated: '更新日時',
    note: '備考',
    runAi: 'AI再実行',
    forceReject: '強制却下',
    markHandled: '手動対応済',
    ok: '完了'
  },

  brandOpenPack: {
    title: '自動開店',
    desc: '1関ずつ。読めるものはシステムが入れる。選ぶのは今マシンを買うかどうかだけ。',
    goPay: '支払いへ',
    level: '第 {n} 関 / {total}',
    photoTitle: '許可証を撮る',
    photoHint: '営業許可を1枚。入力はシステムがやる。',
    photoNext: '撮った、次へ',
    machineTitle: '今マシンを買う？',
    machineHint: '買わなくても店は開く。あとから買える。',
    buyNow: '今買って作り方を習う',
    buyLater: 'あとで買う',
    productTitle: '商品写真と説明',
    productHint: '一言でも写真でも空でもOK。AIが補い、あなたが確認。',
    productHintPh: '例：アイスアメリカーノ、やや苦め',
    productAi: 'AIで補う',
    productSkip: 'スキップ（テンプレ）',
    productConfirm: '商品を確認',
    productName: '商品名',
    productDesc: '説明',
    productPrice: '価格',
    productNeedAi: '先にAI、またはスキップ。',
    productSkipped: 'テンプレ看板を使用。続行可。',
    menuTitle: 'メニューと支払いは準備済み',
    menuHint: 'マシンなしはここまで。次は支払い。',
    teachTitle: '最初の1杯',
    teachHint: 'マシンを結んだら画面どおりに1杯作る。',
    next: 'この関クリア',
    back: '1関戻る',
    stay: 'この関はまだクリアしていない。',
    doneTitle: '店が開いた',
    doneMenu: '支払いとメニュー販売ができる。',
    doneMachine: '次は作り方。',
    colStep: '手順',
    colDetail: 'この地域で必要なこと'
  },

  productShelf: {
    title: '商品掲載',
    desc: '先に売るものを保存。通常品は名前と価格だけ。自動製造は材料と配合が揃ってから、AI が写真・説明・アイコンを作り、確認して掲載。',
    storePh: '店舗番号',
    load: '読込',
    manual: '通常品',
    auto: '自動製造',
    name: '商品名',
    price: '価格',
    kind: '種類',
    state: '状態',
    save: '基本を保存',
    ai: 'AIに任せる',
    publish: '掲載する',
    listed: '掲載済',
    ready: 'AI可',
    waiting: '基本未完',
    needStore: '店舗番号を入力',
    noEquipment: '店に自動設備がありません。配合とスキャンは使えません。',
    materialPh: 'この商品の材料名',
    saveMaterial: 'この材料を記録',
    confirmStep: 'この手順を完了',
    now: 'いま',
    needProduct: '先に商品名と価格を保存してください',
    fail: '失敗。再試行'
  },

  produceGuide: {
    title: '自動設備',
    desc: '茶・コーヒー・ドリンクから選ぶ。店の機械を一台だけ出し、動き方を一文で示す。値段があれば今買い、なければ要望を残す。',
    storePh: '店舗番号',
    tea: '茶',
    coffee: 'コーヒー',
    drink: 'ドリンク',
    look: 'おすすめを見る',
    combo: 'セットもあり：',
    demo: '動き方を見る',
    receiver: '受取人',
    phone: '電話',
    address: '住所',
    buy: '今買う',
    demand: '要望を残す',
    empty: '合う機械がまだありません',
    done: '記録しました',
    fail: '失敗。再試行'
  },

  brandAppListing: {
    title: 'アプリ公開',
    desc: 'ワンクリック：AI が名称／アイコン／商店文案を作成。確認後に Android／iOS 下書きアップロード（XRROSS 代管）。',
    hint: '顧客はビルドやストア管理不要。対外收款には LIVE 決済紐付けが必要。',
    store: '店舗',
    storePh: '店舗を選択',
    displayName: 'アプリ名',
    storeTitle: 'ストアタイトル',
    shortDesc: '短い説明',
    fullDesc: '詳細説明',
    icon: 'アイコン',
    iconEmpty: 'アイコン未生成',
    status: '状態',
    btnAi: '生成する',
    btnConfirm: '素材を確定',
    btnPublish: 'ワンクリック公開',
    btnPipeline: '標準流水線を開始',
    coachDo: 'このステップを実行',
    aiOk: '生成済み（編集可）',
    confirmOk: '素材を確定しました',
    publishOk: '公開をキューしました'
  },

  route: {
    // XRROSS_I18N_UNION_FILL_20260916 ja
    agentPermissionSteward: 'Agent 権限スチュワード',
    aiTrusteeAdmin: 'AI 托管管理',
    leoBrandOnboardingDesk: 'ブランド導入デスク',
    leoBrandOnboardingDeskConfirm: '確認',
    leoBrandOnboardingDeskView: '表示',
    leoBrandOnboardingGroup: 'ブランド導入',
    merchantData: '加盟店データ',
    storeMaterialPhysicalMerge: 'SKUマージ提案',
    teaE1MatchScore: 'マッチスコア',
    teaE1OnTarget: '目標達成',
    teaE1Performance: '茶機 E1 パフォーマンス',
    teaE1Wear: '摩耗',
    // XRROSS_JA_FILL_20260916 begin
    simulatorGroup: 'シミュレータ',
    x600hGateway: 'X600H',
    xt90c2Simulator: 'XT90C2',
    blenderSimulator: 'Blender',
    maestroSimulator: 'Maestroシミュレータ',
    storefrontSimulator: '注文Kiosk',
    deviceServiceAnalytics: '故障分析',
    coffeeMachineProductionData: 'X600H 出品データ',
    coffeeMachineSingleCupData: 'X600H 単杯データ',
    memberHqGroup: '会員 HQ',
    memberHqDashboard: 'HQ 概要',
    memberHqFinance: '財務サマリ',
    financeAccountingReports: '会計レポート',
    financeAccountingGroup: '財務会計',
    storeCostOptimizeGroup: 'コスト効率',
    storeCostOptimizeDesk: 'コスト最適化デスク',
    storeCostOptimizeView: '表示',
    storeCostOptimizeGate: 'ゲート',
    storeOpsCeoDeskGroup: '運営総意思決定台',
    storeOpsCeoDecisionDesk: 'CEO 運営意思決定台',
    storeOpsCeoDecisionDeskView: '表示',
    storeOpsCeoDecisionDeskDecide: '決定',
    storeOpsCeoGovernanceGapTitle: 'グローバル整治ギャップ',
    storeOpsCeoGovernanceGapDesc: '総一覧はここ。価格表／型番ページはジャンプのみ。方案確認は改価・承認・深圳書き込みではありません。',
    storeOpsCeoGovernanceGapConfirm: '方案を確認',
    storeOpsCeoGovernanceGapStart: '標準フローを開始',
    storeOpsCeoGovernanceGapEmpty: '確認待ちのギャップはありません',
    storeOpsCeoGovernanceGapKind: '種類',
    storeOpsCeoGovernanceGapPlan: '方案',
    storeOpsCeoGovernanceGapHonesty: '跨ノード価格差は対帳を取り込んだ後に出ます。本線は自動扇出しません。',
    storeOpsCeoGovernanceGapConfirmed: '確認済',
    storeOpsCeoGovernanceStepOpen: '一覧を開く',
    storeOpsCeoGovernanceStepPick: 'ギャップを選ぶ',
    storeOpsCeoGovernanceStepConfirm: '方案を確認',
    storeOpsCeoGovernanceStepGates: '書込ゲート',
    storeOpsCeoGovernanceStepDone: '完了',
    storeOpsCeoGovernanceCoachTitle: 'いま方案を確認してください',
    storeOpsCeoGovernanceCoachHint: '手順を読んでから確認。確認しても深圳には書きません。',
    aiEngineeringControlGroup: 'AI 工程総控',
    aiEngineeringControlDesk: '工程総控台',
    aiEngineeringControlDeskView: '表示',
    storePnLGroup: '店舗 P&L',
    storePnLDesk: 'P&L／現金デスク',
    storePnLDeskView: '表示',
    storePnLDeskGate: '日次締め／仕訳',
    hkTaxFilingDesk: '店舗帳簿',
    hkTaxFilingDeskView: '表示',
    hkTaxFilingDeskGate: 'パッケージ／人手ゲート',
    hkTaxZeroDesc: '記帳不要。売上は自動、その他の伝票は撮影、税務ファイルはワンタップ。税務署への自動申告ではありません。',
    hkTaxZeroHonesty: '帳簿と提出用ファイルはこちらで用意します。署名とアップロードは税務ポータルでご自身が行います。',
    hkTaxZeroSales: '売上',
    hkTaxZeroExpense: '支出',
    hkTaxZeroSurplus: '今期利益',
    hkTaxZeroPrepare: '税務ファイル作成',
    hkTaxZeroSign: '確認した',
    hkTaxZeroUpload: '税務署へアップロード',
    hkTaxZeroDownload: 'ファイルを保存',
    hkTaxZeroAdvanced: '詳細（会計）',
    hkTaxZeroYa: '課税年度',
    hkTaxZeroCompany: '会社名',
    hkTaxZeroTaxFile: '税務ファイル番号',
    hkTaxZeroTwoTier: '二段階税率',
    hkTaxZeroHasEmp: '従業員あり',
    hkTaxZeroSaveProfile: 'プロフィール保存',
    hkTaxZeroRebuild: '台帳再計算',
    hkTaxZeroAddAdj: '調整を追加',
    hkTaxZeroPartner: 'パートナー送信',
    hkTaxZeroAck: '税務署受付番号',
    hkTaxZeroSaveAck: '受付番号を保存',
    hkTaxZeroEmpAdd: '従業員を追加',
    hkTaxZeroEmpPack: '雇用主パック',
    storeReceiptInbox: '店舗証憑',
    storeReceiptInboxView: '表示',
    storeReceiptInboxGate: 'アップロード入帳',
    storeReceiptInboxDesc: '家賃・光熱・店外仕入の伝票を撮影すると自動仕訳し、香港税務下書きに入ります。税務署への自動申告ではありません。',
    storeReceiptPickStore: '店舗を選択',
    storeReceiptReload: '更新',
    storeReceiptHonesty: '売上は支払済み注文から来ます。ここは店外伝票用です。入帳後も税務デスクで人手署名が必要です。',
    storeReceiptTakePhoto: '撮影／アップロード',
    storeReceiptMerchantHint: '店舗名（任意）',
    storeReceiptList: 'アップロード済み',
    storeReceiptEmpty: 'まだありません',
    storeReceiptDate: '日付',
    storeReceiptMerchant: '取引先',
    storeReceiptAmount: '金額',
    storeReceiptKind: '科目',
    storeReceiptStatus: '状態',
    storeReceiptActions: '操作',
    storeReceiptConfirm: '入帳確認',
    storeReceiptReject: '破棄',
    storeReceiptPreview: '画像',
    storeReceiptBadType: 'JPG／PNG／WebP のみ',
    storeReceiptBadSize: '1枚 8MB まで',
    storeReceiptUploadFail: 'アップロード失敗',
    storeReceiptIngestOk: '受付しました',
    storeReceiptIngestFail: '受付失敗',
    storeReceiptBooked: '入帳しました',
    storeReceiptBookFail: '入帳失敗',
    storeReceiptRejected: '破棄しました',
    storeReceiptRejectFail: '破棄失敗',
    storeReceiptOpenAssist: 'アシスタント',
    storeReceiptIDidCheck: '完了、検査',
    storeReceiptStatusDone: '完了',
    storeReceiptStatusCurrent: '進行中',
    storeReceiptStatusTodo: '未着手',
    xhmHardwarePartnerGroup: '工場／ハード提携',
    xhmHardwarePartnerDesk: '提携／月次精算デスク',
    xhmHardwarePartnerDeskView: '表示',
    xhmHardwarePartnerDeskGate: '月次精算／割当',
    xhmFamilySlotGroup: 'XHM 三軌スロット',
    xhmFamilySlotDesk: 'スロットデスク',
    xhmFamilySlotDeskView: '表示',
    xhmFamilySlotDeskGate: 'スロット保存',
    hkMarketChannelGroup: '香港上市チャネル',
    hkMarketChannelDesk: 'HK 決済／WhatsApp デスク',
    hkMarketChannelDeskView: '表示',
    hkMarketChannelDeskGate: '模擬／設定',
    hkMarketSignup: '香港店契約オンボード',
    hkMarketSignupGate: '契約提出',
    cnMarketChannelGroup: '中国上市チャネル',
    cnMarketChannelDesk: '中国店決済／SNS デスク',
    cnMarketChannelDeskView: '表示',
    cnMarketChannelDeskGate: '模擬／設定',
    cnMarketSignup: '中国店契約オンボード',
    cnMarketSignupGate: '契約提出',
    brandStorePaymentGroup: 'ブランド構築',
    brandOpenPack: '自動開店',
    productShelf: '商品掲載',
    produceGuide: '自動設備',
    brandStorePaymentBind: '決済紐付',
    brandAppListing: 'アプリ上架',
    storeAutonomousMarketingGroup: '店舗自主マーケ',
    storeAutonomousMarketingDesk: '自主マーケデスク',
    storeAutonomousMarketingView: '表示',
    storeAutonomousMarketingGate: 'ゲート',
    workforceGroup: 'シフト出勤',
    workforceWeekSchedule: '週シフト',
    workforceClock: '打刻出勤',
    workforceSummary: '出勤サマリ',
    workforceSmartRoster: 'スマートシフト',
    workforceMySchedule: '自分のシフト',
    workforcePayroll: '給与月次締め',
    memberHqOps: '運営入口',
    distributorReportGroup: 'チャネルレポート',
    distributorDashboard: 'チャネル概要',
    distributorMembers: '自分の会員',
    distributorProfit: '分配明細',
    merchantTokenBillingPlatform: 'AI ポイント',
    merchantDataBillingPlatform: '車載データ請求',
    linuxAutoOps: '車載運営',
    linuxAutoEquipment: '車載機器',
    linuxAutoRemoteOps: '遠隔運用',
    linuxAutoProfileConfig: 'Profile 設定',
    linuxAutoDataBilling: 'CAN データ請求',
    linuxAutoModelRegistry: '型番登録',
    linuxAutoPartnerDelivery: '提携納品',
    linuxAutoFleetMonitor: '車隊監視',
    linuxAutoDbcEntitlement: 'DBC 認可',
    linuxAutoCabinFeatures: '車室機能',
    linuxAutoCanAutoMatch: 'CAN 自動照合',
    // XRROSS_JA_FILL_20260916 end
    homePage: 'ホーム',
    opsAnalyticsDesk: '経営ダッシュボード',
    dataDisplay: 'データ表示',
    atlas: '地図',
    journal: 'ログ',
    details: '詳細',
    systemSetting: 'システム設定',
    socNotificationCenter: '通知センター',
    loginAccount: '管理用垢',
    merchants: '加盟店管理',
    devices: "機器管理",
    material: "原料管理",
    deviceConfig: "機器設定",
    channelConfiguration: "レーン設定",
    configProfileLibrary: "プロファイル一覧",
    coffeeMachineChannelSlots: "X600H配方センター",
    configBindDispatch: "紐付けと配信",
    leoKnowledgeGroup: '知能.Leo',
    leoKnowledgeModelFields: '型番ナレッジ項目',
    leoKnowledgeEquipmentTypeTypeKey: '機器種別 type_key',
    leoKnowledgeUpload: 'ナレッジアップロード',
    leoKnowledgeIngestBatch: '取込バッチ（自動）',
    leoKnowledgePhase1Ssot: 'Phase1 SSOT パイプライン',
    leoKnowledgeCapabilityMatrix: '能力マトリクス',
    leoKnowledgeOnboarding: 'スマート型番オンボーディング',
    leoKnowledgeTesterConsole: 'テスター・コンソール',
    leoKnowledgePipelineHub: 'パイプライン一覧',
    leoKnowledgeFeatureSurface: '機能→API マッピング',
    leoKnowledgeProtocolDoc: 'プロトコル文書索引',
    leoKnowledgeRemoteTools: '遠隔ツール一覧',
    leoKnowledgeLearning: '学習ループ',
    leoKnowledgeExternalIngest: '外部ナレッジ取込',
    leoKnowledgePortalHub: 'Leo チャット／運用',
    leoKnowledgePortalHubDesc: 'Leo チャット（主入口）と Biz 運用。Console／Portal は内部運維のみ。',
    leoKnowledgePortalHubHint: 'コンソールはバブル型 UI。portalToken／ceoBearer が必要な場合は開いた後に URL へ付与してください。',
    leoKnowledgeUiSurfaceSample: '管理画面サンプル',
    leoKnowledgeUiSurfaceSample2: '管理画面サンプル · 2',
    leoKnowledgeUiSurfaceSample3: '管理画面サンプル · 3',
    uiSurfaceSampleMergedLead: '3つの管理画面サンプルを1ページにまとめ、タブで切替えます。',
    uiSurfaceSampleTab1: 'サンプル1 · Ant Pro',
    uiSurfaceSampleTab2: 'サンプル2 · Stripe',
    uiSurfaceSampleTab3: 'サンプル3 · 高密度',
    uiSurfaceSampleLead: 'サンプル1（採用・パイロット）：Ant Design Pro 中密度。Token を全域化。商家／設備リストに骨格適用済み。',
    uiSurfaceSampleLead2: 'サンプル2 · Stripe／SaaS：紫系アクセント、大きめ角丸、ゆったり余白。',
    uiSurfaceSampleLead3: 'サンプル3 · コンパクト運用：ティール、小さめ角丸、高密度。',
    uiSurfaceSampleAlert: '見た目サンプルのみ。API 非呼出。サンプル1／2／3 を比較してください。',
    uiSurfaceSampleTokenTitle: 'Design Token（候補）',
    uiSurfaceSampleDensity: '密度：中（8px グリッド）',
    uiSurfaceSampleDensity2: '密度：ややゆったり（Stripe）',
    uiSurfaceSampleDensity3: '密度：コンパクト（運用）',
    uiSurfaceSampleBtnTitle: 'ボタン階層',
    uiSurfaceSampleBtnPrimary: '主要',
    uiSurfaceSampleBtnSecondary: '副次',
    uiSurfaceSampleBtnText: 'テキスト',
    uiSurfaceSampleBtnDanger: '危険',
    uiSurfaceSampleBtnMore: 'その他',
    uiSurfaceSampleBtnCreate: '新規',
    uiSurfaceSampleListSkeleton: '一覧骨格：絞り込み｜表｜フッター',
    uiSurfaceSampleFormTitle: 'フォーム密度（中）',
    uiSurfaceSampleFormRemark: '備考',
    uiSurfaceSamplePipelineTitle: 'パイプライン節点＋コーチ金樣（SocProcessRail + SocStepCoach）',
    uiSurfaceSamplePipelineMeta: 'トップバー＝節点レール＋青枠コーチ大ボタン；To-go／ページ内共用；別様式禁止',
    uiSurfaceSampleCoachTitle: '今やること：ステップ2（デモ）',
    uiSurfaceSampleCoachHint: '青枠＝今の一歩。大きなボタンを押すだけ。ページ全体を探さない。',
    uiSurfaceSampleCoachPrimary: 'このステップへ',
    uiSurfaceSampleCoachSecondary: '開始／ガイド確認',
    uiSurfaceSamplePipelineStep1: 'ステップ1',
    uiSurfaceSamplePipelineStep2: 'ステップ2',
    uiSurfaceSamplePipelineStep3: 'ステップ3',
    uiSurfaceSamplePipelineStep4: 'ステップ4',
    uiSurfaceSampleColActions: '操作',
    uiSurfaceSampleActEdit: '編集',
    uiSurfaceSampleActExport: '書き出し',
    uiSurfaceSampleTableFootHint: 'フッター：左説明｜右ページネーション',
    uiSurfaceSampleKpi_orders: '本日注文（ダミー）',
    uiSurfaceSampleKpi_online: 'オンライン端末',
    uiSurfaceSampleKpi_alerts: '未処理アラート',
    uiSurfaceSampleKpiSub: 'サンプル数値',
    uiSurfaceSampleFilterTitle: '絞り込み',
    uiSurfaceSampleKeyword: 'キーワード',
    uiSurfaceSampleKeywordPh: '名称またはコード',
    uiSurfaceSampleStatus: '状態',
    uiSurfaceSampleStAll: 'すべて',
    uiSurfaceSampleStOn: '有効',
    uiSurfaceSampleStOff: '無効',
    uiSurfaceSampleReset: 'リセット',
    uiSurfaceSampleSelectPh: '選択してください',
    uiSurfaceSampleTableTitle: '一覧イメージ',
    uiSurfaceSampleColName: '名称',
    uiSurfaceSampleColRegion: '地域',
    uiSurfaceSampleColStatus: '状態',
    uiSurfaceSampleColUpdated: '更新日時',
    uiSurfaceSampleCompareTitle: '対比：全面白 vs レイヤー型グレー',
    uiSurfaceSampleCompareOld: '旧：広い純白',
    uiSurfaceSampleCompareOldDesc: '背景と内容が同じ白だと境界が弱く、長時間の閲読で負担が増えがちです。',
    uiSurfaceSampleCompareNew: '提案：グレー上の白カード',
    uiSurfaceSampleCompareNewDesc: '本文は白でコントラストを確保し、ページ全体は浅いグレーで視線の置き場を作ります。',
    leoPortalHubSovereign: 'コンソール（全画面）',
    leoPortalHubPortal: 'ポータル',
    leoPortalHubDeviceIntegrationSection: 'デバイス連携',
    leoPortalHubDeviceIntegrationLink: '公開ドキュメント・ツール（新しいタブ）',
    leoPortalHubRuntimeModuleLink: 'Device Cloud ランタイム AAR（新しいタブ）',
    leoPortalHubSdkLabSection: 'XRROSS SDK（エンジニア）',
    leoPortalHubSdkEngineerLabOpen: '統合テスト台（トラック1+2、新しいタブ）',
    leoPortalHubSdkPublicTrack1: 'トラック1 公開ページ',
    leoPortalHubSdkPublicTrack2: 'トラック2 公開ページ',
    leoPortalHubChatSection: 'チャット入口',
    leoPortalHubPreferences: 'マイ設定',
    leoPortalHubLogin: 'ログイン',
    leoPortalHubSectionOps: '運用コンソール',
    leoPortalHubSectionOpsDesc: 'ライブ対話・CEO／ポータル向けの主権画面。大画面での検証に適します。',
    leoPortalHubSectionPortal: 'モバイルポータル',
    leoPortalHubSectionPortalDesc: '軽量な入口。スマホやデモ向け。',
    leoPortalHubSectionChat: '対話（Leo）',
    leoPortalHubSectionChatDesc: 'Leo 対話。下段で設定・ログイン。',
    leoPortalHubSectionDeviceDesc: '公開ドキュメント、ランタイム、連携資料（いずれも新しいタブ）。',
    leoPortalHubSectionSdkDesc: '2 トラック配線・回帰・デバッグ用のエンジニア向け統合テスト台。',
    leoPortalHubCardSovereignDesc: 'バブル型チャット、Markdown、SOP ステップカード。',
    leoPortalHubCardPortalDesc: 'コンパクトな Leo ポータル。必要に応じ URL に portalToken／ceoBearer を付与。',
    leoPortalHubCardLeoDesc: '既定の Leo チャット（全球会員同一入口）。',
    leoPortalHubCardPrefDesc: 'ペルソナ、地域などの個人設定。',
    leoPortalHubCardLoginDesc: 'スタッフアカウントでログイン後、書き込み／センシティブ機能を利用。',
    leoPortalHubCardDeviceIntegrationDesc: '公開説明、トラック1 ツール、連携チェックリスト。',
    leoPortalHubCardRuntimeDesc: 'Device Cloud ランタイム／AAR とトラック2 の入口。',
    leoPortalHubCardSdkLabDesc: 'トラック1・2 を同時に試せる統合ラボ。',
    leoPortalHubSdkFeaturedTag: 'エンジニア',
    leoPortalHubOpenNewTab: 'クリックで新しいタブ',
    leoPortalHubSdkCrossRefHint: 'トラック1／2 の公開ページは上の「デバイス連携」にある2枚のカードをご利用ください。',
    leoFloatDockTitle: 'Leo チャット',
    leoFloatDockMinimize: '最小化',
    leoFloatDockClose: '閉じる',
    leoFloatDockResizeHint: '右下をドラッグしてサイズ変更',
    leoFloatDockSwitchLabel: 'Leo チャット',
    socAssistantTabManual: 'マニュアル',
    socAssistantTabGuide: 'スマートガイド',
    socSmartGuideLead: '自分が誰で、何を達成したいかを言う。標準プロセスを開き、削除するまで結果まで見ます。終わったら次を開きます。',
    socSmartGuideStart: 'プロセス開始',
    socSmartGuideMyProcesses: '自分のプロセス',
    socSmartGuideCatalog: 'またはカタログから選ぶ',
    socSmartGuideNetStats: '単位 {units} · プロセス {processes} · 交差 {edges}',
    socSmartGuideIntentPlaceholder: '例：新ブランドの責任者です。契約から出品できるまで案内して',
    socSmartGuideEntry: '入口',
    socSmartGuideExit: '出口',
    socSmartGuideDemand: '要求',
    socSmartGuideResult: '結果',
    socSmartGuideHandoff: 'このプロセスは完了。次を開きます',
    socSmartGuideRolePreview: 'ロール確認',
    socSmartGuideRoleCurrent: 'このアカウント',
    socSmartGuideProxyStore: '店員代行：店舗ID',
    socSmartGuidePaused: '一時停止',
    socSmartGuideInProgress: '進行中',
    socSmartGuideNotices: '通知',
    socSmartGuideNoticeNotDone: '未実施',
    socSmartGuideNoticeWrong: '誤り',
    socSmartGuideNoticeDue: '期限',
    socSmartGuideAck: '確認',
    socSmartGuideContinue: '続ける',
    socSmartGuideDelete: '流水線を削除',
    socSmartGuideDeleteConfirm: '削除すると、この線の追跡を止めます。削除しますか？',
    socSmartGuideDeleted: '流水線を削除しました',
    socSmartGuideDeleteFail: '削除できませんでした',
    socSmartGuideOpenPage: '開く',
    socProcessNetTogoTitle: '残作業',
    socProcessNetTogoRemain: '残り {n} ステップ',
    socProcessNetTogoAllDone: 'この線は完了',
    socProcessNetTogoHint: 'チェックはシステム状態のみ。停滞ステップで実ページへ、または Leo に話して同一伝票を埋めます。',
    socProcessNetTogoVoice: 'Leo に話す',
    socProcessNetTogoClose: '閉じる',
    socProcessNetTogoLoadFail: '残作業を読み込めません',
    socProcessNetTogoNow: '現在',
    socSmartGuideSlotsHint: '足りない欄を先に答える（会話も同じ伝票）',
    socSmartGuideSlotSubmit: '保存',
    socAssistantTabChat: 'Leo チャット',
    xrrossIntroNavButton: 'XRROSS を知る',
    xrrossIntroHub: 'XRROSS を知る',
    xrrossIntroLeo: 'Leo',
    xrrossIntroSoc: 'SOC',
    xrrossIntroTrinity: 'Trinity',
    xrrossIntroXhm: 'XHM',
    leoSmartIntro: 'Leo Smart を知る',
    leoFloatDockSwitchHint: 'オンで Leo SOCアシスタントの「チャット」タブを開きます（マニュアル／ガイドと同じドロワー）。単独 Leo ページは従来どおり全画面チャットです。',
    layoutThemeUseDark: 'ダークテーマに切替',
    layoutThemeUseLight: 'ライトテーマに切替',
    leoProfileWorkbenchLeoMovedPrefix: 'C-Line · Leo：コンソール／ポータル／Leo チャットはサイドバー「Leo ナレッジ」内の',
    leoProfileWorkbenchLeoMovedSuffix: 'へ移動しました。',
    equipmentCategory: '機器カテゴリ',
    equipmentCategoryEdit: '機器カテゴリ（編集）',
    equipmentCategoryDel: '機器カテゴリ（削除）',
    equipmentTypePermAdd: '機器種別（一覧／追加）',
    equipmentTypePermEdit: '機器種別（編集）',
    deviceSimulatorConsole: 'シミュレーター・コンソール',
    leoDeviceOpsRolePolicy: 'コマンド権限マトリクス',
    leoDeviceOpsSemanticTraining: '意味訓練ワークベンチ',
    leoTurnRoutingTrainingHub: 'T0 入口ルーティング訓練台',
    leoKnowledgePortalOpsInventory: 'Portal ops API 棚卸し',
    leoKnowledgePortalOpsDailyHub: 'PORTAL_OPS ワークベンチ',
    leoDeviceOpsReviewInbox: 'B線レビュー受信箱',
    leoDeviceOpsDescriptionAutogen: 'Device_OPS 盤點台',
    leoDeviceOpsBLineDailyHub: 'B線デイリーハブ',
    productCenter: "商品管理",
    productCenterFolderOther: 'その他製品',
    dataCenter: "データ本部",
    maintenance: "保守管理",
    filesCenter: 'ファイル管理',
    menuSetting: 'メニュー設定',
    organization: '組織管理',
    loginAccount: '垢リスト', // "账号"翻译为"アカウント"(Account)太长，为保长度用了"垢"(俗语)或"ID"，此处用"垢リスト"或"ID一覧"更短，这里选比较通用的"ID一覧"
    authorization: '権限管理',
    merchants: '加盟店一覧',
    deviceList: '機器一覧',
    deviceAutoServiceGroup: 'アフターサービス・メンテナンス',
    supportTicketGroup: 'サポート',
    supportTicketCreate: 'チケット作成',
    supportTicketMine: 'マイチケット',
    supportTicketWorkbench: 'サポート工作台',
    supportPlaybook: '標準Q&A',
    deviceServiceWorkbench: 'アフターサービス作業台',
    deviceServiceMyAssignments: '担当修理タスク',
    deviceServiceAssignees: '修理担当者',
    deviceServiceMaintenance: 'メンテナンス計画',
    deviceServiceFaultPolicy: '故障ポリシー',
    deviceServiceEnterprisePolicy: '企業ポリシー',
    deviceServiceMobile: 'モバイルタスク',
    deviceServiceBills: '修理請求',
    storeMaterialStock: '在庫概要',
    storeMaterialOrders: '発注',
    storeMaterialConsumable: '消耗品 BOM',
    storeMaterialMq: 'MQ 設定',
    storeMaterialInvoice: '請求書',
    storeMaterialBarcodeAlias: 'バーコード対応',
    storeMaterialCount: '在庫棚卸',
    storeMaterialBomWizard: 'BOMウィザード',
    storeMaterialAnalytics: '物料使用レポート',
    channelCategory: 'レーン種別',
    productCategory: '商品種別',
    optionCategory: '規格種別',
    optionList: '規格一覧',
    storeAccount: '店舗ＩＤ',
    stores: '店舗管理',
    modelName: '機器名/型番',
    category: '原料種別',
    configDistribute: 'レーン送信',
    devicesChannels: '機器レーン',
    productsList5: '商品一覧5',
    produceFivePos: '商品5店舗カスタム',
    posCenter: 'POSセンター',
    menuDistribute: 'メニュー送信',
    storeMenu: '店舗メニュー',
    merchantsData: '店舗統計',
    devicsData: '機器統計',
    productionData: '製造データ',
    maintanenceData: '保守データ',
    devicesWorkingData: '稼働データ',
    afterSalesReminder: '保守通知',
    maintenanceTips: '点検通知',
    fileUpgrade: '更新配信',
    dataDowloan: 'データＤＬ',
    materialList: '原料一覧',
    accessoriesCategory: '軽食種別',
    accessoriesList: '軽食一覧',
    businessCenter: '業務本部',
    afterSalesServiceGroup: 'アフターサービス',
    storeMaterialGroup: '在庫管理',
    appsBanner: 'Appバナー',
    advertisement: '広告一覧',
    advertBind: '広告紐付',
    advertDistribute: '広告配信',
    membersCenter: '会員一覧',
    orderCenter: '注文一覧',
    packBag: '持帰り袋',
    appsCenter: 'アプリ管理',
    productsList2: '商品一覧2',
    XTSeriesData: '調合機データ',
    calibrationData: '校正データ',
    fullPipeData: '満管データ',
    productionData: '商品データ',
    materialDate: '原料データ',
    qualityData: '単杯データ',
    alertsLog: '故障ログ',
    cleaningLog: '洗浄記録',
    coffeeData: '珈琲機データ',
    coffeeSumData: '品質データ',
    taxCenter: '税務本部',
    taxManagement: '税務管理',
    taxAllocation: '税務設定',
    dataOfTeaExtractorMachine: '抽出機データ',
    teaMachineMaterial: '物料ロス',
    teaEarlyBrewWork: '多機連携',
    dispenserPrecision: '精度',
    dispenserMaterialLoss: '物料ロス',
    dispenserMultiMachine: '多機連携',
    ecosystemMallGroup: 'エコシステムモール',
    ecosystemMallTopology: '店舗トポロジ',
    ecosystemMallFeaturedBuyEyebrow: 'おすすめ · 家庭向け直販',
    ecosystemMallFeaturedBuyTitle: 'Xrross X600H · $499',
    ecosystemMallFeaturedBuyDesc: '家庭用スマートコーヒーマシン。ワンクリックで会計へ。',
    ecosystemMallFeaturedBuyCta: 'X600H を購入',
    ecosystemMallFeaturedBuyBrowse: 'カタログを見る',
    ecosystemMallCapGridTitle: 'ここでできること',
    ecosystemMallCapGridDesc: '機能は隠しません。各マスにマウスを置くと短い説明と連動がポップアップ。青バッジ＝今いちばんすべき一歩。',
    ecosystemMallCapHoverHint: 'マウスで説明を表示',
    ecosystemMallTipBuyX600h: '家庭向けチェックアウトで Stripe／PayPal により X600H を購入（海外は Stripe 既定）。',
    ecosystemMallTipOrientPipeline: 'ガイド：能力グリッド → 家庭／店舗 → 店舗選択 → 能力を開く。',
    ecosystemMallTipGapFillPipeline: '店舗選択後の穴埋め：トポロジ → 提案 → 模擬／リード → 発注可能。',
    ecosystemMallTipColorScheme: 'キャンバス配色のみ。機能は変わりません。',
    ecosystemMallTipBrowseCatalog: 'まずカタログとトポロジを見る。急いで決済しなくてよい。',
    ecosystemMallTipHomePipeline: '家庭チェックアウト：SKU → 住所 → 決済 → 完了。',
    ecosystemMallTipBackTopology: '商城ホーム（トポロジ／能力グリッド）へ戻る。',
    ecosystemMallTipReload: 'このページのデータを再読込。',
    ecosystemMallTipPayStripe: 'Stripe で安全に決済（海外既定）。',
    ecosystemMallTipPayPaypal: 'PayPal で決済（任意）。',
    ecosystemMallTipTrialPipeline: '試用→購入：試用開始 → 結果 → 購入または意向。',
    ecosystemMallTipEntryContinue: 'ブリーフィングの次の一歩へ。',
    ecosystemMallTipEntrySwitch: '家庭／店舗フォーカスを切替（機能は減らさない）。',
    ecosystemMallTipEntryAdvanced: '詳細チャート／専門家向けを開閉。',
    ecosystemMallTipTrackHome: '家庭フォーカス：直購・家庭機器向け。',
    ecosystemMallTipTrackCommercial: '店舗フォーカス：店務・ライン・ギャップ向け。',
    ecosystemMallTipAppDlPipeline: '当地区の正式アプリ案内（OTA と同台帳）。',
    ecosystemMallTipAppDlReload: 'ダウンロード一覧を更新。',
    ecosystemMallCapBadgeSuggest: 'おすすめ',
    ecosystemMallCapBadgeCurrent: 'いまここ',
    ecosystemMallCapBadgeNeedStore: '店舗を選択',
    ecosystemMallCapC1Title: '店舗トポロジー',
    ecosystemMallCapC1Blurb: 'トポロジ図であるもの／足りないものを見る',
    ecosystemMallCapC1Link: '連携：機器をタップして連動を確認',
    ecosystemMallCapC2Title: '検索・おすすめ',
    ecosystemMallCapC2Blurb: 'キーワードで次の一台を探す',
    ecosystemMallCapC2Link: '連携：店のギャップから推薦',
    ecosystemMallCapC3Title: 'ライン組合せ',
    ecosystemMallCapC3Blurb: 'この業態に必要な機器',
    ecosystemMallCapC3Link: '連携：店務ラインをまとめて揃える',
    ecosystemMallCapC4Title: '試用シミュレーション',
    ecosystemMallCapC4Blurb: '買う前にクラウドで試す',
    ecosystemMallCapC4Link: '連携：試した後に不足を埋める／購入',
    ecosystemMallCapC5Title: '組合せデモ',
    ecosystemMallCapC5Blurb: '店全体の流れを見る',
    ecosystemMallCapC5Link: '連携：複数機器の店務ストーリー',
    ecosystemMallCapC6Title: '家庭向け購入／注文',
    ecosystemMallCapC6Blurb: 'ハード購入・決済・注文確認',
    ecosystemMallCapC6Link: '連携：購入後も Leo／トポロジー同一生態',
    ecosystemMallCapC7Title: 'ビジネスプラン',
    ecosystemMallCapC7Blurb: 'プラン購入／アップグレード',
    ecosystemMallCapC7Link: '連携：プラン機能が店と機器に戻る',
    ecosystemMallCapC8Title: '購入意向',
    ecosystemMallCapC8Blurb: 'これが欲しい／設置したい',
    ecosystemMallCapC8Link: '連携：意向→履行→トポロジー',
    ecosystemMallCapC9Title: '販売前Q&A',
    ecosystemMallCapC9Blurb: '連動／買い方／試し方を質問',
    ecosystemMallCapC9Link: '連携：理解してからシム／意向へ',
    ecosystemMallCapC10Title: 'アプリダウンロード',
    ecosystemMallCapC10Blurb: '当地区の正式アプリ',
    ecosystemMallCapC10Link: '連携：スマホと機器が同一台帳',
    ecosystemMallCapC11Title: '仮想店舗／家庭',
    ecosystemMallCapC11Blurb: 'レイアウトと配置提案',
    ecosystemMallCapC11Link: '連携：仮想配置を実ギャップに対応',
    ecosystemMallCapC12Title: '製品展示',
    ecosystemMallCapC12Blurb: 'カード格子で商品を見る',
    ecosystemMallCapC12Link: '連携：カードから決済／試用／トポロジへ',
    ecosystemMallProductDisplayDesc: '全商品を格子表示（トポロジ・ライン組合せと並立）。カードを開き、購入か試用を選ぶ。',
    ecosystemMallProductDisplayToolbar: '商品グリッド',
    ecosystemMallProductDisplayCount: '{n} 件',
    ecosystemMallProductDisplaySearchPh: '名称／コード検索',
    ecosystemMallProductDisplayDefaultPitch: 'クラウド対応 · 連動可',
    ecosystemMallProductDisplayAlreadyHere: 'すでに製品展示にいます',
    ecosystemMallProductDisplaySeeTopology: 'トポロジで連動を見る',
    ecosystemMallProductDisplayScopeLabel: '機器範囲',
    ecosystemMallProductDisplayScopeAll: '全機器',
    ecosystemMallProductDisplayScopeStore: 'この店舗',
    ecosystemMallProductDisplayNeedStore: '店舗範囲は先に店舗を選択',
    ecosystemMallProductDisplayNoStore: '店舗未選択',
    ecosystemMallProductDisplayStoreAlert: 'この店舗：上で店舗を選ぶと、保有／推奨商品が出ます。',
    ecosystemMallProductDisplayCatalogAlert: '全機器：商城カタログ全量。店舗を選ぶと保有をマーク。',
    ecosystemMallProductDisplayEmpty: '表示できる商品がありません。全機器に切替・店舗変更・ACTIVE 上架を確認。',
    ecosystemMallProductDisplaySideEmpty: '左の商品カードを押すと、トポロジ店と同じ詳細パネルが開きます。',
    ecosystemMallProductDisplaySideEmptyHint: 'カバー／動画、概要、仕様、機能章；購入・試用・トポロジ連動へ。',
    ecosystemMallDetailCapacity: '能力向上',
    ecosystemMallDetailLabor: '人工削減',
    ecosystemMallDetailMedia: '製品詳細とメディアギャラリー',
    ecosystemMallDetailMediaPending: '画像待ち',
    ecosystemMallDetailMediaPreview: '製品プレビュー',
    ecosystemMallDetailVideo: '製品動画',
    ecosystemMallDetailCover: 'モールカバー',
    ecosystemMallDetailAvatar: 'トポロジアバター',
    ecosystemMallDetailModelImg: '型番画像',
    ecosystemMallDetailScene: 'シーン',
    ecosystemMallDetailTabOverview: '概要',
    ecosystemMallDetailTabSpecs: '仕様',
    ecosystemMallDetailTabFeatures: '機能',
    ecosystemMallDetailKeySpecs: '主要仕様',
    ecosystemMallDetailSeeAll: 'すべて見る',
    ecosystemMallDetailSpecsLoading: '仕様読込中…',
    ecosystemMallDetailSpecsEmpty: '採用済み仕様がありません。',
    ecosystemMallDetailSpecsFail: '仕様の読込に失敗',
    ecosystemMallDetailSpecSearchPh: '仕様を検索…',
    ecosystemMallDetailGuide: 'ガイド体験',
    ecosystemMallDetailAllChapters: '全章',
    ecosystemMallDetailPrev: '前へ',
    ecosystemMallDetailNext: '次へ',
    ecosystemMallDetailProof: '能力証明フック',
    ecosystemMallDetailOpen: '開く',
    ecosystemMallDetailNoChapters: 'この型番に機能章はありません。',
    ecosystemMallDetailBackChapters: '章一覧へ戻る',
    ecosystemMallDetailChapter: '章',
    ecosystemMallDetailChapterHint: 'タップで手順を見る',
    ecosystemMallDetailModel: '型番',
    ecosystemMallDetailFamily: 'ファミリー',
    ecosystemMallDetailRole: '店舗ロール',
    ecosystemMallDetailOverlayOwned: '導入済 · クラウド連動',
    ecosystemMallDetailOverlayMissing: 'クラウド準備済 · 店舗に未導入',
    ecosystemMallDetailOverlayAvailable: 'カタログ選択可 · クラウド準備済',
    ecosystemMallOrientRailTitle: '生態モールを知る',
    ecosystemMallGapFillPipeline: '店舗の不足を埋める',
    ecosystemMallGapFillRailTitle: '店舗ギャップ補完',
    ecosystemMallHomeCheckoutPipeline: '家庭向け購入フロー',
    ecosystemMallTrialThenBuyTitle: '試してから買う',
    ecosystemMallTrialThenBuyDesc: '試用後に直購または意向。試用は実機台帳と分離。機能は減らしません。',
    ecosystemMallTrialThenBuyPipeline: '試用してから買う',
    ecosystemMallTrialThenBuyRailTitle: '試用→購入',
    ecosystemMallTrialThenBuyListTitle: 'マイ試用シミュレータ',
    ecosystemMallTrialThenBuyAllStatus: 'すべての状態',
    ecosystemMallTrialThenBuyCleanup: '期限切れ整理',
    ecosystemMallTrialThenBuyEmpty: '試用シミュレータなし',
    ecosystemMallTrialThenBuyStatus: '状態',
    ecosystemMallTrialThenBuyExpires: '期限',
    ecosystemMallTrialCoachPick: '試す商品を選ぶ',
    ecosystemMallTrialCoachOpen: '試用を開く／更新',
    ecosystemMallTrialCoachResult: '結果後に購入または意向',
    ecosystemMallTrialHintPick: 'トポロジで機器を選び試用。本ページは開通一覧。',
    ecosystemMallTrialHintOpen: '更新で試用SNを確認（実機と隔離）。',
    ecosystemMallTrialHintResult: '購入と意向の入口は両方見える。',
    ecosystemMallSideBuyNow: 'この機器を購入',
    ecosystemMallSideSimOpen: 'まずシミュレーション',
    ecosystemMallSideSimClose: 'シムを閉じる',
    ecosystemMallSideIntentNeedStore: '先に店舗を選び、意向を残す',
    ecosystemMallSideIntentPotential: 'これが欲しい（意向を残す）',
    ecosystemMallSideIntentOwned: 'この店には既にある',
    ecosystemMallAppDownloads: 'アプリ入手',
    ecosystemMallAppDownloadsDesc: 'Leo の製品ページ。iPhone は App Store。Android 海外は Google Play、中国大陸はこの区のノード直装（OTA と同じ）。',
    ecosystemMallAppDlReload: '再読込',
    ecosystemMallAppDlChannels: '入手チャネル',
    ecosystemMallAppDlAndroid: 'Android 直接インストール',
    ecosystemMallAppDlInstallNow: 'ダウンロードして入れる',
    ecosystemMallAppDlNoApk: 'この区に直装パッケージがまだない',
    ecosystemMallAppDlAndroidReady: 'Android を検出。この区の公開済み Leo スマホ版を入れられます。',
    ecosystemMallAppDlAndroidWait: 'お客様向けパッケージは未公開です。ストア審査完了をお待ちください。',
    ecosystemMallAppDlVersion: 'バージョン',
    ecosystemMallAppDlUnknownSrc: '提供元不明と出たら、このアプリのインストールを許可してください。',
    ecosystemMallAppDlPlayReview: 'Google Play はまだ開いていません。',
    ecosystemMallAppDlIosReview: 'App Store はまもなく公開。',
    ecosystemMallAppDlReviewing: '審査中',
    ecosystemMallAppDlComing: '近日公開',
    ecosystemMallAppDlDesktopHint: 'iPhone は App Store。Android 海外は Google Play、中国大陸はこの区のノード直装。リンクのコピーもできます。',
    ecosystemMallAppDlCopyLink: 'このページのリンクをコピー',
    ecosystemMallAppDlOpenSoc: 'SOC を開く',
    ecosystemMallAppDlCopySoc: 'SOC リンクをコピー',
    ecosystemMallAppDlSocHint: 'SOC はブラウザの中枢です。いまここにいます。',
    ecosystemMallAppDlCopied: 'コピーしました',
    ecosystemMallAppDlSmartAndroid: 'Android です。今すぐ Leo を入れられます。',
    ecosystemMallAppDlSmartAndroidPlay: 'Android（海外）です。Google Play から Leo を入れてください。',
    ecosystemMallAppDlSmartAndroidNode: 'Android（中国大陸）です。この区のノードから入れてください（OTA と同じ包）。',
    ecosystemMallAppDlSmartAndroidNoApk: 'Android ですが、この区に直装包がまだありません。海外は Google Play へ。',
    ecosystemMallAppDlSmartIos: 'iPhone です。App Store から Leo.Smart を入れてください。',
    ecosystemMallAppDlSmartDesktop: 'PC です。Android で開くか、リンクをコピーしてください。',
    ecosystemMallAppDlRoleLeo: 'スマホの頭脳',
    ecosystemMallAppDlRoleSoc: 'いまここ',
    ecosystemMallAppDlRoleXhm: '店内機器 · 次回',
    ecosystemMallAppDlTopo: 'モール位相 · 三位一体',
    ecosystemMallAppDlEdgeLeoSoc: 'スマホ → SOC',
    ecosystemMallAppDlEdgeSocXhm: 'SOC → 機器',
    ecosystemMallAppDlCapLeo: 'Leo は人と機械の話し方。Android は先に直装できます。',
    ecosystemMallAppDlCapSoc: 'SOC はアカウント・店舗・遠隔の中枢です。',
    ecosystemMallAppDlCapXhm: '機器側アプリは次回。まずはスマホ Leo を入れてください。',
    ecosystemMallAppDlStartPipeline: '標準パイプライン開始',
    ecosystemMallAppDlPipelineStarted: '標準パイプラインを開始しました',
    ecosystemMallAppDlDeveloper: 'XRROSS',
    ecosystemMallAppDlCategory: '暮らし · 人機 · 店舗',
    ecosystemMallAppDlPlayBtn: 'Google Play',
    ecosystemMallAppDlIosBtn: 'App Store',
    ecosystemMallAppDlQrTitle: 'QRでダウンロード',
    ecosystemMallAppDlQrHint: 'スキャンで入手ページへ。iPhone は App Store。Android 海外は Google Play、中国大陸はこの区のノード直装。',
    ecosystemMallAppDlQrSave: 'QRを保存',
    ecosystemMallAppDlQrOpen: 'ダウンロードページを開く',
    ecosystemMallAppDlShots: 'プレビュー',
    ecosystemMallAppDlShotVoice: '話して抽出',
    ecosystemMallAppDlShotTopo: 'Leo → SOC → 機器',
    ecosystemMallAppDlShotLife: '暮らしの人機',
    ecosystemMallAppDlShotWork: '店の仕事',
    ecosystemMallAppDlAbout: 'このアプリについて',
    ecosystemMallAppDlAboutBody: 'Leo は人機の暮らしのスマホ入口です。話せば店の機械が動きます。スマホは SOC に、SOC は茶機・コーヒー機・出杯ラインにつながります。チャットボットの一覧ではなく、生活・仕事・商売が一本の位相です。',
    ecosystemMallAppDlFeatTalk: '話して抽出、状態確認、機械と会話',
    ecosystemMallAppDlFeatTopo: '三位一体：スマホ Leo → SOC 中枢 → 店内機器',
    ecosystemMallAppDlFeatLife: '注文・店員の仕事・店長の運営、人機が同席',
    ecosystemMallAppDlFeatOta: 'インストール包はこの区の OTA と同じ帳本。公開すれば直装も追従',
    ecosystemMallAppDlWhatsNew: '新着',
    ecosystemMallAppDlWhatsNewBody: 'この区は {ver} を公開済み。更新確認と同じ包です。',
    ecosystemMallAppDlWhatsNewEmpty: 'お客様向けパッケージはまだありません。',
    ecosystemMallAppDlInfo: '情報',
    ecosystemMallAppDlInfoDev: '開発元',
    ecosystemMallAppDlInfoPkg: 'パッケージ名',
    ecosystemMallAppDlInfoAge: '年齢区分',
    ecosystemMallAppDlAgeVal: '4+',
    ecosystemMallSocOps: '運営ストア',
    ecosystemMallPortraits: '顧客ペルソナ',
    ecosystemMallPortraitsDesc: '企業を設備ベンダー／運営者に分類し、規模・運用・ライフサイクルで精緻販促します。',
    ecosystemMallPortraitsStatsTitle: 'ペルソナ統計',
    ecosystemMallPortraitsStatEntTotal: '企業数',
    ecosystemMallPortraitsStatUserTotal: 'ユーザー数',
    ecosystemMallPortraitsChartType: '企業 · タイプ分布',
    ecosystemMallPortraitsChartBrand: '企業 · ブランド樹',
    ecosystemMallPortraitsChartHabit: '企業 · 利用ドメイン',
    ecosystemMallPortraitsChartLifecycle: '企業 · ライフサイクル',
    ecosystemMallPortraitsKpiOverrideRate: '上書き率 I-1',
    ecosystemMallPortraitsColHabit: '習慣Top',
    ecosystemMallPortraitsColCommercial: '商業2類',
    ecosystemMallPortraitsColScale: '規模(機/店/活)',
    ecosystemMallPortraitsColLifecycle: 'ライフサイクル',
    ecosystemMallPortraitsCommercialFilter: '商業画像',
    ecosystemMallPortraitsLifecycleFilter: 'ライフサイクル',
    ecosystemMallPortraitsCommercialVendor: '設備ベンダー',
    ecosystemMallPortraitsCommercialChain: '実店舗チェーン',
    ecosystemMallPortraitsLifecycleChampion: 'チャンピオン',
    ecosystemMallPortraitsLifecycleGrowing: '成長',
    ecosystemMallPortraitsLifecycleStable: '安定',
    ecosystemMallPortraitsLifecycleAtRisk: '離脱リスク',
    ecosystemMallPortraitsLifecycleDormant: '休眠',
    ecosystemMallPortraitsScaleSummary: '機{eq}／店{kids}／活{days}日',
    ecosystemMallPortraitsExplainTitle: 'なぜこの分類か',
    ecosystemMallPortraitsHabitProduce: '出品/配方',
    ecosystemMallPortraitsHabitMaterial: '物料BOM',
    ecosystemMallPortraitsHabitDevice: '設備',
    ecosystemMallPortraitsHabitAfterSales: 'アフター',
    ecosystemMallPortraitsHabitData: 'データ分析',
    ecosystemMallPortraitsHabitStore: '店舗業務',
    ecosystemMallPortraitsHabitHq: '本部組織',
    ecosystemMallPortraitsHabitMonetization: '課金',
    ecosystemMallPortraitsHabitOther: 'その他',
    ecosystemMallPortraitsTabEnterprise: '企業',
    ecosystemMallPortraitsTabUser: 'ユーザー',
    ecosystemMallPortraitsTypeFilter: 'タイプ',
    ecosystemMallPortraitsStatusFilter: 'SOCテナント',
    ecosystemMallPortraitsBrandCtxFilter: 'ブランド樹',
    ecosystemMallPortraitsColBrandCtx: 'ブランド樹',
    ecosystemMallPortraitsStatusOemSelf: '設備メーカー自身',
    ecosystemMallPortraitsStatusDistSelf: '代理店自身',
    ecosystemMallPortraitsStatusSocBrand: '独立SOCブランド',
    ecosystemMallPortraitsStatusDeviceCust: '設備メーカー配下顧客',
    ecosystemMallPortraitsStatusUnknown: '不明',
    ecosystemMallPortraitsBrandCtxRoot: 'ルート／独立',
    ecosystemMallPortraitsBrandCtxPhysical: '店舗チェーン配下',
    ecosystemMallPortraitsBrandCtxOem: '設備メーカー配下',
    ecosystemMallPortraitsTypeOem: '設備メーカー',
    ecosystemMallPortraitsLeoXidInstalled: 'Leo App · インストール済 X-ID',
    ecosystemMallPortraitsLeoXidActive30d: 'Leo App · 30日アクティブ X-ID',
    ecosystemMallPortraitsColLeoApp: 'Leo App',
    ecosystemMallPortraitsLeoStatusActive: '30日アクティブ',
    ecosystemMallPortraitsLeoStatusInstalled: 'インストール済',
    ecosystemMallPortraitsLeoStatusNotInstalled: '未インストール',
    ecosystemMallPortraitsLeoEntSummary: 'インストール {installed} · アクティブ {active}',
    ecosystemMallPortraitsLeoAppFilter: 'Leo App 状態',
    ecosystemMallPortraitsLeoPushBannerTitle: '既存顧客ラウンド1：Leo モバイル智能アシスタント',
    ecosystemMallPortraitsLeoPushBannerDesc: '未インストールの顧客がいます。アプリダウンロードから同僚に共有してください。',
    ecosystemMallPortraitsLeoPushCta: 'アプリダウンロードへ',
    ecosystemMallAppDlSmartTitle: 'Leo モバイル智能アシスタント',
    ecosystemMallAppDlShareColleague: '同僚に共有',
    ecosystemMallAppDlShareOk: '共有カード準備完了',
    ecosystemMallAppDlShareFail: '共有に失敗しました',
    ecosystemMallPortraitsTypeDistributor: '代理店',
    ecosystemMallPortraitsTypePhysical: '店舗チェーン',
    ecosystemMallPortraitsReload: '再読込',
    ecosystemMallPortraitsRecompute: '再計算',
    ecosystemMallPortraitsRecomputeOk: '再計算完了',
    ecosystemMallPortraitsRecomputeFail: '再計算失敗',
    ecosystemMallPortraitsLoadFail: '読込失敗',
    ecosystemMallPortraitsColName: '企業名',
    ecosystemMallPortraitsColAccount: 'アカウント',
    ecosystemMallPortraitsColEnterpriseId: '企業ID',
    ecosystemMallPortraitsColType: 'タイプ',
    ecosystemMallPortraitsColStatus: 'SOCテナント',
    ecosystemMallPortraitsColConfidence: '信頼度',
    ecosystemMallPortraitsColComputed: '計算時刻',
    ecosystemMallPortraitsColActions: '操作',
    ecosystemMallPortraitsSignals: 'シグナル',
    ecosystemMallPortraitsOverride: '上書き',
    ecosystemMallPortraitsOverrideOk: '上書きしてロック済み',
    ecosystemMallPortraitsOverrideOkDetail: '「{type}」にロックしました（「タイプ」列を確認。OEM／販社は商業列ではどちらも機器商）',
    ecosystemMallPortraitsOverrideFail: '上書き失敗',
    ecosystemMallPortraitsLocked: 'ロック中',
    ecosystemMallPortraitsUnlock: '解除',
    ecosystemMallPortraitsUnlockConfirm: '解除後は組織基準で再計算します。よろしいですか？',
    ecosystemMallPortraitsUnlockOk: '解除して再計算しました',
    ecosystemMallPortraitsUnlockFail: '解除失敗',
    ecosystemMallPortraitsColDeviceMode: '端末利用',
    ecosystemMallPortraitsDeviceModeFilter: '端末利用',
    ecosystemMallPortraitsDeviceNoFleet: '端末なし',
    ecosystemMallPortraitsDeviceIdle: '遊休多い',
    ecosystemMallPortraitsDeviceOffline: 'オフライン偏重',
    ecosystemMallPortraitsDeviceLowOut: '接続・低出力',
    ecosystemMallPortraitsDeviceHigh: '高稼働',
    ecosystemMallPortraitsDeviceOps: '運用偏重',
    ecosystemMallPortraitsDeviceFault: '故障注意',
    ecosystemMallPortraitsDeviceBalanced: 'バランス',
    ecosystemMallPortraitsAdvice: '提案',
    ecosystemMallPortraitsAdviceTitle: '端末提案（実行可能）',
    ecosystemMallPortraitsAdviceNext: '次の一手：',
    ecosystemMallPortraitsKpiAdviceP1: '優先提案数',
    ecosystemMallPortraitsDeviceUsageSummary: 'オンライン {online}/{eq} · 杯数 {cups} · 運用 {ops} · 遊休 {idle}',
    ecosystemMallImmersivePromo: '没入プロモ',
    ecosystemMallAdOrchestrate: '広告編成',
    ecosystemMallPromoContent: '販促コンテンツ',
    ecosystemMallCompanyPay: '自社入金',
    ecosystemMallCompanyPayDesc: '海外は Stripe 主・PayPal 併用、国内は WeChat 別線。App／公式／アドオン売上は自社口座へ。Stub は実入金ではありません。',
    ecosystemMallCompanyPayReload: '再読込',
    ecosystemMallCompanyPayChannel: '経路',
    ecosystemMallCompanyPayOrderNo: '注文番号',
    ecosystemMallCompanyPaySku: 'SKU',
    ecosystemMallCompanyPayName: '名称',
    ecosystemMallCompanyPayAmount: '金額',
    ecosystemMallCompanyPayStatus: '状態',
    ecosystemMallCompanyPayEmail: 'Email',
    ecosystemMallCompanyPayTracking: '追跡番号',
    ecosystemMallCompanyPayAction: '操作',
    ecosystemMallCompanyPayShip: '発送',
    ecosystemMallCompanyPayLedger: 'PayPal台帳',
    ecosystemMallCompanyPayIntent: '台帳番号',
    ecosystemMallCompanyPaySurface: '面',
    ecosystemMallCompanyPayRef: '本地ID',
    ecosystemMallCompanyPayTime: '時刻',
    ecosystemMallCompanyPayCarrier: '運送会社',
    ecosystemMallCompanyPayCancel: '取消',
    ecosystemMallCompanyPayShipOk: '発送確定',
    ecosystemMallHomeCheckoutTitle: '家庭向けチェックアウト',
    ecosystemMallHomeCheckoutDesc: '商品を選び、配送先を入力し、PayPal で安全にお支払いください。完了後、確認メールをお送りします。',
    ecosystemMallHomeCheckoutBackTopology: 'トポロジーへ',
    ecosystemMallHomeCheckoutReload: '再読込',
    ecosystemMallHomeCheckoutNextAddress: '次へ：配送先',
    ecosystemMallHomeCheckoutBackSku: '商品へ戻る',
    ecosystemMallHomeCheckoutPlaceOrder: '注文を確定',
    ecosystemMallHomeCheckoutPayStripe: 'Stripeで支払う',
    ecosystemMallHomeCheckoutPayPaypal: 'PayPalで支払う',
    ecosystemMallHomeCheckoutCapture: '支払い確認（テスト）',
    ecosystemMallHomeCheckoutCaptureLive: 'PayPal支払いを完了しました',
    ecosystemMallHomeCheckoutBuyPanel: '今すぐ購入',
    ecosystemMallHomeCheckoutEmptyCatalog: '購入可能な商品がありません。しばらくしてからお試しください。',
    ecosystemMallHomeCheckoutSku: '商品',
    ecosystemMallHomeCheckoutQty: '数量',
    ecosystemMallHomeCheckoutName: '受取人',
    ecosystemMallHomeCheckoutPhone: '電話',
    ecosystemMallHomeCheckoutEmail: 'Email',
    ecosystemMallHomeCheckoutAddress: '住所',
    ecosystemMallHomeCheckoutCity: '市区',
    ecosystemMallHomeCheckoutPostal: '郵便番号',
    ecosystemMallHomeCheckoutCountry: '国',
    ecosystemMallHomeCheckoutPayChannel: '支払方法',
    ecosystemMallHomeCheckoutOrderLine: '注文 {no} · {status} · {amount}',
    ecosystemMallHomeCheckoutStubNote: 'テストモード（管理者のみ）。実決済ではありません。',
    ecosystemMallHomeCheckoutStripeDefaultHint: '海外は Stripe が既定（PayPal も選択可）',
    ecosystemMallHomeCheckoutStripeTabHint: 'Stripe のウィンドウで支払い後、注文／メールで確認できます。',
    ecosystemMallHomeCheckoutStripeOpened: 'Stripe を開きました。そちらで支払いを完了してください',
    ecosystemMallHomeCheckoutPaypalTabHint: 'PayPal のウィンドウで支払い後、「PayPal支払いを完了しました」を押してください。',
    ecosystemMallHomeCheckoutBuyAgain: 'もう一台買う',
    ecosystemMallHomeCheckoutHqOrders: '注文台帳（本部）',
    ecosystemMallHomeCheckoutNoOrders: '注文なし',
    ecosystemMallHomeCheckoutWechat: 'WeChat Pay',
    ecosystemMallHomeCheckoutStepSku: '商品',
    ecosystemMallHomeCheckoutStepAddress: '住所',
    ecosystemMallHomeCheckoutStepPay: '支払',
    ecosystemMallHomeCheckoutStepDone: '完了',
    ecosystemMallHomeCheckoutCoachSku: '購入する商品を選んでください',
    ecosystemMallHomeCheckoutCoachAddress: '配送情報を入力',
    ecosystemMallHomeCheckoutCoachPay: '支払いを完了',
    ecosystemMallHomeCheckoutCoachDone: '支払い済み',
    ecosystemMallHomeCheckoutHintSku: '商品カードを選んで続けます。',
    ecosystemMallHomeCheckoutHintAddress: 'Email は注文確認と PayPal に使います。',
    ecosystemMallHomeCheckoutHintPay: 'PayPal で支払い、完了後に戻って確認してください。',
    ecosystemMallHomeCheckoutNeedSku: '先に商品を選んでください',
    ecosystemMallHomeCheckoutCatalogFail: '商品を読み込めませんでした。再試行してください。',
    ecosystemMallHomeCheckoutSkuNoPrice: 'この商品はまだ価格がありません。意向を残して相談するか、別の商品を選んでください。',
    ecosystemMallHomeCheckoutHqFail: '台帳読込失敗（一般ユーザーは無視可）',
    ecosystemMallHomeCheckoutNeedName: '受取人名が必要',
    ecosystemMallHomeCheckoutNeedPhone: '電話が必要',
    ecosystemMallHomeCheckoutNeedEmail: '有効な Email が必要',
    ecosystemMallHomeCheckoutNeedAddress: '住所が必要',
    ecosystemMallHomeCheckoutNeedCity: '市区が必要',
    ecosystemMallHomeCheckoutNeedCountry: '国が必要',
    ecosystemMallHomeCheckoutNeedLogin: 'チェックアウトにはログインが必要です',
    ecosystemMallHomeCheckoutOrderCreated: '注文を作成しました。支払いへ進んでください',
    ecosystemMallHomeCheckoutOrderFail: '注文を作成できませんでした。内容を確認して再試行してください',
    ecosystemMallHomeCheckoutNeedOrder: '先に注文してください',
    ecosystemMallHomeCheckoutPaypalStub: 'テスト用 PayPal 準備完了（管理者）',
    ecosystemMallHomeCheckoutPaypalOpened: 'PayPal を開きました。そちらで支払いを完了してください',
    ecosystemMallHomeCheckoutPayFail: '支払いを開始できません。しばらくして再試行してください',
    ecosystemMallHomeCheckoutPaid: 'お支払いを受領しました。ありがとうございます！',
    ecosystemMallHomeCheckoutPaidThanks: '注文 {no} は支払い済みです。{email} に確認メールを送信しました。発送後もご連絡します。',
    ecosystemMallHomeCheckoutStatusPaid: '支払い済み',
    ecosystemMallHomeCheckoutStatusPending: '支払い待ち',
    ecosystemMallHomeCheckoutStatusShipped: '発送済み',
    ecosystemMallHomeCheckoutCaptureFail: 'まだ支払いを確認できません。PayPal で支払済みなら、少し待って再試行してください。',
    ecosystemMallHomeCheckoutWechatFail: 'WeChat Pay を開始できません',
    ecosystemMallHomeCheckoutNeedTracking: '追跡番号が必要',
    ecosystemMallHomeCheckoutShipFail: '発送失敗',
    ecosystemMallCompanyPayLive: 'PayPal 資格情報が設定済み（sandbox／live）',
    ecosystemMallCompanyPayLiveMode: 'PayPal Live — 実入金',
    ecosystemMallCompanyPaySandboxMode: 'PayPal Sandbox — テスト',
    ecosystemMallCompanyPayStub: '現在は stub（実入金ではない）',
    ecosystemMallCompanyPayLoadFail: '読込失敗（管理者権限が必要）',
    ecosystemMallCompanyPayNeedTracking: '追跡番号を入力',
    ecosystemMallCompanyPayShipped: '発送済みに更新',
    ecosystemMallCompanyPayShipFail: '発送失敗',
    ecosystemMallCompanyPayEmptyOrders: '??????',
    ecosystemMallCompanyPayEmptyLedger: '??????',
    ecosystemMallCompanyPayStubCol: 'stub?',
    ecosystemMallCompanyPayStubYes: '???stub?',
    ecosystemMallCompanyPayKindHome: '??? App',
    ecosystemMallCompanyPayKindWebsite: '?????',
    ecosystemMallCompanyPayStatusPending: '???',
    ecosystemMallCompanyPayStatusPaid: '???',
    ecosystemMallCompanyPayStatusShipped: '???',
    ecosystemMallCompanyPayStatusDelivered: '???',
    ecosystemMallCompanyPayStatusBound: '???',
    ecosystemMallCompanyPayStatusCancelled: '??',
    ecosystemMallCompanyPayIntentCreated: '???',
    ecosystemMallCompanyPayIntentApproved: '???',
    ecosystemMallCompanyPayIntentCaptured: '???',
    ecosystemMallCompanyPayIntentCapturedStub: 'stub ??',
    ecosystemMallCompanyPayIntentFailed: '??',
    ecosystemMallCompanyPaySurfaceHome: '????',
    ecosystemMallCompanyPaySurfaceWebsite: '????',
    ecosystemMallCompanyPaySurfaceAddon: 'SOC ????',
    ecosystemMallCompanyPaySurfacePlan: '???????',
    ecosystemMallCompanyPaySurfaceContract: '??????',
    ecosystemMallPriceBook: '価格表',
    ecosystemMallBillingPromo: '課金プロモ',
    ecosystemMallBillingPromoDesc: 'ブランド向け課金プロモを定義し、指定ブランドへクーポンを発行します。標価は価格表のまま、クーポンは決済時のみ値引きされます。',
    ecosystemMallBillingPromoHqOnly: '課金プロモは本部専用です。ブランドは「サービス契約」から契約と支払いを確認してください。',
    ecosystemMallBillingPromoReload: '再読込',
    ecosystemMallBillingPromoNewCampaign: '新規プロモ',
    ecosystemMallBillingPromoNlCompose: '口語で作成',
    ecosystemMallBillingPromoNlComposeTitle: '自然言語でプロモ記述',
    ecosystemMallBillingPromoNlComposeHint: '例：ブランド1119のアドオンTrack Bで1000元引き、発行後30日有効。保存前にフォームで確認してください。',
    ecosystemMallBillingPromoNlComposePh: 'オファー・対象・利用先・有効期間を記述…',
    ecosystemMallBillingPromoNlComposeParse: '解析プレビュー',
    ecosystemMallBillingPromoNlComposeApply: 'フォームへ反映',
    ecosystemMallBillingPromoNlComposeSummary: '解析概要',
    ecosystemMallBillingPromoNlComposeConfidence: '信頼度',
    ecosystemMallBillingPromoNlComposeWarnings: '要確認',
    ecosystemMallBillingPromoEditCampaign: 'プロモ編集',
    ecosystemMallBillingPromoTabCampaigns: 'プロモーション',
    ecosystemMallBillingPromoTabCoupons: '発行済クーポン',
    ecosystemMallBillingPromoColName: 'プロモ名',
    ecosystemMallBillingPromoColKind: 'プロモ種別',
    ecosystemMallBillingPromoColOffer: '値引方式',
    ecosystemMallBillingPromoColAudience: '対象ブランド',
    ecosystemMallBillingPromoColStatus: '状態',
    ecosystemMallBillingPromoColCouponCode: 'クーポン番号',
    ecosystemMallBillingPromoColCampaign: 'プロモーション',
    ecosystemMallBillingPromoColIssued: '発行日時',
    ecosystemMallBillingPromoActivate: '有効化',
    ecosystemMallBillingPromoPause: '一時停止',
    ecosystemMallBillingPromoIssue: 'クーポン発行',
    ecosystemMallBillingPromoRevoke: '取消',
    ecosystemMallBillingPromoManualIssue: '手動発行',
    ecosystemMallBillingPromoBrandId: 'ブランド',
    ecosystemMallBillingPromoBrandIdPh: 'ブランド ID を入力',
    ecosystemMallBillingPromoBrandIds: '指定ブランド',
    ecosystemMallBillingPromoBrandIdsHint: '複数 ID はカンマ区切り',
    ecosystemMallBillingPromoFilterCampaign: 'プロモで絞込',
    ecosystemMallBillingPromoFilterStatus: '状態で絞込',
    ecosystemMallBillingPromoSearch: '検索',
    ecosystemMallBillingPromoOfferPct: '割引率（%）',
    ecosystemMallBillingPromoCampaignValidity: 'プロモ有効期間',
    ecosystemMallBillingPromoCouponValidity: 'クーポン有効期間',
    ecosystemMallBillingPromoRelativeDays: '発行後の有効日数',
    ecosystemMallBillingPromoNamePh: '例：新規顧客20%オフ',
    ecosystemMallBillingPromoNameRequired: 'プロモ名を入力してください',
    ecosystemMallBillingPromoEmpty: 'データがありません',
    ecosystemMallBillingPromoSaved: '保存しました',
    ecosystemMallBillingPromoIssued: 'クーポンを発行しました',
    ecosystemMallBillingPromoRevoked: 'クーポンを取消しました',
    ecosystemMallBillingPromoStatusUpdated: 'プロモ状態を更新しました',
    ecosystemMallBillingPromoEnum_status_ALL: 'すべて',
    ecosystemMallBillingPromoEnum_status_DRAFT: '下書き',
    ecosystemMallBillingPromoEnum_status_ACTIVE: '実施中',
    ecosystemMallBillingPromoEnum_status_PAUSED: '一時停止',
    ecosystemMallBillingPromoEnum_status_ARCHIVED: 'アーカイブ',
    ecosystemMallBillingPromoEnum_status_EXPIRED: '期限切れ',
    ecosystemMallBillingPromoEnum_couponStatus_ALL: 'すべて',
    ecosystemMallBillingPromoEnum_couponStatus_ISSUED: '発行済',
    ecosystemMallBillingPromoEnum_couponStatus_REDEEMED: '利用済',
    ecosystemMallBillingPromoEnum_couponStatus_EXPIRED: '期限切れ',
    ecosystemMallBillingPromoEnum_couponStatus_REVOKED: '取消済',
    ecosystemMallBillingPromoEnum_kind_STANDARD_PACK: '標準パッケージ',
    ecosystemMallBillingPromoEnum_kind_SEASONAL: '期間限定',
    ecosystemMallBillingPromoEnum_kind_TARGETED: '重点顧客向け',
    ecosystemMallBillingPromoEnum_kind_AI_ORCHESTRATED: 'スマートプロモ',
    ecosystemMallBillingPromoEnum_offer_DISCOUNT_PCT: '割引率',
    ecosystemMallBillingPromoEnum_offer_DISCOUNT_FIXED: '定額値引',
    ecosystemMallBillingPromoEnum_offer_BUNDLE_PRICE_CAP: 'バンドル上限価格',
    ecosystemMallBillingPromoEnum_offer_FREE_TRIAL_EXTEND: '試用延長',
    ecosystemMallBillingPromoEnum_offer_CROSS_GRANT: 'クロスクーポン',
    ecosystemMallBillingPromoEnum_offer_AI_POINTS_BONUS: 'AIポイント付与',
    ecosystemMallBillingPromoEnum_audience_ALL_ELIGIBLE_BRANDS: '対象ブランドすべて',
    ecosystemMallBillingPromoEnum_audience_BRAND_ALLOWLIST: '許可リスト',
    ecosystemMallBillingPromoEnum_audience_BRAND_DENYLIST: '拒否リスト除外',
    ecosystemMallBillingPromoEnum_audience_PORTRAIT_QUERY: '顧客像で絞込',
    ecosystemMallBillingPromoEnum_audience_AI_AGENT: 'スマート選定',
    ecosystemMallBillingPromoEnum_audience_HYBRID: 'ルール＋スマート',
    ecosystemMallBillingPromoEnum_campaignValidity_PERMANENT: '恒久的',
    ecosystemMallBillingPromoEnum_campaignValidity_FIXED_WINDOW: '指定期間',
    ecosystemMallBillingPromoEnum_couponValidity_PERMANENT_UNTIL_REDEEMED: '利用まで有効',
    ecosystemMallBillingPromoEnum_couponValidity_RELATIVE_FROM_ISSUE: '発行後 N 日',
    ecosystemMallBillingPromoEnum_couponValidity_INHERIT_CAMPAIGN: 'プロモに準拠',
    ecosystemMallBillingPromoSectionOffer: 'オファー設定',
    ecosystemMallBillingPromoSectionAudience: '精密ターゲット',
    ecosystemMallBillingPromoSectionCrossSell: 'クロスセル',
    ecosystemMallBillingPromoRedeemTarget: '利用可能範囲',
    ecosystemMallBillingPromoGrantScope: 'クーポン紐付け',
    ecosystemMallBillingPromoTriggerEvent: '自動トリガー',
    ecosystemMallBillingPromoAutoIssue: '条件達成で自動発行',
    ecosystemMallBillingPromoTracksMissing: '未契約ライン（クロスセル）',
    ecosystemMallBillingPromoUserIds: '指定アカウント',
    ecosystemMallBillingPromoUserIdsHint: 'ユーザー ID をカンマ区切り（1:1 パーソナル）',
    ecosystemMallBillingPromoColGrantScope: '紐付け範囲',
    ecosystemMallBillingPromoColUser: '指定アカウント',
    ecosystemMallBillingPromoColRedeemTarget: '利用先',
    ecosystemMallBillingPromoUserIdPh: 'ユーザー ID（任意）',
    ecosystemMallBillingPromoOfferFixed: '定額値引',
    ecosystemMallBillingPromoTrialDays: '試用延長（日）',
    ecosystemMallBillingPromoBonusPoints: 'AI ポイント付与',
    ecosystemMallBillingPromoBundleCap: 'バンドル上限価格',
    ecosystemMallBillingPromoBundleSkus: 'バンドル SKU',
    ecosystemMallBillingPromoCrossGrantSku: 'クロス付与 SKU',
    ecosystemMallBillingPromoCrossGrantHint: '例：Track B 契約後にデバイス／Leo 加購クーポン',
    ecosystemMallBillingPromoEnum_audience_USER_ALLOWLIST: 'アカウント許可リスト',
    ecosystemMallBillingPromoEnum_redeemTarget_ANY_BILLING_CHECKOUT: '統合決済',
    ecosystemMallBillingPromoEnum_redeemTarget_TRACK_A_CONTRACT: 'Track A デバイス契約',
    ecosystemMallBillingPromoEnum_redeemTarget_TRACK_B_ADDON: 'Track B SOC／Leo 加購',
    ecosystemMallBillingPromoEnum_redeemTarget_HARDWARE_ORDER: 'ハードウェア注文',
    ecosystemMallBillingPromoEnum_grantScope_BRAND: 'ブランド共有',
    ecosystemMallBillingPromoEnum_grantScope_ENTERPRISE_NODE: '組織ノード',
    ecosystemMallBillingPromoEnum_grantScope_STORE: '単店舗',
    ecosystemMallBillingPromoEnum_grantScope_USER: '指定アカウント専用',
    ecosystemMallBillingPromoEnum_grantScope_PORTRAIT_COHORT: 'ペルソナ cohort',
    ecosystemMallBillingPromoEnum_trigger_MANUAL_HQ: 'HQ 手動',
    ecosystemMallBillingPromoEnum_trigger_TRACK_A_ACTIVE: 'Track A 契約有効',
    ecosystemMallBillingPromoEnum_trigger_TRACK_B_ACTIVE: 'Track B 加購有効',
    ecosystemMallBillingPromoEnum_trigger_HARDWARE_PAID: 'ハード支払完了',
    ecosystemMallBillingPromoEnum_trigger_AI_ISSUE: 'スマートプロモ発行',
    ecosystemMallBillingPromoEnum_tracksMissing_TRACK_A: 'Track A 未契約',
    ecosystemMallBillingPromoEnum_tracksMissing_TRACK_B: 'Track B 未契約',
    mySubscriptionPlan: 'マイプラン',
    mySubscriptionPlanDesc: '契約済みプラン概要と A/B ライン。契約・支払いは契約デスク、価格・プロモはエコシステムモール。',
    mySubscriptionPlanGoContract: '契約デスクを開く',
    mySubscriptionPlanGoMall: 'モールで価格を見る',
    mySubscriptionPlanGoPriceBook: 'HQ 価格表',
    mySubscriptionPlanTiersTitle: '4段階月額（USD）',
    mySubscriptionPlanTierCol: '段',
    mySubscriptionPlanSceneCol: '用途',
    mySubscriptionPlanPriceCol: '月額',
    mySubscriptionPlanTrackCol: 'Track',
    mySubscriptionPlanTier1Scene: 'SOC のみ（自動生産設備なし）',
    mySubscriptionPlanTier2Scene: '店舗パック（SOC + 全自動設備・台数無制限）',
    mySubscriptionPlanTier3Scene: '設備データのみ（SOC 店舗運営なし）',
    mySubscriptionPlanTier3Price: '台あたり月額（茶/コーヒー/ドリンク $10、PT5 $5）',
    mySubscriptionPlanTier4Scene: 'SOC + 設備（$199 パック以外）',
    mySubscriptionPlanHint: '② と ④ は同一店舗で排他。契約は契約デスク、標価・プロモはモールが正。',
    subscriptionBillingFolder: '契約・請求',
    deviceEndpointDataFolder: '端末データ',
    mallPricingCollectFolder: '価格・決済',
    ecosystemMallPriceBookDesc: '建値の真源。未税価格／税区は東京HQのみ編集可。エッジは読取専用ミラー。PayPal は USD、WeChat は CNY。',
    ecosystemMallPriceBookEdgeBanner: '建値は東京HQで世界統一。このノードは読取専用ミラーです。東京停止時は最後の扇出を販売に使い、ここで追加・改価は禁止です。',
    ecosystemMallPriceBookTokyoBanner: 'ここがグローバル書込中心です。未税建値／税区を保存すると111と追随リージョンへ扇出されます。',
    ecosystemMallPriceBookReload: '再読込',
    ecosystemMallPriceBookRefreshFx: '為替更新',
    ecosystemMallPriceBookFxNote: '為替 {asOf} · {src}（1 USD）',
    ecosystemMallPriceBookFxTaxPanel: '為替・税区 · {fx} · 税区 {taxCount} 件',
    ecosystemMallPriceBookFxSection: 'USD 為替',
    ecosystemMallPriceBookStale: '為替が 48 時間以上未更新です。更新するか日次取得を待ってください',
    ecosystemMallPriceBookCoverageGap: '価格表で未定价の機能/設備が {count} 件あります（OFF/単価なし）。契約・追加購入はブロックされます。HQ で単価設定と有効化をしてください。',
    ecosystemMallPriceBookCcy: '通貨',
    ecosystemMallPriceBookRatePerUsd: '対 1 USD',
    ecosystemMallPriceBookSkus: 'SKU 建値',
    ecosystemMallPriceBookKind: '区分',
    ecosystemMallPriceBookSku: 'SKU',
    ecosystemMallPriceBookName: '名称',
    ecosystemMallPriceBookList: '建値',
    ecosystemMallPriceBookListExTax: '建値（税抜）',
    ecosystemMallPriceBookExTaxBanner: 'グローバル税抜建値は1セット。各国税率は税区で管理し、見積時に加算します。',
    ecosystemMallPriceBookTaxRegions: '税区（現地加算）',
    ecosystemMallPriceBookTaxRegionsHint: '価格表は税抜。CN=ソフト6%、CN_HW=ハード13%。契約台で税区を選ぶと加算されます。',
    ecosystemMallPriceBookTaxRegionCode: '税区コード',
    ecosystemMallPriceBookTaxRegionName: '名称',
    ecosystemMallPriceBookTaxName: '税種',
    ecosystemMallPriceBookTaxRate: '税率',
    ecosystemMallPriceBookTaxNotes: '備考',
    ecosystemMallPriceBookTaxEditTitle: '税区を編集',
    ecosystemMallPriceBookLoadFail: '読込失敗（管理者権限が必要）',
    ecosystemMallPriceBookRefreshOk: '為替を更新しました',
    ecosystemMallPriceBookRefreshFail: '為替更新に失敗',
    ecosystemMallPriceBookAdd: '追加',
    ecosystemMallPriceBookEdit: '編集',
    ecosystemMallPriceBookSave: '保存',
    ecosystemMallPriceBookSaveOk: '保存しました',
    ecosystemMallPriceBookSaveFail: '保存に失敗',
    ecosystemMallPriceBookKindAddon: 'アドオン',
    ecosystemMallPriceBookKindHome: '家庭用ハード',
    ecosystemMallPriceBookKindCommercial: '商用ハード',
    ecosystemMallPriceBookListCcy: '建値通貨',
    ecosystemMallPriceBookListedHkd: 'カタログ HKD',
    ecosystemMallPriceBookColumnPricing: '課金',
    ecosystemMallPriceBookPricingSection: '課金方式',
    ecosystemMallPriceBookPaymentSection: '支払テンプレ',
    ecosystemMallPriceBookProductClass: '製品クラス',
    ecosystemMallPriceBookProductSoc: 'SOC ソフト',
    ecosystemMallPriceBookProductDeviceData: 'デバイスデータ',
    ecosystemMallPriceBookProductHardware: 'ハードウェア',
    ecosystemMallPriceBookProductAiPoints: 'AI ポイント',
    ecosystemMallPriceBookBillingCycle: '課金周期',
    ecosystemMallPriceBookUnitPrice: '単価',
    ecosystemMallPriceBookMinContractMonths: '最低契約月数',
    ecosystemMallPriceBookDayCountHint: '日額従量',
    ecosystemMallPriceBookDayCountHintBody: '契約時に利用日数を入力。価格表は日単価のみ。',
    ecosystemMallPriceBookTiers: '段階価格',
    ecosystemMallPriceBookDeviceCountTiers: '台数段階割引',
    ecosystemMallPriceBookDeviceCountTiersHint: '単価は本行の定価。段階係数は底価に適用。単価未設定は 0。',
    ecosystemMallPriceBookDeviceCountTierBand: '段',
    ecosystemMallPriceBookDeviceCountTierMin: '最小台数',
    ecosystemMallPriceBookDeviceCountTierMax: '最大台数',
    ecosystemMallPriceBookDeviceCountTierDiscount: '割引係数',
    ecosystemMallPriceBookDeviceCountTierNegotiated: '本部協議',
    ecosystemMallPriceBookDeviceCountTierReset: '標準5段に戻す',
    ecosystemMallPriceBookStoreCountTiers: '店舗数ティア割引',
    ecosystemMallPriceBookStoreCountTiersHint: '1店舗単価はこの行の表示価格。割引はそれに対して適用。0店舗＝0円。',
    ecosystemMallPriceBookStoreCountTierBand: '段',
    ecosystemMallPriceBookStoreCountTierMin: '最小店舗',
    ecosystemMallPriceBookStoreCountTierMax: '最大店舗',
    ecosystemMallPriceBookStoreCountTierDiscount: '割引係数',
    ecosystemMallPriceBookStoreCountTierNegotiated: '本部協議',
    ecosystemMallPriceBookStoreCountTierReset: '標準5段に戻す',
    ecosystemMallPriceBookAddTier: '段階追加',
    ecosystemMallPriceBookRemoveTier: '削除',
    ecosystemMallPriceBookTrialDays: '試用日数',
    ecosystemMallPriceBookCancelAnytime: 'いつでも解約',
    ecosystemMallPriceBookDefaultPayment: '既定支払',
    ecosystemMallPriceBookPayNet: '掛け',
    ecosystemMallPriceBookPayPrepaid: '前払い',
    ecosystemMallPriceBookPayDeposit: '頭金+残金',
    ecosystemMallPriceBookPayInstallment: '分割',
    ecosystemMallPriceBookDepositPct: '頭金%',
    ecosystemMallPriceBookStatus: '状態',
    ecosystemMallPriceBookStatusActive: '有効',
    ecosystemMallPriceBookStatusOff: '停止',
    ecosystemMallPriceBookNameZh: '中国語名',
    ecosystemMallPriceBookNameTw: '繁体名',
    ecosystemMallPriceBookNameEn: '英語名',
    ecosystemMallPriceBookNameJa: '日本語名',
    ecosystemMallPriceBookCancel: 'キャンセル',
    ecosystemMallPriceBookFilterPreset: 'クイック絞込',
    ecosystemMallPriceBookPresentationTab: '顧客ブロック L0–L6',
    ecosystemMallPriceBookPresentationTabAll: 'すべて',
    ecosystemMallPriceBookBlock_FREE_INCLUDED: 'L0 · 同梱無料',
    ecosystemMallPriceBookBlock_BUNDLE_TIER: 'L1 · 月額プラン',
    ecosystemMallPriceBookBlock_TRACK_A: 'L2 · 端末データ',
    ecosystemMallPriceBookBlock_TRACK_B: 'L3 · 店舗運用',
    ecosystemMallPriceBookBlock_BUNDLE_DISCOUNT: 'L4 · 組合せルール',
    ecosystemMallPriceBookBlock_HARDWARE: 'L5 · ハードウェア',
    ecosystemMallPriceBookBlock_AI_POINTS: 'L6 · 従量ポイント',
    ecosystemMallPriceBookBlockDesc_FREE_INCLUDED: '機器購入／開店に含まれる：Leo 基本・基礎店務は月額追加なし。',
    ecosystemMallPriceBookBlockDesc_BUNDLE_TIER: '4 段階の月額プラン。顧客がプランを選び、下の SKU 标价と対応。',
    ecosystemMallPriceBookBlockDesc_TRACK_A: 'Track A · 端末あたりのデータ／クラウド月額。',
    ecosystemMallPriceBookBlockDesc_TRACK_B: 'Track B · 店舗／モジュール単位の SOC 加購。',
    ecosystemMallPriceBookBlockDesc_BUNDLE_DISCOUNT: 'プラン排他とアップグレード規則（② 全店 vs ④ SOC+端末）。',
    ecosystemMallPriceBookBlockDesc_HARDWARE: 'ハードウェア本体の一括価格（月額ではない）。',
    ecosystemMallPriceBookBlockDesc_AI_POINTS: 'AI ポイント等の従量パック。',
    ecosystemMallPriceBookBundleColTier: '段',
    ecosystemMallPriceBookBundleColPlan: 'プラン',
    ecosystemMallPriceBookBundleColScenario: 'シナリオ',
    ecosystemMallPriceBookBundleColIncludes: '含む内容',
    ecosystemMallPriceBookBundleT1Title: '① SOC のみ $49/店/月',
    ecosystemMallPriceBookBundleT1Desc: 'SOC 店務のみ、自動生産設備なし',
    ecosystemMallPriceBookBundleT1Includes: '標準 SOC；A 線端末データ不含',
    ecosystemMallPriceBookBundleT2Title: '② 全店パック $199/店/月',
    ecosystemMallPriceBookBundleT2Desc: '自動生産設備あり、台数無制限',
    ecosystemMallPriceBookBundleT2Includes: 'SOC + 当店の自動生産設備データ（台数無制限）',
    ecosystemMallPriceBookBundleT3Title: '③ 端末のみ従量',
    ecosystemMallPriceBookBundleT3Desc: 'クラウドのみ、SOC 店務パック不要',
    ecosystemMallPriceBookBundleT3Includes: 'A 線端末データ月額のみ',
    ecosystemMallPriceBookBundleT3PriceHint: '端末標準月額（右 SKU 参照）',
    ecosystemMallPriceBookBundleT4Title: '④ SOC $99 + 端末従量',
    ecosystemMallPriceBookBundleT4Desc: 'SOC と端末両方、$199 全店パック以外',
    ecosystemMallPriceBookBundleT4Includes: 'SOC $99/店/月 + 端末データ別途',
    ecosystemMallPriceBookBundleRuleT2T4Title: '② と ④ は同店で排他',
    ecosystemMallPriceBookBundleRuleT2T4Body: '同一店・同一期間は $199 全包 か $99+端末 のどちらか一方のみ。',
    ecosystemMallPriceBookBundleRuleUpgradeTitle: 'アップグレード',
    ecosystemMallPriceBookBundleRuleUpgradeBody: '① 後から自動生産設備 → ④ または ② へ；③ から SOC 追加 → ④ または ②。',
    ecosystemMallPriceBookBundleRulePromoTitle: '① プロモ価格',
    ecosystemMallPriceBookBundleRulePromoBody: '$49 はプロモ期間価格。終了後は標準価格（HQ 价目表に別途）。',
    ecosystemMallPriceBookBundleRuleDeviceScopeTitle: '② $199 の対象設備',
    ecosystemMallPriceBookBundleRuleDeviceScopeBody: '茶機・コーヒー・ドリンク・ブレンダー・Maestro 等を含む；kiosk／サイネージ／レジ等は不含。',
    ecosystemMallPriceBookQuoteSectionTab: '見積ブロック',
    ecosystemMallPriceBookQuoteTabAll: 'すべて',
    ecosystemMallPriceBookQuoteTabA: 'ブロック A · 端末データ',
    ecosystemMallPriceBookQuoteTabB: 'ブロック B · 店舗運用',
    ecosystemMallPriceBookQuoteTabC: 'ブロック C · バンドル',
    ecosystemMallPriceBookQuoteTabOther: 'ハード／ポイント',
    ecosystemMallPriceBookQuoteSectionCol: '見積セクション',
    ecosystemMallPriceBookQuoteSection_TRACK_A_DEVICE_DATA: 'A · 端末データ',
    ecosystemMallPriceBookQuoteSection_TRACK_B_STORE_OPS: 'B · 店舗',
    ecosystemMallPriceBookQuoteSection_TRACK_B_HQ: 'B · 本部',
    ecosystemMallPriceBookQuoteSection_TRACK_B_ANALYTICS: 'B · 分析',
    ecosystemMallPriceBookQuoteSection_TRACK_B_INTEGRATION: 'B · 連携',
    ecosystemMallPriceBookQuoteSection_TRACK_B_DEVICE_ADDON: 'B · 端末アドオン',
    ecosystemMallPriceBookQuoteSection_BUNDLE_FULL_STACK: 'C · 全店パック',
    ecosystemMallPriceBookQuoteSection_HARDWARE: 'ハード',
    ecosystemMallPriceBookQuoteSection_AI_POINTS: 'AI ポイント',
    ecosystemMallPriceBookQuoteSection_FREE_INCLUDED: '端末同梱',
    ecosystemMallPriceBookFilterSearch: '検索',
    ecosystemMallPriceBookFilterSearchPh: 'SKU／名称／キーワード',
    ecosystemMallPriceBookFilterSegment: 'セグメント',
    ecosystemMallPriceBookFilterSegmentAll: '全セグメント',
    ecosystemMallPriceBookSegmentHome: '家庭',
    ecosystemMallPriceBookSegmentCommercial: '商用',
    ecosystemMallPriceBookSegmentAll: '共通',
    ecosystemMallPriceBookFilterCategory: '製品ファミリ',
    ecosystemMallPriceBookFilterCategoryAll: '全ファミリ',
    ecosystemMallPriceBookCatHomeHardware: '家庭用ハード',
    ecosystemMallPriceBookCatHomeAddon: '家庭用アドオン',
    ecosystemMallPriceBookCatCommercialHardware: '商用ハード',
    ecosystemMallPriceBookCatCommercialStoreOps: '店舗オペ',
    ecosystemMallPriceBookCatCommercialHq: '本部マルチ店舗',
    ecosystemMallPriceBookCatCommercialIntegration: '決済連携',
    ecosystemMallPriceBookCatCommercialAiData: 'AI／分析',
    ecosystemMallPriceBookCatCommercialOther: 'その他商用',
    ecosystemMallPriceBookCatAiPoints: 'AIポイント',
    ecosystemMallPriceBookCatUniversal: '共通アドオン',
    ecosystemMallPriceBookCatOther: 'その他',
    ecosystemMallPriceBookFilterStatusAll: '全状態',
    ecosystemMallPriceBookFilterKindAll: '全区分',
    ecosystemMallPriceBookFilterCurrencyAll: '全通貨',
    ecosystemMallPriceBookFilterPricing: '課金方式',
    ecosystemMallPriceBookFilterPricingAll: '全課金',
    ecosystemMallPriceBookFilterPriceBand: '価格帯',
    ecosystemMallPriceBookFilterPriceBandAll: '全価格帯',
    ecosystemMallPriceBookPriceBandFree: '無料（0元）',
    ecosystemMallPriceBookPriceBandLow: 'エントリー（<500 CNY）',
    ecosystemMallPriceBookPriceBandMid: '標準（500–3000）',
    ecosystemMallPriceBookPriceBandHigh: 'プレミアム（>3000）',
    ecosystemMallPriceBookFilterClear: '絞込解除',
    ecosystemMallPriceBookFilterSelectAll: 'すべて',
    ecosystemMallPriceBookFilterClearAll: '解除',
    ecosystemMallPriceBookFilterMultiAll: 'すべて（複数）',
    ecosystemMallPriceBookFilterResult: '{shown}／{total} 件表示',
    ecosystemMallPriceBookPresetAll: 'すべて',
    ecosystemMallPriceBookPresetHomeHardware: '家庭用ハード',
    ecosystemMallPriceBookPresetHomeAddon: '家庭用アドオン',
    ecosystemMallPriceBookPresetCommercialHardware: '商用ハード',
    ecosystemMallPriceBookPresetCommercialSoftware: '商用ソフト',
    ecosystemMallPriceBookPresetAiPoints: 'AIポイント',
    ecosystemMallPriceBookPresetActiveOnly: '有効のみ',
    ecosystemMallPriceBookColumnSegment: 'セグメント',
    ecosystemMallPriceBookColumnCategory: 'ファミリ',
    ecosystemMallPriceBookPricingTrialThenPaid: '試用後課金',
    ecosystemMallPriceBookPricingAiPointsPack: 'AIポイント',
    ecosystemMallPriceBookPricingPerDeviceYear: '端末／年',
    ecosystemMallPriceBookPricingPerDeviceMonth: '端末／月',
    ecosystemMallPriceBookPricingPerDeviceDay: '端末／日（従量）',
    ecosystemMallPriceBookPricingPerDevicePeriod: '端末／期',
    ecosystemMallPriceBookPricingPerStoreMonth: '店舗／月',
    ecosystemMallPriceBookPricingPerStoreDay: '店舗／日（従量）',
    ecosystemMallPriceBookPricingTieredAnnualPool: '年額台数段階',
    ecosystemMallPriceBookPricingSocStoreSubscription: 'SOC店舗サブスク',
    ecosystemMallPriceBookDeviceScope: '課金範囲',
    ecosystemMallPriceBookDeviceFamily: 'デバイス族',
    ecosystemMallPriceBookModelKey: '型番キー',
    ecosystemMallPriceBookModelKeyPh: '例 PT5、X600H（族または型番、型番優先）',
    ecosystemMallPriceBookModelKeyShort: '型番 {key}',
    ecosystemMallPriceBookDeviceScopeHint: 'デバイスデータ料金は族または型番の指定が必須です。契約時に該当台数で計算されます。',
    ecosystemMallPriceBookDeviceScopeRequired: 'デバイス族または型番を入力してください',
    ecosystemMallPriceBookDeviceFamilyTeaMachine: 'ティーブリュワー',
    ecosystemMallPriceBookDeviceFamilyCoffeeMachine: 'コーヒーマシン',
    ecosystemMallPriceBookDeviceFamilyDispenser: 'ディスペンサー',
    ecosystemMallPriceBookDeviceFamilyKiosk: 'キオスク',
    ecosystemMallPriceBookDeviceFamilySignage: 'サイネージ',
    ecosystemMallPriceBookPricingPerStoreYear: '店舗／年',
    ecosystemMallPriceBookPricingPerHouseholdYear: '世帯／年',
    ecosystemMallPriceBookPricingOneTimeSku: '買切',
    ecosystemMallPriceBookPricingModuleAddon: 'モジュール',
    ecosystemMallPriceBookPricingCustomQuote: '見積',
    ecosystemMallCommerceMatrix: '商業マトリクス',
    ecosystemMallCommerceMatrixDesc: 'SKUドメイン、メニュー分類、価格と健全性。未分類ページはテナント非表示。',
    ecosystemMallCommerceMatrixEdgeBanner: 'ドメイン追加・紐付けは東京HQで世界統一。読取専用ミラーです。東京停止時は最後の扇出を使い、ここで追加は禁止です。',
    ecosystemMallCommerceMatrixTokyoBanner: 'このノードはグローバル書込中心です。紐付け・オーディエンス・新規ドメインは111と追随リージョンへ扇出されます。',
    ecosystemMallCommerceMatrixReload: '再読込',
    ecosystemMallCommerceMatrixOpenPriceBook: '価格表',
    ecosystemMallCommerceMatrixBlockerHint: '未分類または価格欠落があります。公開前に修正してください。',
    ecosystemMallCommerceMatrixPassHint: '商業マトリクス健全性チェック合格。',
    ecosystemMallCommerceMatrixHealthSummary: '未分類 {unassigned} · ブロック {blockers} · アーキ不一致 {archMismatch}',
    ecosystemMallCommerceMatrixArchMismatchHint: 'ドメインSKUと価格表の product_class／quote_section が不一致：{n}件。価格表で修正してください。',
    ecosystemMallCommerceMatrixArchMismatchShort: 'アーキ不一致',
    ecosystemMallCommerceMatrixArchCols: 'アーキ欄',
    ecosystemMallCommerceMatrixArchWriteNote: 'アーキ欄（product_class／quote_section）は価格表のみ編集可。本画面は金額・メニュー紐付け・ドメイン追加のみ。',
    ecosystemMallCommerceMatrixSkuSection: 'SKUドメイン',
    ecosystemMallCommerceMatrixTreeSection: 'メニュー／権限ツリー · 商業パノラマ（サイドバー整合）',
    ecosystemMallCommerceMatrixOrphanSkuSection: 'メニュー未紐付け SKU',
    ecosystemMallCommerceMatrixMenuSection: 'メニュー分類（ページ）',
    ecosystemMallCommerceMatrixTier: '階層',
    ecosystemMallCommerceMatrixMenuCount: 'メニュー数',
    ecosystemMallCommerceMatrixMenuNames: '含むメニュー',
    ecosystemMallCommerceMatrixTrialDays: '試用日数',
    ecosystemMallCommerceMatrixHealth: '健全性',
    ecosystemMallCommerceMatrixAudience: '対象',
    ecosystemMallCommerceMatrixMenuName: '名称',
    ecosystemMallCommerceMatrixActions: '操作',
    ecosystemMallCommerceMatrixFilterAll: 'すべて',
    ecosystemMallCommerceMatrixFilterBlocker: 'ブロック',
    ecosystemMallCommerceMatrixFilterUnassigned: '未分類',
    ecosystemMallCommerceMatrixFilterInternal: '内部',
    ecosystemMallCommerceMatrixLoadFail: '読込失敗（プラットフォーム管理者）',
    ecosystemMallCommerceMatrixFilterKeyword: 'キーワード',
    ecosystemMallCommerceMatrixFilterKeywordPh: 'SKU／名称／ドメイン',
    ecosystemMallCommerceMatrixFilterReset: 'リセット',
    ecosystemMallCommerceMatrixFilterResultCount: '表示 {shown}／{total}',
    ecosystemMallCommerceMatrixFilterHealth: '健全性',
    ecosystemMallCommerceMatrixFilterTier: 'ティア',
    ecosystemMallCommerceMatrixFilterSegment: 'セグメント',
    ecosystemMallCommerceMatrixFilterPriceStatus: '定価',
    ecosystemMallCommerceMatrixFilterPriceHas: '定価あり',
    ecosystemMallCommerceMatrixFilterPriceMissing: '定価なし',
    ecosystemMallCommerceMatrixFilterCurrency: '通貨',
    ecosystemMallCommerceMatrixFilterDomain: 'ドメインパック',
    ecosystemMallCommerceMatrixFilterPillar: '柱',
    ecosystemMallCommerceMatrixFilterAudience: '対象',
    ecosystemMallCommerceMatrixFilterSkuBinding: 'SKU 紐付',
    ecosystemMallCommerceMatrixFilterSkuHas: 'SKU あり',
    ecosystemMallCommerceMatrixFilterSkuNo: 'SKU なし',
    ecosystemMallCommerceMatrixFilterHealthOk: '正常',
    ecosystemMallCommerceMatrixFilterHealthWarn: '警告',
    ecosystemMallCommerceMatrixFilterHealthBlocker: 'ブロック',
    ecosystemMallCommerceMatrixFilterAudienceBrandOps: 'ブランド運用',
    ecosystemMallCommerceMatrixFilterUnassigned: '未分類',
    ecosystemMallCommerceMatrixPillarSystem: 'システム設定',
    ecosystemMallCommerceMatrixPillarDevice: 'デバイス·XHM',
    ecosystemMallCommerceMatrixPillarSoc: 'SOC 運用',
    ecosystemMallCommerceMatrixPillarLeo: 'Leo',
    ecosystemMallCommerceMatrixPillarMall: 'エコシステムモール',
    ecosystemMallCommerceMatrixPillarOther: 'その他',
    ecosystemMallCommerceMatrixDomain: 'ドメインパック',
    ecosystemMallCommerceMatrixSegment: 'セグメント',
    ecosystemMallCommerceMatrixBindTarget: '割り当て',
    ecosystemMallCommerceMatrixBindApply: '選択を割り当て',
    ecosystemMallCommerceMatrixBindNeedSelect: '先にページとパックを選んでください',
    ecosystemMallCommerceMatrixBindOk: '割り当てました',
    ecosystemMallCommerceMatrixBindPolicy: '適用方針',
    ecosystemMallCommerceMatrixBindPolicyNewOnly: '新規契約のみ（推奨）',
    ecosystemMallCommerceMatrixBindPolicyGrandfather: '既存顧客は据え置き',
    ecosystemMallCommerceMatrixBindPolicyImmediate: '即時全量（高リスク）',
    ecosystemMallCommerceMatrixCreateDomain: 'ドメイン追加',
    ecosystemMallStartUnifyPipeline: '標準フローを開始',
    ecosystemMallGovernanceGapJump: '整治ギャップ',
    ecosystemMallCommerceMatrixCreateDomainHint: '追加は安全。メニュー付け替えは既定で新規契約のみ。既存購入者の権限は維持。',
    ecosystemMallCommerceMatrixCreateDomainEnName: 'ドメイン英名',
    ecosystemMallCommerceMatrixCreateDomainQuoteSection: '見積区分',
    ecosystemMallCommerceMatrixCreateDomainProductClass: '製品区分',
    ecosystemMallCommerceMatrixCreateDomainNeed: 'メニュー／英名／柱が必要',
    ecosystemMallCommerceMatrixCreateDomainOk: 'ドメインを作成しました',
    ecosystemMallCommerceMatrixCreateDomainOkSku: 'ドメイン作成完了、SKU={sku}',
    ecosystemMallCommerceMatrixCreateDomainFail: 'ドメイン作成に失敗',
    ecosystemMallCommerceMatrixWizardStepMenus: 'メニュー',
    ecosystemMallCommerceMatrixWizardStepConfirmMenus: '確認',
    ecosystemMallCommerceMatrixWizardStepName: '名称',
    ecosystemMallCommerceMatrixWizardStepBilling: '周期',
    ecosystemMallCommerceMatrixWizardStepPay: '支払',
    ecosystemMallCommerceMatrixWizardStepPrice: '価格',
    ecosystemMallCommerceMatrixWizardStepDone: '最終確認',
    ecosystemMallCommerceMatrixWizardPickMenusHint: '権限ツリーと同様にメニュー頁を選択（同一柱のみ）。',
    ecosystemMallCommerceMatrixWizardSelectedCount: '{n} 件のメニューを選択',
    ecosystemMallCommerceMatrixWizardPillar: '柱：{pillar}',
    ecosystemMallCommerceMatrixWizardNameZh: '表示名（任意）',
    ecosystemMallCommerceMatrixWizardAutoSkuHint: 'SKU は名称から自動採番。保存時に一意性を保証。',
    ecosystemMallCommerceMatrixWizardBillingHint: '対応する課金周期（複数可。優先は年＞月＞日）。',
    ecosystemMallCommerceMatrixWizardCycleDay: '日',
    ecosystemMallCommerceMatrixWizardCycleMonth: '月',
    ecosystemMallCommerceMatrixWizardCycleYear: '年',
    ecosystemMallCommerceMatrixWizardPayHint: '対応する支払条件（複数可）。',
    ecosystemMallCommerceMatrixWizardPayPrepaid: '前払い',
    ecosystemMallCommerceMatrixWizardPrev: '戻る',
    ecosystemMallCommerceMatrixWizardNext: '次へ',
    ecosystemMallCommerceMatrixWizardFinish: '作成する',
    ecosystemMallCommerceMatrixWizardNeedMenus: 'メニューを1つ以上選択してください',
    ecosystemMallCommerceMatrixWizardMultiPillar: '複数柱が混在しています。同一柱のみ選択してください',
    ecosystemMallCommerceMatrixWizardNeedBilling: '課金周期を1つ以上選択',
    ecosystemMallCommerceMatrixWizardNeedPay: '支払条件を1つ以上選択',
    ecosystemMallCommerceMatrixWizardNeedPrice: '0より大きい価格を入力',
    ecosystemMallCommerceMatrixBindFail: '割り当て失敗',
    ecosystemMallCommerceMatrixMakeFree: '無料にする',
    ecosystemMallCommerceMatrixMakeFreeConfirm: 'この有料パックのページを無料基本パックへ移します。テナントは購入不要になります。続行しますか？',
    ecosystemMallCommerceMatrixMakeFreeOk: '無料にしました',
    ecosystemMallCommerceMatrixFreeTier: '無料',
    ecosystemMallCommerceMatrixPaidTier: '有料',
    ecosystemMallCommerceMatrixBindHint: '受眾／域包列で直接編集（内部指定可）、選択で一括処理。',
    ecosystemMallCommerceMatrixAudienceApply: '受眾変更',
    ecosystemMallCommerceMatrixAudienceNeedSelect: 'ページを選択し受眾を指定してください',
    ecosystemMallCommerceMatrixAudienceOk: '受眾を更新しました',
    ecosystemMallCommerceMatrixAudienceFail: '受眾の更新に失敗しました',
    ecosystemMallCommerceMatrixAudienceJsonBoundWarn: '{n} 件は JSON シード归类のため未归类にできません',
    ecosystemMallCommerceMatrixBatchSelected: '{n} ページ選択中',
    ecosystemMallCommerceMatrixClearSelection: '選択解除',
    ecosystemMallCommerceMatrixInlineDomainPh: '域包を選択',
    ecosystemMallCommerceMatrixBindPillarMixed: '一括割当は同一柱のページのみ選択してください',
    ecosystemMallCommerceMatrixBindPillarOther: '五本柱に未配置 — 先にメニュー樹を修正してください',
    ecosystemMallCommerceMatrixBindPillarMismatch: '{n} 件は域包の柱不一致のためスキップしました',
    ecosystemMallCommerceMatrixMenuId: 'メニュー ID',
    ecosystemMallCommerceMatrixTierFreeBasic: '無料基本パック',
    ecosystemMallCommerceMatrixTierAddon: '追加パック',
    ecosystemMallCommerceMatrixTierNone: 'なし',
    ecosystemMallCommerceMatrixAudienceInfraFolder: '基盤フォルダ',
    ecosystemMallCommerceMatrixHealthOk: '正常',
    ecosystemMallCommerceMatrixHealthWarn: '警告',
    ecosystemMallCommerceMatrixHealthBlocker: 'ブロック',
    ecosystemMallCommerceMatrixDomain_socMonDomainBasicOps: 'SOC 運用基盤',
    ecosystemMallCommerceMatrixDomain_socMonDomainStoreOpsPlus: '店舗運用追加',
    ecosystemMallCommerceMatrixDomain_socMonDomainHqMulti: '本部マルチ店追加',
    ecosystemMallCommerceMatrixDomain_socMonDomainPayIntegrate: '決済連携追加',
    ecosystemMallCommerceMatrixDomain_socMonDomainAnalytics: '分析 AI 追加',
    ecosystemMallCommerceMatrixDomain_socMonDomainSmartGuidePlus: 'スマートガイド追加',
    ecosystemMallCommerceMatrixDomain_leoMonDomainBasic: 'Leo 基盤',
    ecosystemMallCommerceMatrixDomain_leoMonDomainHomeAddon: 'Leo ホーム追加',
    ecosystemMallCommerceMatrixDomain_leoMonDomainComAddon: 'Leo コンポーネント追加',
    ecosystemMallCommerceMatrixDomain_leoMonDomainAiPoints: 'Leo AI ポイント',
    ecosystemMallCommerceMatrixDomain_ecMonDomainMallBrowse: 'モール閲覧基盤',
    ecosystemMallCommerceMatrixDomain_ecMonDomainBusinessPlan: 'ビジネスプラン追加',
    ecosystemMallCommerceMatrixDomain_deviceMonDomainBasicCenter: 'デバイスセンター基盤',
    ecosystemMallCommerceMatrixDomain_deviceMonDomainAfterSales: 'アフターサービス基盤',
    ecosystemMallCommerceMatrixDomain_deviceMonDomainInCar: '車載基盤',
    ecosystemMallCommerceMatrixDomain_deviceMonDomainHardwarePartner: 'ハードウェアパートナー基盤',
    ecosystemMallCommerceMatrixDomain_deviceMonDomainFamilySlot: 'デバイス族スロット',
    ecosystemMallCommerceMatrixDomain_brandServiceModeA: '契約モード A（デバイスデータ）',
    ecosystemMallCommerceMatrixDomain_brandServiceModeB: '契約モード B（SOC/Leo 追加）',
    ecosystemMallCommerceMatrixDomain_subscriptionBillingFolder: 'サブスク請求',
    ecosystemMallCommerceMatrixDomain_deviceEndpointDataFolder: 'デバイス端末データ',
    ecosystemMallSocOpsDesc: '標準体験パック（標準料金）またはカスタム（追加料金）。カスタムは人員・機器・権限・モジュール確認後に模擬パック発行。',
    ecosystemMallSocOpsToDevices: 'デバイス星図',
    ecosystemMallSocOpsFullSim: '一日シミュレーション',
    ecosystemMallSocOpsPlayDay: '一日を再生',
    ecosystemMallSocOpsDayPlaying: '再生中…',
    ecosystemMallSocOpsDayLabel: '一日の流れ',
    ecosystemMallSocOpsRailCup: '杯',
    ecosystemMallSocOpsRailCupHint: '注文→製造→受取',
    ecosystemMallSocOpsRailStock: '在庫',
    ecosystemMallSocOpsRailStockHint: '1杯で減算、不足は補充提案',
    ecosystemMallSocOpsRailPeople: '人',
    ecosystemMallSocOpsRailPeopleHint: '案内と本部連携',
    ecosystemMallSocOpsRailCash: '金',
    ecosystemMallSocOpsRailCashHint: '決済・分析・インテル',
    ecosystemMallSocOpsRailMore: 'その他',
    ecosystemMallSocOpsMode: '表示',
    ecosystemMallSocOpsModeTopo: 'トポロジ',
    ecosystemMallSocOpsModeList: 'モジュール',
    ecosystemMallSocOpsReload: '再読込',
    ecosystemMallSocOpsGuideToggle: '体験パック',
    ecosystemMallSocOpsGuideHide: 'パックを閉じる',
    ecosystemMallSocOpsPickCard: 'カードを選ぶと、このドメインが店で何をするか表示します。',
    ecosystemMallSocOpsPickNode: 'ノードを選ぶと、このドメインが店で何をするか表示します。',
    ecosystemMallSocOpsPickHint: '上の「杯 / 在庫 / 人 / 金」でも流れを強調できます。',
    ecosystemMallSocOpsYear: '年',
    ecosystemMallSocOpsInBasic: '基本に含む',
    ecosystemMallSocOpsStartTrial: '試用開始',
    ecosystemMallSocOpsTrySim: 'ドメイン体験',
    ecosystemMallSocOpsCombo: '組合せデモ',
    ecosystemMallSocOpsAddPack: '運営パックに追加',
    ecosystemMallSocOpsRemovePack: 'パックから外す',
    ecosystemMallSocOpsConfirmPay: '開通／支払い確認',
    ecosystemMallSocOpsPaying: '開通中…',
    ecosystemMallSocOpsMakePlan: 'プラン作成',
    ecosystemMallSocOpsPayOk: '開通しました',
    ecosystemMallSocOpsPayFail: '開通に失敗',
    ecosystemMallSocOpsPayNeedTrial: '先に試用してから開通してください',
    ecosystemMallSocOpsAutoHuman: '自動 vs 人',
    ecosystemMallSocOpsAuto: '自動：',
    ecosystemMallSocOpsHuman: '人：',
    ecosystemMallSocOpsCaps: 'できること',
    ecosystemMallSocOpsRelations: '上下流',
    ecosystemMallSocOpsUpstream: '依存',
    ecosystemMallSocOpsDownstream: '駆動',
    ecosystemMallSocOpsRelNone: 'なし（クラウド直結）',
    ecosystemMallSocOpsDemoTitle: 'ドメイン自動フロー',
    ecosystemMallSocOpsDemoClose: '閉じる',
    ecosystemMallSocOpsPackTitle: '運営パック · {n} ドメイン',
    ecosystemMallSocOpsPackEst: '年額目安 ¥{amount}',
    ecosystemMallSocOpsPackClear: 'クリア',
    ecosystemMallSocOpsPackTrial: 'パックを試用',
    ecosystemMallSocOpsPackTrialOk: '{n} ドメインの試用を開始',
    ecosystemMallExpGuideTitle: '体験パックを選ぶ',
    ecosystemMallExpGuideSub: '標準パックはすぐ体験。カスタムは人員・機器・権限・モジュール確認後に模擬パック発行。',
    ecosystemMallExpKindStandard: '標準体験パック',
    ecosystemMallExpKindStandardHint: '固定セット。試用または支払い開通',
    ecosystemMallExpKindCustom: 'カスタム体験パック',
    ecosystemMallExpKindCustomHint: '店舗一式を確認してから模擬パックを発行',
    ecosystemMallExpFeeStandard: '標準料金',
    ecosystemMallExpFeeExtra: '追加料金',
    ecosystemMallExpFeeExtraHint: 'カスタム設定・発行は別課金',
    ecosystemMallExpStepPickStandard: '① 標準パックを選ぶ',
    ecosystemMallExpStandardLineA: '標準パックを試用し模擬店へ。',
    ecosystemMallExpStandardLineB: '標準パックを支払って正式開通。',
    ecosystemMallExpStaffTitle: '人員',
    ecosystemMallExpStaffHint: '店長・店員の人数（設定記録。口座開設完了とは言いません）。',
    ecosystemMallExpDevicesTitle: '機器',
    ecosystemMallExpDevicesHint: '模擬店に置く機器を選ぶ。',
    ecosystemMallExpModulesTitle: 'モジュール',
    ecosystemMallExpModulesHint: '試用する運営ドメインを選ぶ。',
    ecosystemMallExpPermsTitle: '権限',
    ecosystemMallExpPermsHint: '店長／店員の権限プリセット。',
    ecosystemMallExpConfirmTitle: '確認して発行',
    ecosystemMallExpConfirmHint: '内容を確認し、カスタム模擬パックを発行して体験へ。',
    ecosystemMallExpManagerCount: '店長数',
    ecosystemMallExpStaffCount: '店員数',
    ecosystemMallExpPermsHonest: 'プリセットは設定として保存。口座未作成なら「記録済」であり「完了」ではありません。',
    ecosystemMallExpConfirmHonest: '発行後、試用／模擬店／機器／人員／権限の実状態を表示します。',
    ecosystemMallExpSumStaff: '人員：店長 {m}・店員 {s}',
    ecosystemMallExpSumDevices: '機器 {n}',
    ecosystemMallExpSumModules: 'モジュール {n}',
    ecosystemMallExpSumPerms: '権限プリセット {n}',
    ecosystemMallExpPrev: '戻る',
    ecosystemMallExpNext: '次へ',
    ecosystemMallExpIssuePack: '確認して模擬パック発行',
    ecosystemMallExpIssuing: '発行中…',
    ecosystemMallExpIssueOk: 'カスタム模擬パックを発行し体験へ',
    ecosystemMallExpIssueFail: '発行未完了（一覧参照。成功と偽表示しません）',
    ecosystemMallExpDraftInvalid: '人員・機器・モジュール・権限を先に完了',
    ecosystemMallExpChecklistTitle: '発行結果（正直な状態）',
    ecosystemMallExpCheckModules: 'ソフトモジュール試用',
    ecosystemMallExpCheckStore: '模擬店ワークスペース',
    ecosystemMallExpCheckDevices: '機器の配置',
    ecosystemMallExpCheckStaff: '店長／店員設定',
    ecosystemMallExpCheckStaffHonest: '設定は記録済。口座作成はバックエンド依存',
    ecosystemMallExpCheckPerms: '権限プリセット',
    ecosystemMallExpCheckPermsHonest: 'プリセット記録済＝ロール付与完了ではない',
    ecosystemMallExpStatusDone: '完了',
    ecosystemMallExpStatusRecorded: '記録済（バックエンド待ち）',
    ecosystemMallExpStatusFailed: '失敗',
    ecosystemMallExpStatusPending: '操作待ち',
    ecosystemMallExpStatusSkipped: '未処理',
    ecosystemMallExpModOrder: '注文',
    ecosystemMallExpModProduce: '製造',
    ecosystemMallExpModPickup: '受取',
    ecosystemMallExpModStock: '在庫',
    ecosystemMallExpModPay: '決済',
    ecosystemMallExpModHq: '本部',
    ecosystemMallExpModGuide: '案内',
    ecosystemMallExpModAnalytics: '分析',
    ecosystemMallExpModIntel: 'インテル',
    ecosystemMallExpDevKiosk: '注文キオスク',
    ecosystemMallExpDevTea: '製造／茶機',
    ecosystemMallExpDevQueue: '呼出ディスプレイ',
    ecosystemMallExpDevPos: 'POS',
    ecosystemMallExpDevSignage: 'サイネージ',
    ecosystemMallExpPermManager: '店長：店舗運営一式',
    ecosystemMallExpPermStaff: '店員：日常店務',
    ecosystemMallExpPermStaffPickup: '店員：受取のみ',
    ecosystemMallSocOpsBridgeHwTitle: '推奨ハードウェア',
    ecosystemMallSocOpsBridgeHonest: '機器スナップショット未取得時はカタログ提案のみ。店内保有を偽表示しません。',
    ecosystemMallSocOpsBridgeGoHw: 'デバイス星図へ',
    ecosystemMallSocOpsBridgeFromHw: 'デバイス星図から文脈を受け取りました（ソフト状態は本頁トポロジ準拠）',
    ecosystemMallSocOpsBridgeFromHwPay: 'ハード側は成約線を推奨：パック確認後に支払い開通',
    ecosystemMallSocOpsDualTitle: '体験後は二本線だけ',
    ecosystemMallSocOpsDualSub: '標準権限パックを選ぶ。体験線：パック配備→模擬店作成→運用。成約線：支払いですぐ正式開通。',
    ecosystemMallSocOpsLineATag: '線A · 体験',
    ecosystemMallSocOpsLineATitle: '標準権限パック → 模擬店',
    ecosystemMallSocOpsLineADesc: '選んだ標準パックを試用開通し、バックエンドに模擬店を作ってすぐ回せます。',
    ecosystemMallSocOpsLineAStep1: '標準権限パックを配備（試用）',
    ecosystemMallSocOpsLineAStep2: '模擬店ワークスペースを作成',
    ecosystemMallSocOpsLineAStep3: '仮想店で模擬運用',
    ecosystemMallSocOpsLineACta: 'パック配備して模擬店へ',
    ecosystemMallSocOpsLineACtaShort: '体験線：模擬店へ',
    ecosystemMallSocOpsLineARunning: '配備中…',
    ecosystemMallSocOpsLineAOk: '{n} ドメインを試用配備し、模擬店へ移動します',
    ecosystemMallSocOpsLineBTag: '線B · 成約',
    ecosystemMallSocOpsLineBTitle: '支払いで正式開通',
    ecosystemMallSocOpsLineBDesc: '現在の標準パック／選択ドメインを本番権限として開通します（模擬店なし）。',
    ecosystemMallSocOpsLineBStep1: 'パックまたはドメインを確認',
    ecosystemMallSocOpsLineBStep2: '支払い確認で開通',
    ecosystemMallSocOpsLineBStep3: '実店舗の運営ドメインが有効化',
    ecosystemMallSocOpsLineBCta: '支払って正式開通',
    ecosystemMallSocOpsLineBCtaShort: '成約線：支払い開通',
    ecosystemMallSocOpsLineBOk: '{n} 運営ドメインを正式開通',
    ecosystemMallSocOpsLineBEmpty: '開通待ちのアドオンがありません',
    ecosystemMallSocOpsPackDayTitle: '日次運営スタンダード',
    ecosystemMallSocOpsPackDayDesc: '注文·製造·受取·在庫·決済',
    ecosystemMallSocOpsPackHqTitle: '本部強化パック',
    ecosystemMallSocOpsPackHqDesc: '日次 + 本部·案内·分析',
    ecosystemMallSocOpsPackFullTitle: 'フルインテルパック',
    ecosystemMallSocOpsPackFullDesc: '本部強化 + インテル',
    ecosystemMallSocOpsSimStoreName: '運営模擬店 · {pack}',
    ecosystemMallSocOpsSimStoreFallback: '模擬店APIが未完了のため、仮想店ページへ進みます',
    ecosystemMallSocOpsActive: '開通済',
    ecosystemMallSocOpsTrial: '試用中',
    ecosystemMallSocOpsPotential: '未導入',
    ecosystemMallBadgeAll: 'すべて',
    ecosystemMallBadgeOwned: '導入済',
    ecosystemMallBadgeIntent: '意向あり',
    ecosystemMallBadgeAvailable: '選択可',
    ecosystemMallSocOpsLoadFail: '読込失敗',
    ecosystemMallSocOpsTrialOk: '試用を開始しました',
    ecosystemMallSocOpsTrialFail: '試用に失敗',
    ecosystemMallSocOpsListCount: '{n} モジュール',
    ecosystemMallSocOpsBrand: 'XRROSS 運営ストア',
    ecosystemMallSocOpsChip: 'Leo · SOC · XHM 三位一体',
    ecosystemMallSocOpsSub: '中心＝SOC店舗ランタイム。太い線＝業務の自動循環。ドメインを選びパックで試用。',
    ecosystemMallSocOpsScheme: '配色',
    ecosystemMallSocOpsSchemeLight: 'ライト',
    ecosystemMallSocOpsSchemeMidnight: 'ミッドナイト',
    ecosystemMallSocOpsSchemeSlate: 'スレート',
    ecosystemMallSocOpsSchemeBrand: 'ブランド',
    ecosystemMallSocOpsEngine: '運営マップ',
    ecosystemMallSocOpsLegendTitle: '見方',
    ecosystemMallSocOpsLegendHub: '中心＝SOC店舗ランタイム（Leo案内 / XHM書戻し）',
    ecosystemMallSocOpsLegendActive: '明るい＝開通済／本体に含む',
    ecosystemMallSocOpsLegendPotential: '暗い＝未導入（破線＋黄）',
    ecosystemMallSocOpsLegendTrial: '緑＝試用中',
    ecosystemMallSocOpsLegendHint: '太い線＝一日循環。選択で上下流を強調',
    ecosystemMallSocOpsLegendExpand: '大きなモジュールをクリックすると詳細機能が展開',
    ecosystemMallSocOpsLegendHover: 'ボールにマウスを置くと正式名称と機能を表示',
    ecosystemMallSocOpsHoverBelong: '所属',
    ecosystemMallSocOpsZoomHint: 'ホイール拡大 · 空白ドラッグで移動',
    ecosystemMallSocOpsZoomReset: 'リセット',
    ecosystemMallSocOpsFs: '全画面',
    ecosystemMallSocOpsExitFs: '終了',
    ecosystemMallSocOpsSku: 'アドオンSKU',
    ecosystemMallSocOpsReloading: '開始中…',
    ecosystemMallSocOpsEmpty: '運営ノードがまだありません',
    ecosystemMallSocOpsHubLabel: 'SOC店舗ランタイム',
    ecosystemMallSocOpsHubSub: 'ランタイム',
    ecosystemMallSocOpsHubHint: '杯・在庫・人・金をここで閉環',
    ecosystemMallSocOpsMetaBasicSolve: '店舗ランタイム基盤を一括導入し、他ドメインを載せられる状態にする。',
    ecosystemMallSocOpsMetaBasicAuto: 'アカウント、店舗台帳、基本メニュー、機器ハンドシェイク。',
    ecosystemMallSocOpsMetaBasicHuman: '初回開店設定とブランド規則の確認。',
    ecosystemMallSocOpsMetaBasicC1: '店舗・スタッフ基礎台帳',
    ecosystemMallSocOpsMetaBasicC2: 'メニュー／SKU基盤',
    ecosystemMallSocOpsMetaBasicC3: 'デバイス星図との接続',
    ecosystemMallSocOpsMetaBasicD1: 'クラウドがランタイムを作成',
    ecosystemMallSocOpsMetaBasicD2: '基本メニューと権限を同期',
    ecosystemMallSocOpsMetaBasicD3: 'ドメインをマウント可能に',
    ecosystemMallSocOpsMetaOrderSolve: 'チャネル横断の注文を一本化し、取りこぼしを減らす。',
    ecosystemMallSocOpsMetaOrderAuto: '受付・検証・製造キューへルーティング。',
    ecosystemMallSocOpsMetaOrderHuman: '例外・改訂・クレーム判断。',
    ecosystemMallSocOpsMetaOrderC1: 'マルチチャネル集約',
    ecosystemMallSocOpsMetaOrderC2: '自動検証と割当',
    ecosystemMallSocOpsMetaOrderC3: '例外アラート',
    ecosystemMallSocOpsMetaOrderD1: '注文がクラウドに入る',
    ecosystemMallSocOpsMetaOrderD2: '規則検証後にキューへ',
    ecosystemMallSocOpsMetaOrderD3: '製造ドメインへ引き継ぎ',
    ecosystemMallSocOpsMetaProduceSolve: 'レシピ駆動で1杯を追跡可能な工程にする。',
    ecosystemMallSocOpsMetaProduceAuto: 'BOM／レシピ手順を進め進捗を書戻し。',
    ecosystemMallSocOpsMetaProduceHuman: '故障やレシピ例外時に介入。',
    ecosystemMallSocOpsMetaProduceC1: 'レシピ駆動ライン',
    ecosystemMallSocOpsMetaProduceC2: '受取へ進捗連携',
    ecosystemMallSocOpsMetaProduceC3: '原料減算の提案',
    ecosystemMallSocOpsMetaProduceD1: '注文が製造ジョブを生成',
    ecosystemMallSocOpsMetaProduceD2: '機器／ラインが手順実行',
    ecosystemMallSocOpsMetaProduceD3: '完了を受取・在庫へ通知',
    ecosystemMallSocOpsMetaPickupSolve: '注文コードでトラブルの少ない受取にする。',
    ecosystemMallSocOpsMetaPickupAuto: '整列・呼出・スキャン消込。',
    ecosystemMallSocOpsMetaPickupHuman: '受取トラブルと特別解放。',
    ecosystemMallSocOpsMetaPickupC1: '整列／呼出',
    ecosystemMallSocOpsMetaPickupC2: 'スキャン消込',
    ecosystemMallSocOpsMetaPickupC3: '決済・分析へ状態連携',
    ecosystemMallSocOpsMetaPickupD1: '製造完了が受取キューへ',
    ecosystemMallSocOpsMetaPickupD2: '客が注文コードをスキャン',
    ecosystemMallSocOpsMetaPickupD3: '決済と振り返りへ閉環',
    ecosystemMallSocOpsMetaStockSolve: '1杯ごとに減算し、勘ではなく補充提案を出す。',
    ecosystemMallSocOpsMetaStockAuto: 'BOM減算、閾値警告、補充草案。',
    ecosystemMallSocOpsMetaStockHuman: '入出庫確認と高額調達のゲート。',
    ecosystemMallSocOpsMetaStockC1: 'BOM減算',
    ecosystemMallSocOpsMetaStockC2: '欠品警告',
    ecosystemMallSocOpsMetaStockC3: 'スキャン入出庫提案',
    ecosystemMallSocOpsMetaStockD1: '製造が減算を起動',
    ecosystemMallSocOpsMetaStockD2: '閾値超過で提案生成',
    ecosystemMallSocOpsMetaStockD3: '必要時に本部へエスカレーション',
    ecosystemMallSocOpsMetaHqSolve: '多店舗の例外を本部に集約し、日常は店長を邪魔しない。',
    ecosystemMallSocOpsMetaHqAuto: '閾値超過と店舗横断の集計。',
    ecosystemMallSocOpsMetaHqHuman: '戦略・価格・重大例外の決断。',
    ecosystemMallSocOpsMetaHqC1: '多店舗ダッシュボード',
    ecosystemMallSocOpsMetaHqC2: '閾値超過のエスカレーション',
    ecosystemMallSocOpsMetaHqC3: '方針を案内ドメインへ配信',
    ecosystemMallSocOpsMetaHqD1: '各ドメインが指標を報告',
    ecosystemMallSocOpsMetaHqD2: '超過時だけ人へ',
    ecosystemMallSocOpsMetaHqD3: '決断を店舗案内へ書戻し',
    ecosystemMallSocOpsMetaPaySolve: '債務を明確に記録し、出金前は人のゲートを残す。',
    ecosystemMallSocOpsMetaPayAuto: '仕訳、照合ヒント、支払状態同期。',
    ecosystemMallSocOpsMetaPayHuman: '出金確認と返金判断。',
    ecosystemMallSocOpsMetaPayC1: '入金／買掛仕訳',
    ecosystemMallSocOpsMetaPayC2: '照合トレイル',
    ecosystemMallSocOpsMetaPayC3: '出金前の人ゲート',
    ecosystemMallSocOpsMetaPayD1: '受取完了が会計イベントに',
    ecosystemMallSocOpsMetaPayD2: '未照合を自動集約',
    ecosystemMallSocOpsMetaPayD3: '出金前に確認を要求',
    ecosystemMallSocOpsMetaAnalyticsSolve: '一日の杯・在庫・人・金を振り返れる数字にする。',
    ecosystemMallSocOpsMetaAnalyticsAuto: '売上・ロス・ピークを集計。',
    ecosystemMallSocOpsMetaAnalyticsHuman: '異常を読みメニュー／シフトを決める。',
    ecosystemMallSocOpsMetaAnalyticsC1: '日／週サマリー',
    ecosystemMallSocOpsMetaAnalyticsC2: 'ピークとロスの提示',
    ecosystemMallSocOpsMetaAnalyticsC3: 'インテル／本部へ出力',
    ecosystemMallSocOpsMetaAnalyticsD1: '決済とラインのイベント入庫',
    ecosystemMallSocOpsMetaAnalyticsD2: '経営サマリー生成',
    ecosystemMallSocOpsMetaAnalyticsD3: '異常をインテル／本部へ',
    ecosystemMallSocOpsMetaGuideSolve: 'チャット群ではなく、システムでスタッフ動作を揃える。',
    ecosystemMallSocOpsMetaGuideAuto: '次アクション提示、欠員時の連絡提案。',
    ecosystemMallSocOpsMetaGuideHuman: 'シフト確定と現場例外。',
    ecosystemMallSocOpsMetaGuideC1: '役割ごとの次手順',
    ecosystemMallSocOpsMetaGuideC2: 'シフト／補充提案',
    ecosystemMallSocOpsMetaGuideC3: '本部方針を動作へ落地',
    ecosystemMallSocOpsMetaGuideD1: '本部方針が配信',
    ecosystemMallSocOpsMetaGuideD2: 'スタッフが次手順を受信',
    ecosystemMallSocOpsMetaGuideD3: '動作が注文流へ戻る',
    ecosystemMallSocOpsMetaIntelSolve: 'レポートの山ではなく、行動可能なインテルにする。',
    ecosystemMallSocOpsMetaIntelAuto: 'トレンド／リスクを検知しブリーフ作成。',
    ecosystemMallSocOpsMetaIntelHuman: '組合せ／機器／ソフト追加の判断。',
    ecosystemMallSocOpsMetaIntelC1: 'トレンドとリスクのブリーフ',
    ecosystemMallSocOpsMetaIntelC2: '追加購入の連動提案',
    ecosystemMallSocOpsMetaIntelC3: '本部判断へ還流',
    ecosystemMallSocOpsMetaIntelD1: '分析がシグナルを出力',
    ecosystemMallSocOpsMetaIntelD2: '行動可能なインテルを生成',
    ecosystemMallSocOpsMetaIntelD3: '本部が取捨を決める',
    ecosystemMallCatalog: '商品と章',
    ecosystemMallWebsitePages: '公式サイト製品ページ',
    ecosystemMallSynergyEdges: '連携エッジ承認',
    ecosystemMallIntents: '意向／相談チケット',
    ecosystemMallVendors: 'ベンダーと担当者',
    ecosystemMallMediaBilling: 'メディアAI／課金',
    ecosystemMallProductSpecs: '製品仕様／不足',
    ecosystemMallLines: '生産ライン',
    ecosystemMallSearch: '検索・推薦',
    ecosystemMallEquipmentDemands: '設備需要チケット',
    storeAssortmentOptimization: '店舗品揃え最適化',
    storeAssortmentGroup: '店舗品揃え',
    storeAssortmentDesk: '品揃え最適化ワークベンチ',
    storeAssortmentView: '表示',
    storeAssortmentGate: 'ゲート',
    teaSingleCupParams: '単杯パラメータ',
    dataOfBlendExtractorMachine: '氷沙機データ',
    dataOfMilkExtractorMachine: '乳泡機データ',
    beverageOutputData: '提供データ',
    singleCupData: '単杯データ',
    faultLog: '故障ログ',
    deliveryPlatform: '宅配アプリ',
    uber: 'Uber',
    otherProducts: '他社製品',
    listOfTeaExtractsProducts: '萃茶機製品',
    machineDebug: '機器デバッグ',
    deviceRdGroup: 'デバイス開発',
    presetCommand: '設定指令',
    commandConfiguration: '指令設定',
    operationAndMaintenanceServices: '保守サービス',
    productionList: '商品一覧',
    smallMaterial: '小原料表',
    takeoutProducts: '宅配商品',
    pointRule: 'ポイント規定',
    couponManagement: "クーポン管理",
    couponList: "クーポン一覧",
    additionalProducts: '追加商品',
    type: '製品タイプ',
    taxAllocation: '税務設定',
    produce: '製品リスト',
    produceList4: '商品一覧4',
    smoothieMakerProduct: '氷沙機商品',
    machineMenu: '機器メニュー',
    systemLog: "システムログ",
    add: '新規',
    edit: '編集',
    delete: '削除',
    search: '検索',
    reset: 'リセット',
    detail: '詳細',
    batchImport: '一括取込',
    oneClickCopy: '一括複製',
    resetPwd: 'PWリセット',
    machineList: '機器一覧',
    export: '出力',
    log: 'ログ',
    bindStore: '店舗紐付',
    bindMachine: '機器紐付',
    codeRule: '番付ルール',
    batchDelete: '一括削除',
    region: 'エリア'

  },
  acoount: {
    // XRROSS_JA_FILL_20260916 begin
    searchKeyword: 'アカウント/電話/メール/ロール',
    // XRROSS_JA_FILL_20260916 end
    name: '名称',
    enterpriseName: '企業名',
    account: 'ＩＤ',
    password: 'ＰＷ',
    confirmPassword: '確認ＰＷ',
    roleTitle: '役職',
    roleName: '役割名',
    phone: '携帯番号',
    email: 'メール',
    idNumber: '証件番号',
    workAddress: '勤務地',
    status: '状態',
    onDuty: '勤務中',
    leaveDuty: '離席中',
    takeVacationrm: '休暇中',
    disable: '無効',
    profilePicture: '肖像',
    confirmPasswordCannotBeEmpty: '確認PW未入力',
    inconsistentPasswordInput: 'PW不一致',
    emailFormatError: 'メアド形式誤り',
    phoneNumberFormatError: '番号形式誤り',
    notes: '備考',
    empower: '権限付与',
    contactInformation: '連絡先',
    leoEntityId: 'X-ID',
    leoEntityIdFilter: 'X-IDで絞り込み',
    leoPrimaryAnchor: 'Leo 主錨',
    leoPrimaryAnchorFilter: '主錨で絞り込み',
    leoPrimaryAnchored: '完了',
    leoPrimaryNotAnchored: '未完了',
    leoIdentityLinks: 'ログイン対応',
    leoIdentityLinkCountSuffix: ' 件',
    leoIdentityLinksTitle: 'X-ID ログイン対応関係',
    leoIdentityLinkLabel: '方式／アカウント',
    leoIdentityLinkKind: '種別',
    leoIdentityLinkPrimary: '主錨',
    leoIdentityLinkRef: '資格情報',
    leoIdentityLinksEmpty: 'この X-ID に紐づくログイン方式はまだありません',
    userOrganizationType: '組織タイプ',
    userOrganizationName: '組織名称',
    describe: '記述',
    available: '有効',
    deactivate: '停止',

  },
  merchant: {
    // XRROSS_JA_FILL_20260916 begin
    searchKeyword: '加盟店名/責任者/電話/住所',
    // XRROSS_JA_FILL_20260916 end
    account: 'ログインID',
    password: 'パスワード',
    store: '店舗',
    status: '状態',
    available: '正常',
    deactivate: '停止',
    merchantName: '加盟店名',
    sapPageDesc: 'ゴールド：タイトル｜絞り込み｜表｜フッター。主ボタン1・行操作はMore・中密度。',
    sapListTitle: '加盟店一覧',
    cooperationType: '加盟店タイプ',
    selectCooperationTypeFirst: '先に加盟店タイプを選択',
    noUserOrganizationForType: 'このタイプのユーザー組織がありません。「ユーザー組織」で設定してください',
    enterpriseSegment: '業務区分',
    segmentDistributor: 'ディストリビューター',
    segmentShop: '店舗/加盟店',
    segmentHome: '家庭用企業',
    businessLicense: '営業許可証',
    frontIDCard: '身分証(表)',
    backIDCard: '身分証(裏)',
    head: '責任者',
    Telephone: '連絡電話',
    userOrganization: 'ユーザー組織',
    businessAddress: '登録住所',
    trade: '営業',
    closeBusiness: '休業',
    superior: '上級',
    supervisorSubordinateRelation: '上下関係',
    clickView: '詳細表示',
    business: '事業者',
    country: '国家',
    address: '住所',
    shopNames: '店舗名称',
    storeType: '店舗タイプ',
    selfService: 'セルフ',
    askFor: '自取', // "自取"在日本通常叫"テイクアウト"或"持帰り"，为了长度这里用"受取"或保留"自取"(如果是特定术语)
    SelfPickupTakeoutShop: '自取＋宅配店',
    selfServicePickUpTakeout: 'セルフ＋自取＋宅配',
    businessHours: '営業時間',
    closingTime: '閉店時間',
    operatingCycle: '営業周期',
    Monday: '月曜',
    Tuesday: '火曜',
    Wednesday: '水曜',
    Thursday: '木曜',
    Friday: '金曜',
    Saturday: '土曜',
    Sunday: '日曜',
    picture: '画像',
    vatNumber: 'VAT番号',
    kvtCompanyRegistrationNumber: 'KVK登録番号',
    invoiceUnifiedNumbering: '領収書統一番号',
    invoiceAccountNumber: '領収書口座',
    POSAPIKey: 'POS API Key',
    POSAccount: 'POS Account',
    APPAPIKey: 'APP API Key',
    APPAccount: 'APP Account',
    APPClientKey: 'APP Client Key',
    region: 'エリア'

  },
  device: {
    // XRROSS_JA_FILL_20260916 begin
    modelCodeKey: '型番コード',
    modelCodePlaceholder: '例：PT5 または XRROSS_PT5（全サイト一意）',
    modelCodeRequired: '型番コードを入力してください（Leo model_key 対応）',
    appKeyword: 'ソフト名',
    appVersionOp: 'バージョン比較',
    appVersionOpEq: '等しい',
    appVersionOpContains: '含む',
    appVersionOpLt: '未満',
    appVersionOpGt: '超える',
    appVersionOpLte: '以下',
    appVersionOpGte: '以上',
    appVersionFilter: '端末上バージョン',
    appVersionReportStatus: 'バージョン報告',
    appReportHas: '報告あり',
    appReportNone: '未報告',
    appReportStale: '報告期限切れ(7日)',
    appPublishRel: '公開版との比較',
    appPublishBehind: '公開版より遅れ',
    appPublishEqual: '公開版と同等',
    appPublishAhead: '公開版より新しい',
    macFastRebindEnabled: 'MAC高速再紐付け',
    macFastRebindPending: '再紐付け未準備',
    // XRROSS_JA_FILL_20260916 end
    sapPageDesc: 'ゴールド：タイトル｜KPI｜絞り込み｜表｜フッター。主ボタン1・行操作はMore・中密度。',
    sapKpiTitle: '機器概況',
    sapListTitle: '機器一覧',
    mapShowLocation: '地図表示',
    deviceType: '機器タイプ',
    totalDevice: '機器総数',
    passConfigName: "名称",
    offLineDevice: 'オフライン機',
    materialShortageDevice: '原料不足機',
    alertingDevice: '警報中機器',
    lockDevice: 'ロック機器',
    maintenanceDevice: '要保守機器',
    businessInformation: '業務資料',
    deviceId: '機器ID',
    deviceModel: '型番',
    dealer: "小売業者",
    deviceImie: '機器IMEI',
    appVersion: 'アプリ版',
    equipmentSerialNumber: '製造番号',
    posNumber: '端末番号',
    store: '店舗',
    location: '設置場所',
    none: '無し',
    log: "ログ",
    fault: "故障",
    normal: "正常",
    offline: "切断",
    onLine: "接続",
    isFault: "故障有無",
    type: "タイプ",
    fullyAutomatic: "全自動",
    semiAutomatic: "半自動",
    availableMerchants: "利用可能店",
    faultStatistics: "故障統計",
    basicMaintenance: "基礎保守",
    deepMaintenance: "深度保守",
    onLineDevice: '接続機器',
    equipmentOnlineStatus: "接続状態:",
    moduleLinkStatus: "モジュール回線:",
    hostProduceStatus: "ホスト製作:",
    hostReadyCanProduce: "製作可",
    hostReadyNeedWake: "起動が必要",
    hostReadyUnknown: "不明",
    linkOffline: "モジュール切断",
    linkOnlineHostSleep: "接続中・ホスト休眠",
    brandName: "ブランド名:",
    telephone: "電話:",
    equipmentModelName: "型番/名称:",
    dateOfManufacture: "製造日付:",
    usageDate: "使用日付:",
    menu: "メニュー",
    productName: "商品名",
    channelConfiguration: "レーン設定",
    channelNumber: "レーンNo",
    material: "原料",
    shelfLife: "賞味期限",
    alarmListForTheDay: "警報一覧(当日)",
    content: "内容",
    time: "時間",
    key: "ボタン",
    frequency: "回数",
    remoteOperation: "遠隔操作",
    cloudIris: "雲瞳 / Cloud Iris",
    cloudIrisShort: "雲瞳",
    cloudIrisNeedImie: "機コードが無いため雲瞳を開けません",
    cloudIrisVersionLow: "App 版が雲瞳の最低要件未満です（必要 {minVersion}、現在 {appVersion}）",
    cloudIrisNoVersion: "App 版の上报がなく、雲瞳対応を確認できません",
    cloudIrisNotReadyFamily: "この機種は雲瞳未対応です",
    cloudIrisNotLicensed: "この端末は雲瞳未購入です。加購で端末を選択してください",
    cloudIrisNeedUpgradeShort: "雲瞳要アップデート",
    cloudIrisOldVersionShort: "旧版",
    cloudIrisEnd: "雲瞳を終了",
    cloudIrisWaiting: "機器の映像を待っています…",
    cloudIrisLive: "接続済み。画面をタッチして操作",
    cloudIrisFailed: "雲瞳の準備ができていません",
    cloudIrisUpgradeConfirmTitle: "雲瞳アップグレードの確認",
    cloudIrisUpgradeConfirm: "機コード {imie} に OTA 強制更新を送信（目標 ≥ {minVersion}、現在 {appVersion}）。\n{detail}\nこの 1 台のみ。他顧客のグレーリストは変更しません。",
    cloudIrisUpgradeConfirmOk: "同意して送信",
    cloudIrisUpgradePushSent: "OTA 確認コマンドを送信しました（{imie}）",
    cloudIrisUpgradePushOffline: "グレーリストに追加済み。端末オフラインまたは未 ACK（{imie}）",
    cloudIrisUpgradePushFailed: "雲瞳 OTA 送信に失敗しました",
    identityAndLink: "身分と回線",
    storeAddress: "店舗住所",
    deviceGeo: "機器位置",
    deviceGeoLoading: "位置を読み込み中…",
    deviceGeoNone: "位置なし",
    menuStatus: "メニュー状態",
    updated: "更新済",
    notUpdated: "未更新",
    success: "成功",
    lock: "ロック",
    unlock: "解除",
    startup: "起動",
    shutdown: "終了",
    restart: "再起動",
    param: "変数",
    factoryParam: '出荷変数',
    moduleParam: 'モジュール',
    paramBaselineOpen: 'パラメータ',
    paramBaselineTitle: 'パラメータ基準（Leo）',
    paramBaselineHint: 'JSON パス（例: config.stirTime）をデバイス設定に合わせてください。',
    paramBaselineAddRow: '行を追加',
    paramBaselineSave: '保存',
    paramBaselineRefresh: '再読込',
    paramKey: 'キー',
    paramKeyPh: '例: config.stirTime',
    paramDisplayName: '表示名',
    standardValue: '基準値',
    lowerLimit: '下限',
    upperLimit: '上限',
    unit: '単位',
    paramRemark: '備考',
    paramBaselineNoProfile: 'この型番に読める L1 Profile（または PUBLISHED）がありません。Profile 管理で作成・公開してください。',
    paramBaselineProfileSource: 'デフォルト元: {name} · published {version}',
    paramBaselineApplyPublished: '最新 published から反映',
    paramBaselineApplyConfirm: '最新 published の JSON をマージします（同一キーは上書き）。よろしいですか？',
    paramBaselineApplyDone: 'published の提案を反映しました（保存してください）',
    paramBaselineTypeUnionTitle: '同一機種カテゴリ · published パス集合（参考）',
    paramBaselineTypeUnionMissing: 'Profile が無い型番 ID',

  },
  produce: {
    // XRROSS_I18N_UNION_FILL_20260916 ja
    countsInConsumption: '消費に計上',
    matterTypeKind: '資材種別',
    matterTypeKindParameter: 'パラメータ',
    matterTypeKindPhysical: '物理資材',
    matterTypeParameterHint: '「パラメータ」種別は資材消費統計に含めません（プログラム・濃度・水温など）。',
    name: '名称',
    price: '価格',
    uberPrice: 'Uber単価',
    matterType: '原料タイプ',
    physicalMaterial: '物理SKU',
    physicalMaterialHint: 'V1: 先に物理SKUを選択。未選択時は名称で物理作成＋自動マップ可。',
    physicalMaterialRequired: '物理SKUを選択するか、名称で物理作成にチェックしてください',
    createPhysicalIfMissing: '名称で物理SKUを作成し自動マップ',
    normType: '規格タイプ',
    matter: '原料',
    min: '最小値',
    max: '最大値',
    shelfLife: '賞味期限',
    unit: '単位',
    hour: '時間',
    step1: '商品資料',
    step2: '商品原料',
    step3: '商品処方',
    step4: '処方組合',
    step5: '商品小料',
    produceName: '商品名称',
    produceCode: '商品コード',
    produceType: '商品タイプ',
    showSnacks: '軽食表示',
    yes: 'はい',
    no: 'いいえ',
    describe: '記述',
    order: '順序',
    value: '値',
    unit: '単位',
    norm: '規格',
    select: '選択',
    step: '手順',
    matterSequence: '原料順序',
    action: '操作',
    freeSnacks: '無料追加',
    feeBasedMaterials: '有料追加',
    nextStep: '次へ',
    back: '戻る',
    save: '保存',
    saveUpdate: '更新保存',
    productList: '商品メニュー',
    selectProduct: '商品選択',
    menuSort: '順位',
    produceImport: '商品取込',
    bind: '紐付',
    bindMachien: '機器紐付',
    smallMatterType: '小料タイプ',
    listing: '公開',
    isSales: '注文可',
    productListName: "商品メニュー名入力",
    Text1: '商品名称入力',
    Text2: '加盟店',
    Text3: '原料',
    Text4: '小料',
    Text5: '飲料',
    Text6: '軽食',
    Text7: '新規処方',
    Text8: '更新',
    Text9: '商品コード重複',
    Text10: '情報を完備下さい',
    Text11: '茶類',
    Text12: '第一段階',
    Text13: '第二段階',
    Text14: '第三段階',
    Text15: '出す',
    Text16: '出さない',
    Text17: '範囲:',
    Text18: '茶葉量:',
    Text19: '数字のみ入力可',
    Text20: '氷の量:',
    Text21: '同一段の攪拌時間は萃茶/抽出時間を超えられません（上限 {max}）',
    Text22: '萃茶/抽出時間は現在の攪拌時間より小さくできません（{min}）',
    Text23: 'レシピ「{name}」：攪拌時間が萃茶/抽出上限（{max}）を超えています。保存前に調整してください',
    codeRule: '編集規則',
    prefix: '接頭辞',
    suffix: '接尾辞',
    review: 'プレビュー',
    codeRuleDescribe: 'レジ印字用コードの形式となります',

  },
  business: {
    name: '名称',
    type: 'タイプ',
    homepage: 'ホーム',
    advertisingList: '広告一覧',
    pictureOrVideo: '画像/動画',
    addProductAdvertisements: '商品広告追加',
    AddImagesOrvideos: '画像/動画追加',
    userName: 'ユーザー名',
    email: 'メール',
    sex: '性別',
    birthday: '誕生日',
    phone: '携帯番号',
    walletBalance: '財布残高',
    integral: 'ポイント',
    orderNo: '注文番号',
    pickupCode: '受取コード',
    orderSource: '経路',
    orderSourceAll: 'すべて',
    orderSourceTable: 'テーブルQR',
    orderSourceNormal: '通常',
    tableNo: '卓番',
    store: '店舗',
    amount: '注文金額',
    payAmount: '支払金額',
    receiptsPrice: '受取金額',
    discount: '値引き',
    orderStatus: '注文状態',
    toBePaid: '未払',
    paid: '済',
    processing: '処理中',
    completed: '完了',
    orderCancellation: '注文取消',
    orderRejection: '注文拒否',
    paymentMethod: '支払方式',
    wallet: '財布',
    cash: '現金',
    pos: 'カード機',
    thirdParty: '第三者',
    otherPay: 'その他',
    produce: '商品',
    unitPrice: '単価',
    number: '数量',
    parameter: '変数',
    totalTaxAmount: '総税額',
    taxName: '税名',
    taxAmount: '税額',
    taxRate: '税率',
    orderType: '注文タイプ',
    pack: '持帰り',
    dineIn: '店内',

  },
  file: {
    // XRROSS_JA_FILL_20260916 begin
    publishStatus: '公開状態',
    published: '対外最新',
    archived: 'アーカイブ済',
    backupStatus: 'サーバーバックアップ',
    backedUp: 'バックアップ済',
    notBackedUp: '未バックアップ',
    otaStatus: 'OTA状態',
    otaLiveBacked: '対外最新·バックアップ済',
    otaLiveNoBackup: '対外最新·未バックアップ',
    otaArchivedBacked: 'アーカイブ·バックアップ済',
    otaArchivedNoBackup: 'アーカイブ·未バックアップ',
    otaLinkBroken: 'リンク無効',
    otaStatusTipTitle: '状態説明：',
    otaStatusTipLiveBacked: '緑＝対外公開中かつサーバーにバックアップあり。正常。',
    otaStatusTipLiveNoBackup: '橙＝対外公開中だが未バックアップ。バックアップ補完または再アップロードを。',
    otaStatusTipArchivedBacked: '灰＝対外非公開だがロールバック可。',
    otaStatusTipArchivedNoBackup: '赤＝アーカイブかつバックアップなし。ロールバックほぼ不可、再アップロード推奨。',
    otaStatusTipLinkBroken: '赤「リンク無効」＝URL空またはクラウド404/不通。APKを再アップロードしてください。',
    recheckLinks: 'リンク再確認',
    history: '履歴',
    historyTitle: 'バージョン履歴',
    backupNow: 'バックアップ補完',
    batchBackup: '一括バックアップ補完',
    batchArchive: '一括アーカイブ',
    batchBackupConfirm: '選択項目のバックアップ補完を実行しますか？',
    batchBackupDone: '一括バックアップ補完が完了しました',
    selectFirst: '操作するAPPを先に選択してください',
    copyLink: 'リンク',
    linkCopied: 'ダウンロードリンクをコピーしました',
    linkCopyFailed: 'コピー失敗。手動でコピーしてください',
    noDownloadLink: 'このAPPにはまだダウンロードリンクがありません',
    backupRemoteGone: 'クラウドAPKが存在しません（404）。APKを再アップロードしてからバックアップしてください。',
    archive: 'アーカイブ',
    archiveConfirm: 'アーカイブ後、旧端末はこの版を取得しません（ファイルはロールバック用に残ります）。確認',
    rollback: 'ロールバック',
    rollbackConfirm: 'この版へロールバックしますか？現在の対外最新はアーカイブ保存されます。',
    otaBackupHint: '保存後、システムがパッケージをサーバー製品庫へバックアップします。旧端末は元のダウンロードURLを使います。',
    otaReuploadHint: 'バックアップ補完が404の場合：クラウドファイルは削除済みです。ここでAPKを再アップロードしてから確定してください。',
    otaGray: 'グレー',
    otaGrayOff: '全量',
    otaGrayOn: 'グレー({n}台)',
    otaGraySet: 'グレー設定',
    otaGrayHint: 'ON＝ホワイトリスト機コードのみこの版へ。OFFまたは空＝全量。',
    otaGrayMachines: 'グレー機コード',
    otaGrayMachinesPlaceholder: '1行1機コード、またはカンマ区切り',
    otaForceUpgrade: '強制アップグレード',
    otaForceUpgradeHint: 'ON＝端末で更新をキャンセル不可。グレーと併用可。',
    otaPushForce: '即時プッシュ',
    otaPushForceConfirm: 'グレーホワイトリスト機へ強制アップグレード確認を即時プッシュしますか？オフライン機は offline になります。',
    otaPushForceResult: 'プッシュ完了：計 {total}、到達 {delivered}、オフライン {offline}',
    pendingIntentGate: 'PendingIntentゲート',
    pendingIntentGatePass: 'ゲート通過',
    pendingIntentGateSkip: 'スキップ済',
    pendingIntentGateNa: '非適用',
    pendingIntentGateFail: 'ゲート未通過',
    pendingIntentGateUnknown: '未マーク',
    pendingIntentGateTipPass: '公開時に Android 12 PendingIntent 硬ゲート通過（OTA 元として安全）。',
    pendingIntentGateTipSkip: '公開時に人手で硬ゲートをスキップ。リスクあり。',
    pendingIntentGateTipNa: 'targetSdk が低い、または UpdateDialog なし。硬ゲート非適用。',
    pendingIntentGateTipFail: 'スキャン済：targetSdk≥31 かつ UpdateDialog に PendingIntent 修正なし。この版のアプリ内 OTA はクラッシュします。',
    pendingIntentGateTipUnknown: '履歴版にゲートマークなし。新規公開または再スキャンで書き込みます。',
    // XRROSS_JA_FILL_20260916 end
    name: '名称',
    version: 'Ver',
    keyword: '識別',
    file: 'ファイル',
    upload: 'アップ',
    remark: '備考'

  },
  coupon: {
    Text1: '名称',
    Text2: '割引金額',
    Text3: '消費ポイント',
    Text4: '状態',
    Text5: '詳細',
    Text6: '利用可',
    Text7: '利用不可',
    Text8: '有効日数'

  },
  pass: {
    name: '名称',
    pass: 'レーン',
    passNumber: 'レーンNo',
    preDischargeTime: '予備排出時間',
    addPass: '新規レーン',
    bindPass: 'レーン紐付',
    passConfigName: 'レーン設定名'

  },
  operation: {
    business_data: "業務データダッシュボード",
    orderAmount: "注文金額",
    orderQuantity: "注文数量",
    actualAmountReceived: "実収金額",
    top_10_beverage_rankings: "飲品ランクTop10",
    sales_revenue: "売上高",
    order_quantity: "注文数",
    payment_method: "支払方式",
    real_time_orders_on_the_hour: "リアルタイム注文",
  },
  dataCenter: {
    Text1: "内容",
    Text2: "データ",
    Text3: "販売量/杯",
    Text4: "売上額/円",
    Text5: "消費原料/g",
    Text6: "月",
    Text7: "日",
    Text8: "時",
    Text9: "図表",
    Text10: "単杯消費原料",
    Text11: "順位",
    Text12: "商品消費原料",
    Text13: "機器消費原料",
    Text14: "比率",
    Text15: "順位",
    Text16: "販売量",
    Text17: "売上額",
    Text18: "時間/S",
    Text19: "商品販売量",
    Text20: "商品売上額",
    Text21: "機器販売量",
    Text22: "機器売上額",
    Text23: "総杯量",
    Text24: "総処方量/克",
    Text25: "実総処方量/克",
    Text26: "失敗量/杯",
    Text27: "失敗率/%",
    Text28: "誤差率/%",
    Text29: "商品名称",
    Text30: "制作方式",
    Text31: "QR",
    Text32: "商品",
    fullPipeModeValue: '満管',
    fullPipeMode: 'モード',
    calibComplete: '完了',
    calibIncomplete: '未完了',
    calibValue: '数値',
    calibModeChannel: 'チャンネル校正',
    calibModeScale: '小秤校正',
    calibMode: '校正モード',
    pipeActualText: '単管実量(g)',
    Text32Single: '製品-単管',
    Text31Single: 'スキャン-単管',
    Text33: "手動",
    Text34: "注文番号",
    Text35: "店舗",
    Text36: "単価",
    Text37: "処方総量",
    Text38: "実出杯量",
    Text39: "出杯時間",
    Text40: "誤差(%)",
    Text41: "失敗",
    Text42: "正常",
    Text43: "制作完了",
    Text44: "制作失敗",
    Text45: "完了時間",
    Text46: "モード",
    Text47: "レーン",
    Text48: "状態",
    Text49: "未完了",
    Text50: "完了",
    Text51: "商品名称",
    Text52: "杯数",
    Text53: "総価",
    Text54: "注文統計",
    Text55: "注文一覧",
    Text56: "注文金額",
    Text57: "注文数量",
    Text58: "実収金額",
    Text59: "商品金額",
    Text60: "茶葉量",
    Text61: "出水量",
    Text62: "販売量/樽",
    Text63: "樽",
    Text64: "酸味/抽出不足",
    Text65: "均衡/抽出適正",
    Text66: "苦味/抽出過多",
    Text67: "苦/濃度低",
    Text68: "適正",
    Text69: "強/濃度高",
    Text70: "抽出時間",
    Text71: "水粉比",
    strongBalance: "強バランス",
    weakBalance: "弱バランス",
    mediumAcid: "中酸味",
    strongAcid: "強酸味",
    goldenCup: "金賞(適正)",
    weakAcid: "弱酸味",
    bitter: "苦味",
    strongBitter: "強苦味",
    weakBitter: "弱苦味",
    extractionTime: "抽出時間",
    Text72: "動的校正",
  },
  taxation: {
    Text1: "税名",
    Text2: "税率",
    Text3: "基数",
    Text4: "備考",
    Text5: "国家",
    Text6: "タイプ",
    Text7: "店内",
    Text8: "持帰り",
    Text9: "商品タイプ",
    Text10: "税種",
    Text11: "宅配アプリ",
  },
  uber: {
    Text1: "Uber店舗",
    Text2: "PF店舗",
    Text3: "メニュー状態",
    Text4: "店舗状態",
    Text5: "紐付済",
    Text6: "未紐付",
    Text7: "同期"

  },

  login: {
    title: 'システム登录',
    logIn: 'ログイン',
    username: 'ID',
    password: 'PW',
    readAndAgree: '次を読み同意します：',
    pleaseCheckThePrivacyAgreement: 'ログイン前にプライバシーポリシー、利用規約および免責事項に同意してください',
    termTip: 'プライバシーポリシー、利用規約および免責事項',
    Text1: 'IDを入力',
    Text2: 'IDを入力',
    leoSmartComingSoon: 'Leo Smart 専門サイトは近日公開'


  },
  navbar: {
    logOut: 'ログアウト',
    dashboard: 'ホーム',
    github: 'プロジェクト',
    screenfull: '全画面',
    theme: 'スキン',
    size: 'レイアウト',
    globalSearchTitle: 'サイト内検索',
    globalSearchPlaceholder: 'メニュー／店舗／機器／資材／チケット（Ctrl+K）',
    globalSearchHotkeyHint: 'サイト内検索を開く（Ctrl+K）',
    globalSearchRecent: '最近の検索',
    globalSearchSaved: '保存ビュー',
    globalSearchEmpty: '結果なし',
    globalSearchSaveView: '現在のビューを保存',
    globalSearchSaveViewPrompt: 'ビュー名',
    globalSearchDefaultViewName: 'ビュー',
    globalSearchSavedOk: 'ビューを保存しました',
    globalSearchFooterHint: 'Enter で先頭を開く · Esc で閉じる',
    globalSearchGroupMenus: 'メニュー',
    globalSearchGroupStores: '店舗',
    globalSearchGroupEquipment: '機器',
    globalSearchGroupMaterials: '資材',
    globalSearchGroupTickets: 'チケット',
    globalSearchMissingRoute: '開けるページがありません'
  },
  tagsView: {
    refresh: '更新',
    close: '閉じる',
    closeOthers: '他を閉じる',
    closeAll: '全閉じる'
  },
  common: {
    tower: '台',
    yuan: '円',
    cup: '杯',
    place: '位',
    individual: '個',
    language: '言語',
    success: '成功',
    fail: '失敗',
    createTime: '作成日時',
    all: '全部',
    common: '全部',
    sureDel: '削除確認',
    tip: '提示',
    status: '状態',
    bing: '紐付',
    pleaseSelectDevice: '機器を選択',
    pleaseSelectMenu: 'メニュー選択',
    pleaseSelectModel: '型番を選択',
    pleaseSelect: '選択して下さい',
    code: 'コード',
    entering_the_platform: 'PFへ',
    date: "日付",
    address_fail: "住所不正",
    back: '戻る',
    pleaseEnter: '入力して下さい',
    uploadImageBtn: '画像アップロード',
    uploadImageBtnTip: 'JPG/PNGのみ対応（10M以内）',
    uploadVideoBtn: '動画アップロード',
    uploadVideoBtnTip: 'mp4/MP4のみ対応（50M以内）',
    videoPlayTip: ' このブラウザは動画非対応です',
    menuVersion: "メニューVer"

  },
  table: {
    search: '検索',
    detail: '詳細',
    actions: '操作',
    edit: '編集',
    publish: '公開',
    delete: '削除',
    cancel: '取消',
    confirm: '確定',
    add: '新規',
    copy: '複製',
    produceCodeRule: '番付ルール',
    batchDeletion: '一括削除',
    batchImport: '一括取込',
    batchCopy: '一括複製',
    export: 'データ出力',
    exportAll: '全件出力',
    import: '取込',
    templateDownload: '雛形ＤＬ',
    dragAndDropUpload: 'ここにファイルをドロップ',
    picture: '画像',
    resetPwd: 'ＰＷリセット',
    more: 'その他',
    reset: 'リセット'
  },
  coffeeData: {
    Text1: "浸漬流量",
    Text2: "浸漬時間",
    Text3: "抽出流量",
    Text4: "抽出圧力",
    Text5: "抽出温度",
    Text6: "注文タイプ",
    Text7: "状態",
    Text8: "出杯時間",
    Text9: "粉量",
    Text10: "機器コード",
    Text11: "商品名称",
    Text12: "コーヒー液",
    Text13: "タンプ圧",
    Text14: "パック厚",
    Text15: "抽出流速",
    Text16: "抽出室位置",
    Text17: "挽き目1",
    Text18: "挽き目2",

  },
  immersivePromo: {
    sampleTitle: '没入プロモ見本',
    sampleDesc: '上段＝このページの本番ナビ（サイドバーと同じ木）。広告帯はページ下に固定、カードだけスクロール。',
    navEmpty: '表示できるナビがありません。ログインと権限を確認してください。',
    navChildren: 'サブメニュー',
    sampleHint: '広告帯は機能入口ではない。右矢印で広告をもっと見る。',
    adRailKicker: 'おすすめ',
    adMore: 'もっと',
    adMoreTitle: '広告をもっと見る',
    navEnter: '開く',
    helpFoot: 'ナビカードは機能へ。広告帯は配信。矢印で全件。',
    surface: '面',
    surfaceHome: '顧客ホーム',
    surfaceDataCenter: 'データ中心',
    portrait: 'ペルソナ',
    portraitOem: '設備OEM',
    portraitDist: '販社',
    portraitChain: '実店舗チェーン',
    ownedSkusHint: '購入済SKU（カンマ区切り）',
    leoInstalled: 'Leo導入済',
    leoActive: '7日活性',
    strategyLabel: '戦略',
    ownedTitle: '開通済み機能',
    promoTitle: '追加可能な能力',
    promoLead: '見た目は機能カード、文言は広告。ホバーで詳細を見てから試用。',
    zoneOwnedHint: '機能入口',
    zoneUnlockHint: '能力発見 · 広告文案',
    tagOwned: '利用可',
    tagPromo: '追加',
    tagCapability: '開通可',
    hoverHint: 'ホバーで詳細',
    adDetailKicker: '試す理由',
    adDetailClose: '閉じる',
    leoQrHint: 'スキャンで Leo を入れる。iPhone は App Store。Android 海外は Google Play、中国大陸はこの区のノード。',
    leoQrAlt: 'Leo ダウンロード QR',
    trialBadge: '無料トライアル',
    adPromoPriceLabel: 'ただいまお得',
    adPriceLabel: '価格',
    adPriceFallback: '無料トライアル · お得な価格は別途',
    ctaOpen: '開く',
    ctaTrial: 'まず試用',
    ctaSign: '試用後に契約',
    ctaSampleOnly: '見本CTA。正式 entitlement は別途',
    ctaTrialHint: 'まず試用。気に入ってから契約。今は課金しません。',
    ctaPathMissing: 'この広告はまだ入れるページに繋がっていません。後でもう一度お試しください。',
    ctaTrialFirst: '次は試用です。契約デスクへは急ぎません。',
    noPromo: 'この組み合わせに追加能力カードなし',
    reload: '再読込',
    goPortraits: '顧客ペルソナ',
    goOrchestrate: '広告編成',
    loadFail: '読込失敗',
    orchDesc: '人はモードと枠だけ選ぶ。いつ・誰に・何を出すかは常に AI。',
    orchMode: '編成モード',
    orchMode1: '1 · 人の枠＋AI',
    orchMode2: '2 · 全面委任',
    orchMode1Hint: '対象／内容／時間を先に設定（一部でも可）。AI はその枠内だけで編成。',
    orchMode2Hint: '制限なし。月テーマは固定、残りはペルソナ。一括全出し禁止。',
    orchAudience: '対象範囲',
    orchContent: '内容',
    orchTheme: '今月のテーマ',
    orchThemeHint: '空＝当月既定（Leo＋雲瞳）。テーマは帯に固定、他はペルソナで補う。',
    orchThemeSkus: 'テーマ SKU',
    orchSchedule: '時間',
    orchSkus: 'SKU／パック',
    orchAny: '制限なし（空＝この軸は不問）',
    orchDates: '期間',
    orchHours: '毎日の時間帯',
    orchStart: '開始',
    orchEnd: '終了',
    orchDailyStart: '開始時刻',
    orchDailyEnd: '終了時刻',
    orchSave: '保存',
    orchSaveOk: '保存済み。AI がこの枠で編成します',
    orchSaveFail: '保存失敗',
    orchLoadFail: '読込失敗',
    orchGoSample: '没入プロモ見本',
    orchHelpFoot: '結果はページ下の広告帯。機能入口カードではない。タイムゾーン Asia/Shanghai。',
    contentDesc: 'モール推薦は4枠固定：タイトル・本文・画像・動画。文言は繁・簡・英・日を同時に出す。枠ごとにAI、または一括生成。修正・自前アップロード可。',
    contentList: '推薦コンテンツ',
    contentTitleCol: 'タイトル',
    contentFmtTitle: 'タイトル',
    contentLangTw: '繁中',
    contentLangZh: '簡中',
    contentLangEn: 'EN',
    contentLangJa: '日本語',
    contentFmtBody: '本文',
    contentFmtImage: '画像',
    contentFmtVideo: '動画',
    contentGenAll: '一括生成',
    contentHint: '人の提案',
    contentHintPh: '例：移動費を強調、7日試用、仕様より便益（方向のみ。原文は貼らない）',
    contentGenPrompts: '生成プロンプト',
    contentGenPromptNote: 'Cursor／製品が書いた生成プロンプト。AI生成はこれを Gemini に渡す。編集してから生成または保存。',
    contentPreview: '広告プレビュー',
    contentPreviewEmptyImg: '画像がまだありません。生成またはアップロード。',
    contentPreviewEmptyVideo: '完成動画はまだありません。生成で再生できる映像が出ます。アップロードも可。',
    contentPreviewStoryboard: '動画絵コンテプレビュー',
    contentGenerate: 'AI生成',
    contentSave: '保存して公開',
    contentHook: 'カード一文',
    contentBlurb: '短文',
    contentDetail: '本文',
    contentBenefits: '便益（1行1件）',
    contentBenefitsPh: '1行1件',
    contentSocial: 'SNS本文',
    contentSource: '出典',
    contentImagePromptPh: '画像プロンプト（AIが書く／編集可）',
    contentVideoPromptPh: '絵コンテ（完成動画はアップロード）',
    contentNote: '顧客への推薦であり硬広告ではない。画像／動画はAI生成、またはアップロードで差し替え。',
    contentSaveOk: '保存し推薦帯に反映',
    contentSaveFail: '保存失敗',
    contentGenOk: 'AI稿を公開した',
    contentGenLlmSkip: '文案AIに繋がらず、カタログ稿を残し提案文は貼っていません。',
    contentGenImageFail: '画像AIに繋がらず、文字ポスターは出していません。',
    contentGenVideoSkip: '短編は実画像が先。今回は生成していません。',
    contentGenFail: '生成失敗',
    contentLoadFail: 'コンテンツ庫の読込失敗',
    contentHelpFoot: '誰にいつ出すかは「広告編成」。ここはモール4枠。プレビューで画像／動画を確認。'
  },
  addonDeviceScope: {
    title: "端末範囲を選択",
    hint: "雲瞳など台数課金：開通する端末または店舗を選択。合計＝単価×台数。",
    confirm: "選択を確定",
    quoteLine: "{count} 台 × {unit} = {total} {currency}"
  },
  commerceMatrixAlert: {
    title: '商業パノラマ：未分類ページ {n} 件（テナント側欄非表示）',
    openMatrix: 'パノラマを開く'
  },
  capabilityAdoptionBanner: {
    title: 'まだ試していない Leo 機能があります',
    start: 'ガイド開始',
    dismiss: '後で'
  },
  billingAddonGuide: {
    panelTitle: 'マイアドオン',
    sidebarPathHint: '固定入口：サイドバー → サービス契約 → アドオン契約 → アドオン一覧',
    trialSection: 'トライアル中',
    paySection: '未払い',
    goPay: '支払う',
    goAddonHub: 'アドオン一覧を開く',
    trialEnds: 'トライアル期限 {date}',
    bannerTrial: 'アドオンのトライアル中 — ホーム「マイアドオン」またはサイドバー「アドオン契約」から。',
    bannerPay: '「{sku}」のトライアル終了 — 継続利用にはお支払いが必要です。',
    bannerPayBtn: '支払う',
    bannerDismiss: '後で',
    sidebarBadgeTrial: '試用',
    sidebarBadgePay: '未払',
    sidebarBadgeTitle: 'アドオントライアルまたは未払い',
    promoTrialPathHint: '未払い・確認待ちは右上カートに表示されます。'
  },
  trialFeature: {
    badgeTrial: '試用',
    summaryPill: '試用中 {n} 件',
    tooltipActive: '{name}：試用中、残り {days} 日',
    tooltipExpiring: '{name}：試用終了間近（残り {days} 日）— 契約してください',
    tooltipExpired: '{name}：試用終了 — 契約して継続利用',
    tooltipPaidActive: '{name}：有料開通済み',
    popoverKicker: '試用状態',
    trialStartOk: '試用を開始しました',
    trialStartFail: '試用の開始に失敗しました',
    trialAlreadyActive: 'すでに試用中です',
    endTrial: '試用を終了',
    endTrialConfirm: '終了するとクラウド瞳は使えなくなり、請求リマインドも止まります。機器付属の基本機能は変わりません。終了しますか？',
    endTrialHint: '不要ならいつでも試用を終了できます。基本機能には影響しません。',
    endTrialOk: '試用を終了しました',
    endTrialFail: '試用の終了に失敗しました',
    addToCart: 'カートに追加',
    addToCartOk: 'カートに追加しました',
    addToCartFail: 'カートへの追加に失敗しました'
  },
  trialReadiness: {
    title: '試用の準備',
    autoDetectIntro: '以下3項目は自動判定です。設定を自分で確認する必要はありません。「再判定」で更新。',
    refresh: '再判定',
    scopeTitle: '試用デバイス範囲',
    scopeHint: '既定は全型番・全台。型番／店舗／SN で絞れます。',
    modelPlaceholder: '型番（未選択＝全部）',
    storePlaceholder: '店舗（未選択＝全部）',
    devicePlaceholder: '機码（未選択＝範囲内全部）',
    deviceEmptyHint: '現在の絞り込みでは選択できる端末がありません。型番／店舗をクリアするか、ブランド配下に端末を登録してください。',
    applyScope: '範囲を適用',
    scopeSaved: '試用範囲を更新しました',
    scopeSaveFail: '試用範囲の更新に失敗',
    guideTitle: 'すぐクラウド瞳を試す',
    guideStep1: 'クラウド試用が ✅ になっていることを確認。',
    guideStep2: '範囲を選び、クラウド瞳対応かつ最低1台オンラインに。',
    guideStep3: '機器一覧 → 操作 → クラウド瞳。',
    guideStep4: '任意：Leo App でスマホからも可。',
    openEntry: '機器一覧へ',
    deviceOnline: 'オンライン',
    deviceOffline: 'オフライン',
    samplesTitle: '範囲内デバイス（快照）',
    sampleNoIris: 'クラウド瞳非対応機種',
    leoAppLoggedIn: '過去 {days} 日に Leo App ログインを検出（ブランド {brandLogins7d} 回）。',
    leoAppNotSeen: '過去 {days} 日 Leo App ログインなし。SOC アプリ商店からインストール（SOC 試用は任意）。',
    leoAppDetectHint: '会員ログイン監査を自動参照。手動確認不要。',
    cloudReady: 'クラウド試用が有効。SOC クラウド瞳が使えます。',
    cloudMissing: 'クラウド試用が未反映。更新または再開通してください。',
    cloudDetectHint: '加購 entitlement の試用状態を自動確認。',
    cloudTrialBypassNote: '試用中は「クラウド瞳遥控」ロール未設定でも開けます。',
    deviceReady: '範囲内 {ready}/{total} 台が試用可能（対応機種かつオンライン）。',
    deviceNone: '範囲内に機器がありません。登録または条件変更。',
    deviceNoIrisSupport: '範囲内 {total} 台あるがクラウド瞳非対応機種のみ（茶／コーヒー族）。',
    deviceNeedsOnline: '対応 {irisCapable} 台、オンライン {online} 台。電源・通信を確認。',
    deviceDetectHint: 'オンライン状態と機種のクラウド瞳対応を自動判定。',
    actionLeoApp: 'SOC アプリ商店で入手',
    actionDevices: '機器一覧を開く',
    check: { leoApp: 'Leo App', cloud: 'クラウド権限', device: 'オンライン＋クラウド瞳対応' }
  },
  billingCart: {
    title: '請求カート',
    empty: '未払い・確認待ちはありません',
    refresh: '更新',
    trackAddon: 'アドオン',
    trackContract: '契約',
    statusConfirm: '確認待ち',
    statusPay: '支払待ち',
    statusTrial: '試用購入待ち',
    statusRenew: '更新待ち'
  },
  billingOrder: {
    documentTitle: 'XRROSS サービス注文書',
    documentSubtitle: '料金明細と合計を確認してから承認／お支払いください（商業 Order Form）',
    orderNo: '注文番号',
    orderDate: '発行日',
    partyTitle: '当事者',
    seller: '売主',
    buyer: '買主（ブランド）',
    currency: '通貨',
    billType: '注文種別',
    lineItems: '明細',
    salesOrderTitle: '販売注文明細',
    scheduleOfFeesTitle: '料金明細（Schedule of Fees）',
    stickyPayLabel: 'お支払い合計',
    stickyPayHint: 'プラン：{scheme} · 現在 {devices} 台',
    deviceSummaryHint: '設備カテゴリと単価でグループ表示。同単価は台数をまとめて表示。',
    feeSummaryTitle: '料金サマリー',
    listExTaxUsd: 'USDリスト（税抜）',
    fxRate: '為替レート',
    subtotalExTax: '税抜小計',
    addonExtra: '追加（雲瞳など）',
    taxAmount: '税額',
    colLineNo: 'No.',
    colSku: 'SKU',
    colMachineCode: '機番',
    colDeviceType: '設備タイプ',
    colModel: '機種',
    colSite: '所属',
    colService: 'サービス',
    colServiceDefault: 'デバイスデータ年額',
    grandTotal: '合計',
    colDescription: '説明',
    colSegment: 'セグメント',
    colQty: '数量',
    colUom: '単位',
    colUnitPrice: '単価',
    colBillingFreq: '課金周期',
    colAmount: '行金額',
    freqYearly: '年',
    freqMonthly: '月',
    termsTitle: '条項と声明',
    termsHint: 'お支払い前に展開してお読みください。確認・支払いで条項に同意したものとみなします。',
    paymentTermsTitle: '支払条件',
    paymentTermsSummary: '本注文の支払条件：{term}。',
    paymentTermsSummaryDefault: '本注文の通貨・金額が正本です。指定期限内にお支払いください。',
    paymentTermsBody1: '延滞時はサービス停止の場合があります。既払いは契約／アドオン条項に従います。',
    paymentTermsBody2: '決済手数料・為替差は支払者負担。XRROSS 会社口座入金をもって完了とします。',
    usageTermsTitle: '利用条件',
    usageTermsSummaryContract: 'SOC ポータル・デバイスデータ・店舗サブスクは、許可されたブランドと店舗／デバイスのみ利用可能です。',
    usageTermsSummaryAddon: 'アドオン「{sku}」は支払／試用範囲内のみ有効。更新しない場合は機能停止またはダウングレードします。',
    usageTermsBody1: '企業を代表する権限があることを表明します。アカウント操作とリモート操作は企業の責任です。',
    usageTermsCancelAnytime: '本アドオンはいつでも解約可能。次回請求は発生しません。既払期間の返金はありません。',
    serviceTermsTitle: 'サービス条項と免責',
    serviceTermsBody1: 'XRROSS SOC はプライバシーポリシー・利用規約・免責事項に基づき提供されます。',
    serviceTermsBody2: '電子確認・支払タイムスタンプ・アカウント記録は履行証拠となり得ます。',
    viewPlatformTerms: 'プラットフォーム条項全文',
    totalDue: 'お支払合計',
    promoTitle: 'クーポン',
    promoSelectHint: '利用可能なクーポンを選択して適用（1注文1回のみ）。',
    promoApplyBtn: 'クーポンを適用',
    promoAppliedTitle: '適用済みプロモ',
    promoDiscount: '割引',
    promoSubtotalBefore: '割引前小計',
    promoEmpty: '利用可能なクーポンがありません',
    trialEndsAt: '試用終了',
    paymentTermNet7: '請求後7日以内',
    paymentTermNet15: '請求後15日以内',
    paymentTermNet30: '請求後30日以内',
    paymentTermNet45: '請求後45日以内',
    paymentTermNet60: '請求後60日以内',
    paymentTermPrepaid: '前払い',
    paymentTermDueOnReceipt: '請求書受領時支払'
  },
  brandServiceContract: {
    title: 'サービス契約',
    pageDesc: 'ブランドの料金条件を設定。メール／電子署名確認後に有効化。terms_json が自動請求の正本。',
    helpTitle: 'ページ説明（展開）',
    help1: 'ブランドと3つの料金方式から選択。',
    help2: '確認手段：メール／電子署名／ポータル／オフライン。',
    help3: 'データ契約は ACTIVE を参照。Leo 基本は機体購入に含む。追加は試用後課金・いつでも取消可。',
    create: '新規契約',
    tabContracts: '契約一覧',
    tabEntitlementTree: '権限ツリー',
    treeNeedBrand: 'ブランドを選び、サイドバーと同じツリーで購入済／未購入を確認してください。',
    treePickContract: '契約を選択',
    treeInContract: '契約内',
    treeLockedPrice: '固定単価',
    treeQty: '数量',
    treePayable: '支払額',
    treeLineStatus: '状態',
    treeStatusInScope: '購入済',
    treeStatusNotPurchased: '未購入',
    treeFilterInContract: '購入フィルタ',
    treeFilterAll: 'すべて',
    treeFilterPurchased: '購入済のみ',
    treeFilterNotPurchased: '未購入のみ',
    treeFilterKeyword: 'メニュー／SKU 検索',
    createTitle: 'ブランドサービス契約を作成',
    bundleTier: '四段階プラン',
    bundleTierT1: '① SOC のみ $49/店/月',
    bundleTierT2: '② 全店パック $199/店/月',
    bundleTierT3: '③ 端末のみ従量',
    bundleTierT4: '④ SOC $99 + 端末従量',
    bundleTierPaperLock: '紙契約ロック（価格表で再計算しない）',
    priceBookSku: '価格表テンプレ',
    priceBookSkuPh: 'HQ 価格表から契約課金を選択',
    needPriceBookSku: '価格表 SKU を選択してください。なければ契約金額を計算できません',
    brand: 'ブランド',
    brandId: 'ブランドID',
    status: '状態',
    statusDraft: '下書き',
    statusPendingHqApproval: '本社承認待ち',
    statusApproved: '承認済',
    statusPendingTenantConfirm: 'テナント確認待ち',
    statusPendingPay: '支払待ち',
    statusActive: '有効',
    statusSuspended: '停止',
    statusExpired: '期限切れ',
    statusCancelled: '取消',
    contractNo: '契約番号',
    pricingMethod: '料金方式',
    pricingTiered: '年額＋台数階段',
    pricingPerDevice: '端末周期料金',
    pricingPerStoreMonth: '店舗／月（最低月数あり）',
    pricingPerDeviceMonth: '端末／月（最低月数あり）',
    pricingPerStoreDay: '店舗／日従量',
    pricingPerDeviceDay: '端末／日従量',
    minContractMonths: '最低契約月数',
    periodMonths: '本件契約月数',
    dayCount: '利用日数',
    pricingSocStore: 'SOC 店舗サブスク（推奨）',
    addonPricingOneTime: '一回限りアドオン',
    addonPricingPerDeviceYear: '台／年',
    addonPricingPerStoreYear: '店舗／年',
    addonPricingPerHouseholdYear: '世帯／年',
    addonPricingTrialThenPaid: '試用後有料',
    addonPricingAiPoints: 'AIポイントパック',
    addonPricingModule: 'モジュールアドオン',
    addonPricingCustomQuote: '個別見積',
    paymentTerm: '支払条件',
    currency: '通貨',
    confirmChannel: '確認手段',
    confirmStatus: '確認状態',
    confirmNone: '未確認',
    confirmPendingEmail: 'メール確認待ち',
    confirmPendingEsign: '電子署名待ち',
    confirmEmailOk: 'メール確認済',
    confirmSigned: '電子署名済',
    confirmPortalOk: 'ポータル確認済',
    confirmRejected: '拒否',
    confirmExpired: '確認期限切れ',
    confirmPendingTenant: 'テナント確認待ち',
    cycleYearly: '年次',
    cycleQuarterly: '四半期',
    cycleMonthly: '月次',
    cycleDaily: '日次',
    paymentTermDepositBalance: '頭金＋残金',
    paymentTermInstallment: '分割払い',
    period: '周期',
    actions: '操作',
    tierCode: 'プラン',
    unitPrice: '単価',
    tiers: '階段',
    addTier: '階段を追加',
    legacyOral: '口頭旧約',
    confirmSection: '契約確認',
    chEmail: 'メール確認',
    chEsign: '電子署名',
    chPortal: 'ポータル確認',
    chManual: 'オフライン／口頭',
    confirmEmail: '確認メール',
    signerRole: '署名者役割',
    signerName: '署名者名',
    mailLocale: 'メール言語',
    requireConfirm: '有効化前に確認必須',
    addonTitle: 'SOC／Leo 追加（試用・いつでも取消）',
    addonHint: '機体購入で Leo 基本無料。この表は追加のみ。家庭／商用で分離。',
    addonHome: '家庭',
    addonCommercial: '商用',
    addonName: '名称',
    addonTrialDays: '試用日数',
    addonUsdPrice: 'USD 価格',
    addonBillingCycle: '課金周期',
    addonBillingYearly: '年払い',
    addonBillingMonthly: '月払い',
    addonCancel: '取消可',
    addonStartTrial: '試用開始',
    addonWxPay: 'WeChat Pay',
    addonPaypal: 'PayPal',
    addonPaypalOpen: 'PayPal 決済ページを開きました（海外 USD）',
    addonPaypalStub: 'Stub で有効化（実入金ではない）',
    addonPaypalNoUrl: 'PayPal の URL がありません',
    addonWxTitle: 'XRROSS 会社 WeChat 決済',
    addonWxHonesty: 'SOC／ハード販売の会社入金。店舗客単ではない。キー未設定時は模擬QR。',
    addonWxSim: '模擬支払済',
    addonWxPaid: '支払済を記録（模擬≠実入金）',
    addonWxQrFail: 'QRを生成できません',
    addonWxNoEntitlement: '試用レコードがありません',
    addonNeedBrand: '先にブランドを選択してください',
    addonTrialOk: '試用を開始しました',
    quoteLine: '見積：約 {amount} {currency}/{period}（台数 {devices}、店舗 {stores}）',
    quoteTrackA: 'A 小計（デバイスデータ）',
    quoteTrackB: 'B 小計（店舗運営）',
    quoteBundle: 'セット価格',
    quotePayable: '支払額',
    quoteExTax: '税抜小計',
    quoteExTaxShort: '税抜',
    quoteTax: '税額',
    quoteTaxInclusive: '税込合計',
    taxRegion: '課税税区',
    quoteExportPdf: '見積を出力',
    quotePrintTitle: '公式見積',
    needBrandPricing: 'ブランドと料金方式を選択',
    needEmail: 'メール確認にはメール必須',
    sendEmail: '確認メール送信',
    portalAck: 'ポータル確認',
    markEsign: '署名完了',
    activate: '有効化',
    suspend: '停止',
    suspendReason: '停止理由（任意）',
    esignUrlHint: '署名ファイルURL（任意）',
    mailSent: '確認メール送信済み',
    mailStub: 'メール未送信（トークン生成済み）',
    summaryTitle: '契約総表',
    summaryPageDesc: '各ブランドの確認・支払・開通状況を一覧。詳細で内訳を確認。',
    summarySimpleIntro: 'ここに出るのは ① プラットフォーム利用料 ② 追加機能 ③ 機器購入の支払い。各行は1件のことで、重複ではありません。',
    summaryGoDesk: '新規契約',
    startPipeline: '標準フローを開始',
    pipelineTitle: '契約の標準フロー',
    pipelineDesc: '下書き→本社承認→ブランド確認→支払→有効化。ノードをクリックして該当ページとガイドを開きます。',
    pipelineNow: '現在',
    flowNode_bsc_draft: '下書き',
    flowNode_bsc_hq_approve: '本社承認',
    flowNode_bsc_tenant_confirm: '確認',
    flowNode_bsc_pay: '支払',
    flowNode_bsc_active: '有効',
    addonStartPipeline: '加購フローを開始',
    addonPipelineTitle: '加購の標準フロー',
    addonPipelineDesc: '試用／購入→支払→有効化（標準SKUは本社承認不要）。',
    flowNode_sla_start: '試用／購入',
    flowNode_sla_pay: '支払',
    flowNode_sla_active: '有効',
    quickAll: 'すべて',
    quickActionAdmin: '要対応（本部）',
    quickActionTenant: '要確認',
    quickPay: '未払い',
    quickOverdue: '期限超過',
    quickActive: '開通済み',
    statPendingPay: '未払い',
    statOverdue: '期限超過',
    statActive: '開通済み',
    filterBrandPh: 'ブランド検索',
    filterTypePh: '費用タイプ',
    showAdvanced: '詳細フィルタ',
    hideAdvanced: 'フィルタを閉じる',
    colBrand: 'ブランド',
    colItem: '費用の種類',
    colSituation: 'いまの状態',
    colAmount: '支払額',
    colDueDate: '次回期限',
    trackShortContractA: 'プラットフォーム料',
    trackShortAddonB: '追加機能',
    trackShortHardware: '機器購入',
    situationPendingHq: '本部承認待ち',
    situationPendingConfirm: '確認待ち',
    situationPendingPay: '支払待ち',
    situationOverdue: '期限超過',
    situationActive: '開通済み',
    situationSuspended: '停止中',
    situationDraft: '下書き',
    situationHardware: '機器支払い',
    situationOther: 'その他',
    actionApprove: '承認',
    actionConfirm: '確認へ',
    actionReject: '却下',
    goDesk: '契約台',
    paymentStatus: '支払状態',
    payUnpaid: '未払',
    payPaid: '支払済',
    payPartial: '一部支払',
    payOverdue: '延滞',
    amountDue: '請求額',
    amountPaid: '支払済額',
    nextDueAt: '次回期日',
    expiredOnly: '期限切れ／延滞のみ',
    editPayment: '支払編集',
    editPaymentTitle: '支払状態を編集',
    totalContracts: '契約数',
    totalActive: '有効',
    totalUnpaid: '未払／一部',
    totalOverdue: '支払延滞',
    totalDue: '請求合計',
    totalOutstanding: '未収合計',
    viewDetail: '詳細',
    detailTitle: '契約詳細',
    detailPageDesc: '商業 Order Form（機種／数量／単価／合計）と課金履歴。確認ページと同一。',
    backSummary: '総表へ戻る',
    goConfirmOrder: '確認／サインバックを開く',
    detailPayWaitHq: 'HQ承認待ちのため、まだ確認・支払いできません。',
    detailPayWaitConfirm: 'ポータル確認後、支払待ちになると支払ボタンが表示されます。',
    detailPayNoAction: 'この状態では支払えません。右上の確認／支払へ進んでください。',
    detailMerchant: '商戶',
    detailScope: '製品／サービス範囲',
    detailPricing: '価格・課金',
    detailDates: '有効・期限',
    detailChargeHistory: '課金履歴',
    chargeTime: '時刻',
    chargeEvent: 'イベント',
    chargeNote: '備考',
    amountDelta: '支払増減',
    effectiveFrom: '開始',
    effectiveTo: '終了／期限',
    devicesStores: '課金台数／店舗数',
    detailLoadFail: '詳細の読込に失敗',
    track: 'トラック',
    trackContractA: 'サービス契約',
    trackAddonB: 'アドオン',
    trackHardware: 'ハードウェア調達',
    deskPhase: 'フェーズ',
    phasePendingHq: '本部承認待ち',
    phasePendingConfirm: '確認待ち',
    phasePendingPay: '支払待ち',
    phaseOverdue: '延滞',
    phaseSuspended: '停止',
    hqApprove: '本部承認',
    hqReject: '本部却下',
    hqApproveOk: '承認済み・通知送信',
    hqRejectOk: '却下済み',
    submitApproval: '審批提出',
    batchSelected: '{n} 件選択',
    batchSubmit: '一括審批提出',
    batchHqApprove: '一括本部承認',
    batchHqReject: '一括本部却下',
    batchSendEmail: '一括確認メール',
    batchActivate: '一括有効化',
    batchSuspend: '一括停止',
    batchClear: '選択解除',
    batchAllOk: '{n} 件すべて成功',
    batchPartial: '成功 {ok}／失敗 {fail}（{err}）',
    batchConfirmSubmit: '{n} 件を本部審批に提出しますか？',
    batchConfirmActivate: '{n} 件を有効化しますか？',
    contractLineItem: 'サービス項目',
    priceLockedHint: '単価は価格表からロック済み。確認後に契約へ反映',
    discountPct: '割引％',
    discountPctPh: '0＝割引なし',
    discountReasonPh: '割引理由（任意）',
    hqRejectReasonPh: '却下理由',
    billingConfirmTitle: '請求確認',
    schemePickTitle: '料金プランを選択',
    addonTrackBTitle: '併記アドオン（Track B）',
    addonTrackBHint: '雲瞳などアドオンを Track A 契約と同ページに表示。課金 entitlement は別管理で、総表にまとめて出ます。',
    cloudIrisPickHint: '署名前に雲瞳を付ける機器を選べます。台数で金額が再計算されます。',
    cloudIrisPickBtn: '機器を選ぶ',
    cloudIrisPickOk: '雲瞳の機器範囲を更新しました',
    schemePickHint: 'プランを選ぶと下の金額と明細がすぐ更新されます。マウスを乗せると説明と単価内訳を表示。確定前にロックしてください。',
    schemePickHintSimple: 'カードでプランを選び、同じカード内で数量段階を選ぶと合計がすぐ更新されます。',
    schemePickHintPaperLock: '紙の契約で年額と台数上限が固定されています。価格表では再計算しません。確認して署名してください。',
    tierEmbedTitle: '数量段階を選ぶ（多いほどお得）',
    tierEmbedHint: '段階をタップ。現在段階は表示済み。上位段階は最小台数の前払で単価が下がります。',
    storeTierEmbedTitle: '店舗数段階を選ぶ（多いほどお得）',
    storeTierEmbedHint: '段階をタップ。現在段階は表示済み。上位は最小店舗数の前払が必要です。',
    brandRoleTitleReadonly: 'お客様の区分',
    brandRoleLockedHint: 'プラットフォーム設定・変更不可',
    schemeCardBlurbDefault: '選択すると下に合計と明細が表示されます。',
    deviceTierLadderHint: '台数が多いほど単価が下がります。現在台数で各段階を比較します。',
    storeTierLadderHint: '店舗数が多いほど単価が下がります。現在店舗数で各段階を比較します。',
    tierLadderTitle: '台数段階（多いほどお得）',
    storeTierLadderTitle: '店舗数段階（多いほどお得）',
    tierLadderBand: '段階',
    tierLadderRange: '台数範囲',
    tierLadderDiscount: '割引',
    tierLadderUnit: '実効単価',
    tierLadderQty: '課金台数',
    tierLadderQtyStore: '課金店舗数',
    tierLadderTotal: '小計',
    tierLadderSaveVsPrev: '前段階よりお得',
    tierLadderSaveVsPrevAmt: '同台数で前段階より {amount} お得',
    tierLadderCurrent: '現在の段階',
    tierLadderNegotiated: '個別協議',
    tierLadderNeedPrepaid: '前払≥{count}',
    tierLadderNeedPrepaidStore: '前払≥{count}店',
    tierLadderFootnote: '現在 {count} 台で比較。より安い単価にはその段階の最小台数の前払が必要です。',
    schemeHoverHint: 'マウスを乗せてプラン説明と単価内訳を表示',
    schemeUnitComposeTitle: '単価の内訳',
    schemeUnitComposeEmpty: 'このプランには台／店ごとの単価内訳がありません（合計を参照）。',
    schemeUnitComposeFlat: '単価 {unit} {currency} × {qty}',
    schemeUnitComposeTotalOnly: '合計見積 {total} {currency}（これ以上の単価分解なし）。',
    schemeExplain_DEFAULT: '金額は価格表からの見積です。ロックすると契約の支払額と明細に反映されます。',
    schemeExplain_T1: '① 純 SOC：店舗 SOC 月額のみ。機器年額は請求に含まれません。既に機器がある場合は②全店パックまたは④ SOC＋機器を選んでください。',
    schemeT1DeviceGuideTitle: 'T1 純 SOC は機器料金を含みません',
    schemeT1DeviceGuideDesc: 'ブランド配下に約 {count} 台あります。$49/月は SOC のみで機器年額は自動加算されません。機器も課金する場合は全店パックまたは SOC＋機器へ変更してください。',
    schemeT1DeviceBlockTitle: '備考（T1 純 SOC）',
    schemeT1DeviceBlockDesc: 'ブランド配下に約 {count} 台あります。機器がある場合、T1（$49／純 SOC）は通常対象外です。確定前に全店パックまたは SOC＋機器をご検討ください。',
    brandRoleTitle: 'ブランド類型（推奨に影響）',
    brandRoleOperator: 'ブランド運営',
    brandRoleEquipment: '機器メーカー／販路',
    schemeRecommendTitle: 'システム推奨 · 最安',
    schemeRecommendBadge: '推奨',
    schemeRecommendApply: '推奨を適用',
    schemeRecommendApplied: '推奨プランと支払节奏を適用しました',
    schemeRecommendReasonNone: '推奨できるプランがありません。手動で選んでください。',
    schemeRecommendReasonEquipment: '機器側と判定（約 {deviceCount} 台・{storeCount} 店）：SOC 不要。機器プラン {code} を推奨、年換算約 {amount} {currency}。',
    schemeRecommendReasonOperator: '運営側と判定（約 {storeCount} 店・{deviceCount} 台）：候補中 {code} が最安、年換算約 {amount} {currency}。',
    schemeRecommendReasonOperatorAnnual: '運営側：{code} を推奨し年一括85%で試算、約 {amount} {currency}/年。',
    schemeExplain_T2: '② 全店パック：店舗／月の SOC パック（純 SOC より上位）。機器明細をまだ分けない場合向け。',
    schemeExplain_T3: '③ 機器のみ（年額）：ブランド配下の各機器データ年額を機種／機番で明細化。SOC 店舗料は含みません。',
    schemeExplain_T4: '④ SOC＋機器：店舗 SOC と各機器年額をまとめて見積。',
    schemeExplain_PER_DEVICE_YEARLY: '台ごと年額：機器1台＝1行。単価は価格表 SKU。合計＝各行の合計。',
    schemeExplain_TIERED_ANNUAL_POOL: '台数プール段階年額：ブランド配下台数で段階単価。照合用に台別明細も出せます。',
    schemeLockBtn: 'このプランを確定',
    schemeLockOk: '料金プランを確定しました',
    schemeLockFail: 'プラン確定に失敗（select-scheme API が必要）',
    deviceTierLockTitle: '台数ティア（設備データ）',
    deviceTierLockHint: '現状台数で課金するか、前払いティアを選び、その下限台数で前払い・単価固定します。',
    deviceTierModeActual: '現状台数（{count} 台）',
    deviceTierModePrepaid: '前払いティアラック',
    committedDeviceCountLabel: '確約台数',
    committedDeviceCountHint: '現状台数以上。ロック後は確約台数で課金します。',
    committedDeviceCountInvalid: '確約台数は現状 {min} 台以上にしてください',
    storeTierLockTitle: '店舗数ティア（店舗プラン）',
    storeTierLockHint: '店舗プラン選択後、現状店舗数か前払いティア（下限店舗数）を選べます。',
    storeTierModeActual: '現状店舗数（{count}）',
    storeTierModePrepaid: '前払いティアラック',
    tierBandPickHint: 'ティアを選択。前払い数＝max(下限, 現状)。',
    tierBandPrepaidMin: '前払い {count} 台',
    storeTierBandPrepaidMin: '前払い {count} 店舗',
    tierBandRequired: 'ティアを選択してください',
    tierBandUnavailable: '現状数量ではこのティアは選べません。上位を選んでください',
    tierGrowthPolicyHint: '契約期内の追加（同ティア内）は固定単価×残期間で精算。次ティア超過は改訂が必要（自動昇格なし）。',
    paymentCadenceTitle: '支払节奏（条件割引）',
    paymentCadenceHint: '月額固定部分は毎月払い、または12ヶ月一括85%割引。機器年額は割引対象外。ロックで支払額を更新します。',
    paymentCadenceMonthly: '毎月払い',
    paymentCadenceMonthlyNote: '当月の月額固定（他の年額行は別）',
    paymentCadenceAnnual: '年一括 · 85%（15%OFF）',
    paymentCadenceAnnualNote: '月額×12×0.85を一括（年額行は定価）',
    paymentCadenceLockBtn: 'この支払节奏を確定',
    paymentCadenceLockOk: '支払节奏を確定し、支払額を更新しました',
    paymentCadenceLockFail: '支払节奏の確定に失敗',
    billingConfirmDesc: '本部承認後、ここで条項を確認してください。',
    billingConfirmBtn: '条項に同意',
    billingConfirmOk: '確認済み・お支払いへ',
    billingConfirmDone: '確認済みまたは不可',
    billingConfirmMissing: 'track/sourceId 不足または権限なし',
    billingPayActive: 'サービス開通済み'
  },
  opsAnalytics: {
    subtitle: '自店／エリアのグラフ＋AI提案；競合は別アドオン',
    month: '月',
    storeId: '店舗ID',
    query: '照会',
    goPnl: 'P&L台',
    skuHint: 'グラフ／エリア：COM_ANALYTICS_AI；競合＋深いAI：COM_COMPETITOR_INTEL＋AIポイント',
    areaTitle: 'エリア比較',
    store: '店舗',
    compTitle: '競合分析',
    compSku: '競合インテリ',
    compName: '競合',
    rating: '評価',
    reviews: '口コミ数',
    priceBand: '価格帯',
    salesHonesty: '売上の誠実表示',
    aiTitle: 'AI提案（短）',
    catalogTitle: 'レポート一覧（最大集）',
    kpi: { revenue: '売上', gross: '粗利', net: '純額', aov: '客単価', tickets: '件数', labor: '人件費比' },
    charts: { rev: '売上推移', hour: '時間帯', item: '商品順位', channel: 'チャネル', area: 'エリア順位' }
  },
  tokenBilling: {
    pageTitle: 'AI ポイント請求',
    pageLead: 'ログイン企業の Leo 利用量と課金を集計。対外名称は AI ポイント、内部は token ledger。上流コストと参考価格で粗利を概算（過去30日）。'
  },
  leoE2: {
    webMarketSearch: '売れ筋ウェブ検索',
    webMarketHintTitle: '売れ筋検索は接続済み（草案のみ）',
    webMarketHintDesc: '公開情報を検索し用料草案に解析。DRAFT のみ。物料ID予検と人ゲートは必須。生産ハードグリーンではない。自動下発なし。',
    webQuery: '検索語',
    webQueryPh: '例：人気ティーメニュー 用料（空なら既定の売れ筋クエリ）',
    webSearchBtn: '検索して開場へ',
    webSearchFail: '売れ筋ウェブ検索に失敗',
    e21Tab: 'E21 智能配方',
    e21AlertTitle: 'E21 対話試泡クローズドループ（茶機一期・シミュレータ先行）',
    e21Banner: '流れ：セッション開始 → 初回適用ゲート → 試泡 → 味フィードバック → 正式保存 PRIVATE+VERIFIED。PRODUCTION は会話可・下発不可。硬規：茶機の試泡は散葉茶、粉末ではない。',
    e21Entry: '入口',
    e21HasMenu: 'メニュー／品目テキストあり',
    e21CompetitorPaste: '競合レシピ貼り付け',
    e21MenuText: 'メニュー本文',
    e21MenuPh: '顧客メニュー／競合用料を貼り付け、草案をコンパイルして E21 開場にする',
    e21ApplyOpener: '開場へ転入',
    e21TrialMaterial: '現在の試泡物料：{label}',
    e21TeaLeaf: '茶葉',
    e21TargetUrn: '対象機 URN',
    e21DeviceOpsMode: 'deviceOpsMode',
    e21StartMessage: '開場',
    e21Start: 'セッション開始',
    e21ConfirmFirst: '初回適用を確認',
    e21Trial: '試泡',
    e21FormalSave: '正式保存',
    e21TurnFeedback: '多輪／フィードバック',
    e21TurnPh: '例：少し苦いので薄く／満足したので正式保存',
    e21SendTurn: 'turn 送信',
    e21SendFeedback: 'feedback 送信',
    e21SessionState: 'セッション状態',
    e21NeedUrnAndMessage: '対象機と開場を入力してください',
    e21SessionOpened: 'E21 セッション開始済み',
    e21StartFail: 'セッション開始に失敗',
    e21FirstConfirmed: '初回適用を確認しました',
    e21FirstCancelled: '初回適用を取り消しました',
    e21FirstFail: '初回適用に失敗',
    e21TrialStarted: '試泡を開始しました',
    e21TrialFail: '試泡に失敗',
    e21NeedUtterance: '発話を入力してください',
    e21TurnFail: 'turn に失敗',
    e21NeedFeedback: 'フィードバックを入力してください',
    e21FeedbackOk: 'フィードバックを受け取りました',
    e21FeedbackFail: 'feedback に失敗',
    e21Saved: 'PRIVATE+VERIFIED で保存しました',
    e21SaveCancelled: '保存を取り消しました',
    e21SaveFail: '正式保存に失敗',
    e21HotSellOpener: '市場の売れ筋茶を検索'
  },
  x600hProductionOrder: {
    pageDesc: '二系統：Androidはまずクラウド接続、9100はHF配網。その後バインド／初検／出荷。このページから標準パイプラインを開始できます。',
    startStandardPipeline: '全自動流水線を開始',
    socPipelineNodeTodo: '未開始',
    socPipelineNodeCurrent: '進行中',
    socPipelineNodeDone: '完了',
    startOpenStorePipeline: '開店パイプライン開始',
    startBusinessHoursPipeline: '営業時間パイプライン開始',
    pipelineStarted: '一括追加の全自動流水線を開始しました（工場作成含む）。ノードに従ってください。',
    togoOpen: '残作業',
    togoTitle: '工単の残作業',
    togoRemain: '残り {n} ステップ',
    togoAllDone: '4ステップ完了',
    togoStuck: '停滞',
    togoHint: 'チェックはシステム状態のみ。停滞ステップで実ページへ、または Leo に話して同一伝票を埋めます。',
    togoVoice: 'Leo に話す',
    togoClose: '閉じる',
    togoLoadFail: '残作業の読込に失敗',
    togoStep_demand_placed: '需要を受注済み',
    togoStep_hq_confirm: '本社確認',
    togoStep_factory_ready: '工場納品可',
    togoStep_customer_activate: '顧客現場起動',
    flowNow: '現在',
    flowHint: '箱が一本の線：緑は完了、黄は停滞、灰は未着手。箱を押すとこの伝票の該当位置へ。',
    flowNode_hq: '本社確認',
    flowNode_open: '伝票を開く',
    flowNode_bind: '読取バインド',
    flowNode_handshake: '9100ハンドシェイク',
    flowNode_ship: '出荷確認',
    flowNode_activate: '顧客起動',
    simplePipelineTitle: '全自動流水線：一括追加',
    simplePipelineDesc: 'グローバル設備管理のため：工場作成→供給登録→生産注文→システム確認待ち。機器一覧の手作成で代用しないでください。',
    pipelineNow: '現在',
    pipelineDone: '完了',
    pipelineTodo: '未着手',
    pipelineWaitHq: 'システム確認待ち',
    flowNode_bbds_create_factory: '工場作成',
    flowNode_bbds_register_s0: '供給登録',
    flowNode_bbds_create_order: '生産注文',
    flowNode_bbds_wait_hq: 'システム確認待ち'
  },
  deviceOrderLifecycle: {
    title: '機器主鎖案内',
    desc: '受注〜顧客：S1～S7 で実ページへ。HQ／ブランド／工場ごとにスマートガイド起動。',
    roleHq: '本社',
    roleBrand: 'ブランド',
    roleFactory: '工場',
    hintHq: '本社：承認・発番・全鎖の確認。',
    hintBrand: 'ブランド：受注・受領／委譲・顧客有効化入口。',
    hintFactory: '工場：クラウド／HF配網、バインド、初検、出荷確認（主UIはLeo工場パック）。',
    startSmartGuide: 'この役割のスマートガイド開始',
    openPage: 'このステップのページを開く',
    prev: '前へ',
    next: '次へ',
    guideStarted: 'スマートガイド開始。Leo アシスタントで続行。',
    guideStartFail: 'スマートガイドを開始できません（権限またはバックエンド未再起動）',
    s1Title: '生産注文作成',
    s1Short: 'ブランド作成',
    s1Body: '生産注文で数量・型番・クラウド地域を作成。本社確認待ち。',
    s2Title: '本社確認',
    s2Short: '確定ロック',
    s2Body: '本社確認後、数量／型番／地域がロックされ発番・生産へ。',
    s3Title: '発番同期',
    s3Short: '跨区発番',
    s3Body: '発番同期で番号帯とレプリカ ACK を確認。',
    s4Title: '配網・バインド・初検',
    s4Short: '工場ライン',
    s4Body: 'Androidは先にクラウド接続、9100は先にHF配網。その後スキャンバインドと初検。手入力は主経路にしない。',
    s5Title: '出荷確認',
    s5Short: '納品可',
    s5Body: '初検後に出荷確認。未出荷は顧客有効化不可。出荷≠課金開始。',
    s6Title: '受領／委譲',
    s6Short: '店舗／顧客',
    s6Body: 'ブランドが機器リストで受領または店舗／顧客へ委譲。',
    s7Title: '初起動／現場配網',
    s7Short: '課金開始',
    s7Body: 'Leo「現場配網」でクラウド地域→Wi‑Fi。「Wi‑Fi変更」はSTAのみ。初起動後に顧客有効化（工場出荷≠課金開始）。認証ページでゲート列を確認。'
  },
  globalDevice: {
    catalogTitle: '型番カタログ',
    catalogDesc: '新型番は申請・審査が必要。東京の書込中心のみが総表へ承認できます。',
    catalogHint: 'グローバル型番：ノード申請 → 東京承認',
    catalogApply: '新型番を申請',
    applyManageTitle: '型番申請',
    applyManageDesc: '各ノードの型番申請を管理：提出、審査待ち、東京承認／却下。',
    submitApply: '申請を提出',
    applyRequired: '型番コードと名称は必須です',
    applySubmitted: '提出済み（PENDING）',
    modelKey: '型番コード',
    modelName: '型番名称',
    deviceFamily: 'デバイス族',
    applyStatus: '申請状態',
    applicantRegion: '申請リージョン',
    publishedModelId: '公開済み型番ID',
    rejectReason: '却下理由',
    notes: '備考',
    approve: '承認',
    reject: '却下',
    confirmApprove: '承認して東京総表へ書き込みますか？',
    approved: '承認し総表へ反映しました',
    rejected: '却下しました',
    waitingTokyo: '東京審査待ち',
    centerRole: '書込中心ロール',
    statusPending: '審査待ち PENDING',
    statusApproved: '承認済み APPROVED',
    statusRejected: '却下 REJECTED',
    openApplyManage: '型番申請管理を開く',
    governanceGapJump: '整治ギャップ',
    simplePipelineTitle: '全自動流水線：新型番申請',
    simplePipelineDesc: 'グローバル設備管理のため：申請ページを開く→1件提出→東京承認待ち。ローカルで正式型番を作らないでください。',
    pipelineNow: '現在',
    pipelineDone: '完了',
    pipelineTodo: '未着手',
    pipelineWaitTokyo: '東京待ち',
    startSimplePipeline: '全自動流水線を開始',
    pipelineStarted: '型番申請の全自動流水線を開始しました。ノードに従ってください。',
    flowNode_bcas_open_apply: '申請ページを開く',
    flowNode_bcas_submit_apply: '申請を提出',
    flowNode_bcas_wait_tokyo: '東京審査待ち'
  },
  dispenserDataCenter: {
    precisionDesc: '精度 = 実排出 ÷ レシピ排出。ディスペンサー品質監視用。',
    lossDesc: '素材別にレシピと実排出の差分を見てロス／過多を把握します。',
    multiMachineDesc: 'ディスペンサー↔ティーマシン連携作業台への入口です。',
    refresh: '更新',
    imiePlaceholder: '設備 IMIE（空＝テナント集計）',
    days7: '直近7日',
    days30: '直近30日',
    days90: '直近90日',
    avgPrecision: '平均精度',
    onTargetRate: '达标率',
    dispenseCount: '排出回数',
    precisionTrend: '精度トレンド（日次）',
    recentDispenses: '最近の排出',
    noTrend: 'トレンドなし（バックエンド合流後に表示）',
    noRows: '明細なし',
    colTime: '時刻',
    colMaterial: '素材',
    colRecipe: 'レシピ',
    colActual: '実排出',
    colPrecision: '精度',
    colDelta: '差分',
    totalRecipe: 'レシピ合計',
    totalActual: '実排出合計',
    totalDelta: 'ロス差分',
    lossRate: 'ロス率',
    lossByMaterial: '素材別ロス',
    loadFailedFriendly: '精度／ロス API が未提供または不通です。空状態で表示します。',
    multiMachineReuseTitle: 'ディスペンサー多機連携',
    multiMachineReuseBody: '既存の多機連携作業台へディープリンクします。',
    openEarlyBrew: '多機連携作業台を開く',
    openInNewTab: '新しいタブで開く'
  },
  leoAiBill: {
    pageDesc: 'USD 上限はクラウド修繕のみ停止。デスクトップ会話は Cursor Spending を見てください。',
    startPipeline: '標準パイプライン開始',
    usdCapLine: '月次 USD 上限（クラウド修繕のみ）',
    usdExhausted: 'USD 上限到達',
    gateScope: '新しいクラウド修繕のみ停止。デスクトップ Cursor 会話は止めない',
    roundsCap: '月次ラウンド上限',
    usdCap: '月次 USD 上限',
    saveCaps: '上限を保存',
    savedCaps: 'ラウンドと USD 上限を保存しました',
    tableTitle: '総請求（USD＋Token）',
    colSubject: '科目',
    colUsd: 'USD',
    colTokens: 'Token',
    colGated: 'ゲート',
    colHint: '説明',
    colAgent: 'Agent',
    gatedYes: 'クラウド修繕を止める',
    gatedNo: '表示のみ',
    na: '—',
    tokenNotSecondMoney: 'Token は同一クラウド Agent の使用量であり、二度目の課金ではありません。行を開くと明細。',
    detailTitle: 'クラウド修繕明細',
    desktopHint: 'デスクトップ作業は Cursor 公式 Spending を見てください',
    guideStarted: 'パイプラインを開始しました',
    guideStartFail: 'パイプライン開始に失敗'
  },
  x600hAftersales: {
    title: 'X600H アフター',
    desc: '交換／返品／FAQ の進捗を表示。ノードはクリック可・状態が見えます。公開規約は購入ページ。',
    openTerms: '保証・返品ポリシー',
    startLine: 'ラインを開始',
    startHint: 'Leo で話しても同じ playbook です。',
    startReplace: '先に交換を開始',
    startReturn: '30日返品を開始',
    startFaq: '保証／返品 FAQ',
    myProcess: '自分のプロセス',
    refresh: '更新',
    noActive: '進行中のアフターはありません。上で開始するか Leo で話してください。',
    pleaseDo: '実施：',
    followPipeline: '順番に進めてください',
    coachDefault: '青枠＝現在の手順。ノードで状態を確認。',
    openAssist: 'アシスタントを開く',
    iDidCheck: '完了した · 再確認',
    statusDone: '完了',
    statusCurrent: '進行中',
    statusTodo: '未着手'
  }
}


// WEBPACK FOOTER //
// ./src/lang/ja.js